import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  Interval: `${`[${number | number}` | `(${number | number}` | '('},${`${number | number}]` | `${number | number})` | ')'}`;
  JSON: any;
  UserID: string;
};

export type AcknowledgementItem = {
  completedAt?: Maybe<Scalars['Date']>;
  completedByUser?: Maybe<User>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  message: Scalars['String'];
  policyDocument?: Maybe<PolicyDocument>;
  roadmapStep: RoadmapStep;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
  vendorOrganization?: Maybe<VendorOrganization>;
};


export type AcknowledgementItemRoadmapStepArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum AcknowledgementItemStatus {
  Completed = 'Completed',
  Deleted = 'Deleted',
  Pending = 'Pending'
}

export type ActionItem = {
  data?: Maybe<ActionItemMetaData>;
  message: Scalars['String'];
  title: Scalars['String'];
  type?: Maybe<ActionItemType>;
};

export type ActionItemMetaData = {
  executiveReport?: Maybe<ExecutiveReport>;
  policyDocument?: Maybe<PolicyDocument>;
  riskAssessment?: Maybe<RiskAssessmentDocument>;
  templateType?: Maybe<PolicyDocumentTemplateType>;
  vendor?: Maybe<Vendor>;
  vendorOrganization?: Maybe<VendorOrganization>;
  vendorRequest?: Maybe<VendorRequest>;
};

export enum ActionItemType {
  ConductPenTest = 'ConductPenTest',
  ConductRiskAssessment = 'ConductRiskAssessment',
  ConductVulnerabilityScan = 'ConductVulnerabilityScan',
  CreateExecutiveReport = 'CreateExecutiveReport',
  HighNumberOfBouncedEmails = 'HighNumberOfBouncedEmails',
  HighPhishPronePercentage = 'HighPhishPronePercentage',
  InfectedDevices = 'InfectedDevices',
  ManageVendorRisks = 'ManageVendorRisks',
  NoPendingTasks = 'NoPendingTasks',
  PendingTasksDue = 'PendingTasksDue',
  PolicyNeedsReview = 'PolicyNeedsReview',
  PolicyNotCreated = 'PolicyNotCreated',
  ResponsePlanNeedsReview = 'ResponsePlanNeedsReview',
  ResponsePlanNotCreated = 'ResponsePlanNotCreated',
  UnresolvedSecurityEvents = 'UnresolvedSecurityEvents',
  UnsupportedOperatingSystems = 'UnsupportedOperatingSystems',
  VendorRequestDenied = 'VendorRequestDenied',
  VendorResponseExpired = 'VendorResponseExpired',
  VendorResponseExpiring = 'VendorResponseExpiring',
  VendorResponseReviewable = 'VendorResponseReviewable',
  PendingTasksNoDate = 'pendingTasksNoDate'
}

export enum ActionTag {
  AddUserToOrganization = 'AddUserToOrganization',
  ArchiveDocument = 'ArchiveDocument',
  ChangeTaskAssignee = 'ChangeTaskAssignee',
  CompleteAcknowledgementItem = 'CompleteAcknowledgementItem',
  CompleteTask = 'CompleteTask',
  CreateDealership = 'CreateDealership',
  CreateDocument = 'CreateDocument',
  CreateDraftEditPolicyDocument = 'CreateDraftEditPolicyDocument',
  CreateDraftExecutiveReport = 'CreateDraftExecutiveReport',
  CreateDraftPolicyDocument = 'CreateDraftPolicyDocument',
  CreateDraftRiskAssessmentDocument = 'CreateDraftRiskAssessmentDocument',
  CreateExecutiveReport = 'CreateExecutiveReport',
  CreatePolicyDocument = 'CreatePolicyDocument',
  CreateRiskAssessmentDocument = 'CreateRiskAssessmentDocument',
  CreateTask = 'CreateTask',
  CreateTaskComment = 'CreateTaskComment',
  CreateVendorRequest = 'CreateVendorRequest',
  DeleteExecutiveReport = 'DeleteExecutiveReport',
  DeleteTaskComment = 'DeleteTaskComment',
  DeleteVendorOrganization = 'DeleteVendorOrganization',
  EditPolicyDocument = 'EditPolicyDocument',
  GenerateDeviceManagementReport = 'GenerateDeviceManagementReport',
  GeneratePhishingSimulationReport = 'GeneratePhishingSimulationReport',
  GenerateRiskAssessmentReport = 'GenerateRiskAssessmentReport',
  GenerateSecurityResponseReport = 'GenerateSecurityResponseReport',
  GenerateSecurityTrainingReport = 'GenerateSecurityTrainingReport',
  Login = 'Login',
  MarkAllRiskTasksComplete = 'MarkAllRiskTasksComplete',
  RemoveDocument = 'RemoveDocument',
  RemoveMember = 'RemoveMember',
  RemovePolicyDocument = 'RemovePolicyDocument',
  RemoveRiskAssessmentDocument = 'RemoveRiskAssessmentDocument',
  RemoveTask = 'RemoveTask',
  RestoreDocumentFromArchive = 'RestoreDocumentFromArchive',
  ReviewVendorRequest = 'ReviewVendorRequest',
  RevokeTaskCompletion = 'RevokeTaskCompletion',
  RevokeVendorRequestReview = 'RevokeVendorRequestReview',
  SendVendorRequestReminder = 'SendVendorRequestReminder',
  UnassignTask = 'UnassignTask',
  UpdateDealership = 'UpdateDealership',
  UpdateDealershipKeyPersonnel = 'UpdateDealershipKeyPersonnel',
  UpdateDealershipNotificationSettings = 'UpdateDealershipNotificationSettings',
  UpdateDocumentDescription = 'UpdateDocumentDescription',
  UpdateDocumentTitle = 'UpdateDocumentTitle',
  UpdateSelf = 'UpdateSelf',
  UpdateTaskDescription = 'UpdateTaskDescription',
  UpdateTaskDueDate = 'UpdateTaskDueDate',
  UpdateTaskTitle = 'UpdateTaskTitle',
  UpdateVendorOrganization = 'UpdateVendorOrganization'
}

export type AddUserInput = {
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  /** Whether the invited user should become an owner of the organization. Default is false. */
  owner?: InputMaybe<Scalars['Boolean']>;
};

/** Affiliate groups are objects which represent a way for multiple organizations to be associated under an umbrella group. */
export type AffiliateGroup = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  /** Unique internal database identifier for a single AffiliateGroup. */
  id: Scalars['ID'];
  /** User provided name used to identify the AffiliateGroup. Max 255 characters. Does not need to be unique. */
  name: Scalars['String'];
  /** Organizations that are associated with the affiliate group through AffiliateOrganization */
  organizations?: Maybe<Array<Maybe<Organization>>>;
  updatedAt: Scalars['Date'];
};

/** Paginated Return type for the AffiliateGroup type */
export type AffiliateGroupConnection = {
  nodes?: Maybe<Array<Maybe<AffiliateGroup>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

/** AffiliateGroups Filters supported */
export type AffiliateGroupFilters = {
  /** IDs of the affiliate_group record(s) to query from the database */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Name of the affiliate_group record(s) to query from the database. Searches by a substring anywhere within the name attribute based on the input name string. */
  name?: InputMaybe<Scalars['String']>;
};

/** Supported fields to on Affiliate Group queries */
export enum AffiliateGroupSortField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type AffiliateOrganization = {
  affiliateGroup: AffiliateGroup;
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  organization: Organization;
  updatedAt: Scalars['Date'];
};

export type AffiliateOrganizationConnection = {
  nodes?: Maybe<Array<Maybe<AffiliateOrganization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum AffiliateOrganizationSortField {
  AffiliateGroupName = 'affiliateGroupName',
  CreatedAt = 'createdAt',
  Id = 'id',
  OrgCif = 'orgCif',
  OrgName = 'orgName'
}

export type AffiliateOrganizationsFilters = {
  /** Name of an associated Affiliate Group is the only filter that is supported by the back-end. */
  affiliateGroupFilters?: InputMaybe<AffiliateGroupFilters>;
  /** Organization CIF and Name are the only filters that are currently supported by the back-end. */
  organizationFilters?: InputMaybe<OrganizationFilters>;
};

export type Answer = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type AnswerInput = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type ApiResponse = {
  apiType: ApiType;
  createdAt?: Maybe<Scalars['Date']>;
  dailyRequestLimitHitAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lastUpdatedAt?: Maybe<Scalars['Date']>;
  organization: Organization;
  response?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ApiResponseConnection = {
  nodes?: Maybe<Array<Maybe<ApiResponse>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type ApiResponseData = KnowBe4Response | SentinelOneResponse;

export type ApiResponseFilters = {
  apiTypes?: InputMaybe<Array<InputMaybe<ApiType>>>;
  hasHitDailyLimit?: InputMaybe<Scalars['Boolean']>;
};

export enum ApiResponseSortEnum {
  DailyRequestLimitHitAt = 'dailyRequestLimitHitAt',
  LastUpdatedAt = 'lastUpdatedAt',
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName'
}

export type ApiResponses = {
  knowBe4?: Maybe<ApiResponse>;
  sentinelOne?: Maybe<ApiResponse>;
};

export enum ApiType {
  KnowBe4 = 'KnowBe4',
  SentinelOne = 'SentinelOne'
}

export enum AppContextType {
  Admin = 'Admin',
  NoUser = 'NoUser',
  OrganizationShadow = 'OrganizationShadow',
  User = 'User',
  UserShadow = 'UserShadow'
}

export enum AutomationReminderCadence {
  Annual = 'Annual',
  None = 'None',
  Quarterly = 'Quarterly',
  Semi = 'Semi'
}

export type CheckRiskRegistryAnswerInput = {
  organizationId: Scalars['ID'];
  type: QuestionType;
};

export type CheckRiskRegistryAnswerOutput = {
  answers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  hasNoAnswers: Scalars['Boolean'];
  isSilenced: Scalars['Boolean'];
  organizationId: Scalars['ID'];
};

export enum CognitoScope {
  AdminRead = 'adminRead',
  AdminWrite = 'adminWrite',
  Fallback = 'fallback'
}

export type ConsumerFinancialData = {
  creditData: Scalars['Boolean'];
  employeeHistory: Scalars['Boolean'];
  financialAccountNumbers: Scalars['Boolean'];
  income: Scalars['Boolean'];
  paymentData: Scalars['Boolean'];
};

export type ConsumerFinancialDataInput = {
  creditData: Scalars['Boolean'];
  employeeHistory: Scalars['Boolean'];
  financialAccountNumbers: Scalars['Boolean'];
  income: Scalars['Boolean'];
  paymentData: Scalars['Boolean'];
};

export type ConsumerIdentityData = {
  emailAddress: Scalars['Boolean'];
  homeAddress: Scalars['Boolean'];
  name: Scalars['Boolean'];
  phone: Scalars['Boolean'];
};

export type ConsumerIdentityDataInput = {
  emailAddress: Scalars['Boolean'];
  homeAddress: Scalars['Boolean'];
  name: Scalars['Boolean'];
  phone: Scalars['Boolean'];
};

export type CreateAllRegisteredRisksInput = {
  organizationId: Scalars['ID'];
};

export type CreateCustomNotificationDraftInput = {
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  organizationIds: Array<Scalars['ID']>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type CreateDocumentByGuidInput = {
  expiresAt: Scalars['Date'];
  fileExtension: DocumentFileExtension;
  s3ObjectKey: Scalars['String'];
  title: Scalars['String'];
};

export type CreateDocumentInput = {
  category: DocumentCategory;
  conductedAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  documentUrl: Scalars['String'];
  expiresAt: Scalars['Date'];
  organizationIds: Array<Scalars['ID']>;
  title: Scalars['String'];
  vendorParams?: InputMaybe<VendorRiskDocumentInput>;
};

export type CreateEditedPolicyDocumentInput = {
  colorHex?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  footer?: InputMaybe<Scalars['String']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  sections?: InputMaybe<Array<SectionInput>>;
  sourcePolicyDocumentId: Scalars['ID'];
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateExecutiveReportInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  sections: Array<InputMaybe<ExecutiveReportSectionInput>>;
  title: Scalars['String'];
};

export type CreateNavigationEventInput = {
  fromPathname?: InputMaybe<Scalars['String']>;
  toPathname: Scalars['String'];
};

export type CreateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreatePolicyDocumentInput = {
  colorHex?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  draftId?: InputMaybe<Scalars['ID']>;
  footer?: InputMaybe<Scalars['String']>;
  iconImageUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  sections: Array<SectionInput>;
  subtitle?: InputMaybe<Scalars['String']>;
  templateTitle: Scalars['String'];
  templateType: PolicyDocumentTemplateType;
  title: Scalars['String'];
};

export type CreateRegisteredRiskInput = {
  description: Scalars['String'];
  functionCategory: Scalars['String'];
  organizationId: Scalars['ID'];
  rating: Scalars['String'];
  title: Scalars['String'];
};

export type CreateRiskAssessmentInput = {
  draftId?: InputMaybe<Scalars['ID']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
  sections: RiskAssessmentSectionsInput;
};

export type CreateRiskCommentInput = {
  registeredRiskId: Scalars['ID'];
  text: Scalars['String'];
};

export type CreateTaskCommentInput = {
  taskId: Scalars['ID'];
  text: Scalars['String'];
};

export type CreateVendorRequestInput = {
  businessAddress?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
  sharedData?: InputMaybe<SharedDataInput>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type CreateVendorRiskByGuidInput = {
  data?: InputMaybe<VendorRiskResponseDataInput>;
};

export type CustomNotification = {
  createdAt: Scalars['Date'];
  createdBy: User;
  dealerships: Array<Organization>;
  emailBody?: Maybe<Scalars['String']>;
  emailSubject?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  recipients: CustomNotificationRecipientConnection;
  sentAt?: Maybe<Scalars['Date']>;
  sentBy?: Maybe<User>;
  status: CustomNotificationStatus;
  updatedAt: Scalars['Date'];
  vendor?: Maybe<Vendor>;
};


export type CustomNotificationRecipientsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
};

export type CustomNotificationConnection = {
  nodes?: Maybe<Array<Maybe<CustomNotification>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CustomNotificationRecipient = {
  createdAt: Scalars['Date'];
  customNotification: CustomNotification;
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  organization: Organization;
  user?: Maybe<User>;
};

export type CustomNotificationRecipientConnection = {
  nodes?: Maybe<Array<Maybe<CustomNotificationRecipient>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum CustomNotificationStatus {
  Draft = 'Draft',
  Sent = 'Sent'
}

export type DateFilter = {
  from: Scalars['Date'];
  to: Scalars['Date'];
};

export type DateRange = {
  max?: InputMaybe<Scalars['Date']>;
  min?: InputMaybe<Scalars['Date']>;
};

export type DealershipRequestMeta = {
  shareAll?: Maybe<Scalars['Boolean']>;
  shareList?: Maybe<Array<Maybe<Scalars['ID']>>>;
  shareOne?: Maybe<Scalars['Boolean']>;
};

export type DealershipRequestMetaInput = {
  shareAll?: InputMaybe<Scalars['Boolean']>;
  shareList?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  shareOne?: InputMaybe<Scalars['Boolean']>;
};

export type Document = {
  archivedAt?: Maybe<Scalars['Date']>;
  category: DocumentCategory;
  conductedAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  documentUrl?: Maybe<Scalars['String']>;
  expiresAt: Scalars['Date'];
  fileExtension?: Maybe<DocumentFileExtension>;
  id: Scalars['ID'];
  organizations?: Maybe<Array<Maybe<Organization>>>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  uploadedByUser?: Maybe<User>;
};


export type DocumentOrganizationsArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum DocumentCategory {
  Other = 'OTHER',
  PenetrationTest = 'PENETRATION_TEST',
  PolicyDocument = 'POLICY_DOCUMENT',
  RiskAssessment = 'RISK_ASSESSMENT',
  RiskReport = 'RISK_REPORT',
  VendorRisk = 'VENDOR_RISK',
  VulnerabilityScan = 'VULNERABILITY_SCAN'
}

export type DocumentConnection = {
  nodes?: Maybe<Array<Maybe<Document>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum DocumentFieldSortFieldEnum {
  ConductedAt = 'conductedAt',
  CreatedAt = 'createdAt',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  Title = 'title'
}

export enum DocumentFileExtension {
  Csv = 'csv',
  Doc = 'doc',
  Docx = 'docx',
  Pdf = 'pdf'
}

export type DocumentFilters = {
  categories?: InputMaybe<Array<InputMaybe<DocumentCategory>>>;
  conductedAt?: InputMaybe<Scalars['Date']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  description?: InputMaybe<Scalars['String']>;
  documentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type DocumentOrganization = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  document?: Maybe<Document>;
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type DocumentOrganizationConnection = {
  nodes?: Maybe<Array<Maybe<DocumentOrganization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum DocumentOrganizationSortFieldEnum {
  Cif = 'cif',
  Id = 'id',
  Name = 'name'
}

export type DocumentUser = {
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  document: Document;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['Date']>;
  uploadedByUser?: Maybe<User>;
};

export type Endpoint = {
  deviceType: SentinelOneDeviceType;
  infected: Scalars['Boolean'];
  ipAddress: Scalars['String'];
  name: Scalars['String'];
  osStatus: OsSupportStatus;
  osVersion: Scalars['String'];
  siteId?: Maybe<Scalars['String']>;
};

export type EnrolledUser = {
  email: Scalars['String'];
  enrolledAt: Scalars['Date'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  status: EnrolledUserStatus;
};

/**
 * Enrolled User status as defined by the KnowBe4 API documentation with spaces
 * in the values replaced with underscores and converted to uppercase.
 * COMPLIANCE_FALLBACK is used in the event of a KnowBe4 schema change.
 */
export enum EnrolledUserStatus {
  Completed = 'COMPLETED',
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED',
  Passed = 'PASSED',
  PastDue = 'PAST_DUE'
}

export enum EnvironmentName {
  Production = 'production',
  Qa = 'qa',
  Staging = 'staging'
}

export type ExecutiveReport = {
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  createdByUser?: Maybe<User>;
  expiredAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  organization: Organization;
  pdfUrl?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<ExecutiveReportSection>>>;
  sourceExecutiveReportId?: Maybe<Scalars['ID']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
};


export type ExecutiveReportOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type ExecutiveReportConnection = {
  nodes?: Maybe<Array<Maybe<ExecutiveReport>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum ExecutiveReportFieldSortField {
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName'
}

export type ExecutiveReportFilters = {
  isDraft?: InputMaybe<Scalars['Boolean']>;
  isExpired?: InputMaybe<Scalars['Boolean']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ExecutiveReportMetricsSectionTemplate = {
  helperHtml?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  metricsSections?: Maybe<Array<Maybe<MetricsSection>>>;
  templateHtml?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ExecutiveReportSection = {
  createdAt?: Maybe<Scalars['Date']>;
  data?: Maybe<Scalars['JSON']>;
  executiveReport?: Maybe<ExecutiveReport>;
  id: Scalars['ID'];
  isComplete?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type ExecutiveReportSectionInput = {
  data?: InputMaybe<Scalars['JSON']>;
  isComplete: Scalars['Boolean'];
};

export type ExecutiveReportSectionTemplate = {
  helperHtml?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  templateHtml?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ExecutiveReportSections = {
  additionalIssues?: Maybe<ExecutiveReportSectionTemplate>;
  customSections?: Maybe<Array<Maybe<ExecutiveReportSectionTemplate>>>;
  ftcComplianceOverview?: Maybe<ExecutiveReportSectionTemplate>;
  introduction?: Maybe<ExecutiveReportSectionTemplate>;
  keyRiskManagementActivities?: Maybe<ExecutiveReportSectionTemplate>;
  riskAssessmentResults?: Maybe<ExecutiveReportSectionTemplate>;
  securityMetrics?: Maybe<ExecutiveReportMetricsSectionTemplate>;
  vendorOversightStatus?: Maybe<ExecutiveReportSectionTemplate>;
};

export type ExecutiveReportTemplate = {
  sections?: Maybe<ExecutiveReportSections>;
};

export enum FunctionCategory {
  Analysis = 'Analysis',
  AnomaliesAndEvents = 'AnomaliesAndEvents',
  AssetManagement = 'AssetManagement',
  AwarenessAndTraining = 'AwarenessAndTraining',
  BusinessEnvironment = 'BusinessEnvironment',
  DataSecurity = 'DataSecurity',
  DetectionProcess = 'DetectionProcess',
  Governance = 'Governance',
  IdentityManagement = 'IdentityManagement',
  InformationProtection = 'InformationProtection',
  Maintenance = 'Maintenance',
  Mitigation = 'Mitigation',
  ProtectiveTechnology = 'ProtectiveTechnology',
  RecoveryCommunications = 'RecoveryCommunications',
  RecoveryImprovements = 'RecoveryImprovements',
  RecoveryPlanning = 'RecoveryPlanning',
  ResponseCommunications = 'ResponseCommunications',
  ResponseImprovements = 'ResponseImprovements',
  ResponsePlanning = 'ResponsePlanning',
  RiskAssessment = 'RiskAssessment',
  RiskManagementStrategy = 'RiskManagementStrategy',
  SecurityContinuousMonitoring = 'SecurityContinuousMonitoring',
  SupplyChainRiskManagement = 'SupplyChainRiskManagement'
}

export type GetCompletedSectionMapOutput = {
  AccessManagement: Scalars['Boolean'];
  BusinessAndCompliance: Scalars['Boolean'];
  DeviceManagement: Scalars['Boolean'];
  EmailSecurity: Scalars['Boolean'];
  EndpointSecurity: Scalars['Boolean'];
  NetworkManagement: Scalars['Boolean'];
};

export type KeyPersonnel = {
  name: Scalars['String'];
  title: Scalars['String'];
};

export type KeyPersonnelInput = {
  name: Scalars['String'];
  title: Scalars['String'];
};

export type KnowBe4Response = {
  phishing: Array<Maybe<PhishingCampaign>>;
  training: Array<Maybe<TrainingCampaign>>;
  users: Array<Maybe<KnowBe4User>>;
};

export type KnowBe4User = {
  archivedAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  joinedAt: Scalars['Date'];
  lastName: Scalars['String'];
};

export type LastVendorRequest = {
  request?: Maybe<VendorOrganization>;
  vendorId: Scalars['ID'];
};

export type Location = {
  address?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export type LocationInput = {
  address?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  state: Scalars['String'];
  zip: Scalars['String'];
};

export enum MailingRecipientSortField {
  CreatedAt = 'createdAt',
  Id = 'id'
}

export type Metric = {
  code: Scalars['String'];
  format?: Maybe<MetricFormat>;
  ratings: Array<Maybe<MetricRatingScale>>;
  title: Scalars['String'];
};

export enum MetricFormat {
  Number = 'Number',
  Percent = 'Percent'
}

export enum MetricRating {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type MetricRatingScale = {
  range: Scalars['Interval'];
  rating: MetricRating;
};

export type MetricsSection = {
  code: Scalars['String'];
  metrics?: Maybe<Array<Maybe<Metric>>>;
  title: Scalars['String'];
};

export type Mutation = {
  _?: Maybe<Scalars['Boolean']>;
  /** Adds a user to a given organization */
  addUserToOrganization?: Maybe<User>;
  /** Assign a task to a user with id assigneeId */
  assignTask: Task;
  /** Creates the risks based on the action items from the roadmap when a user logs in. */
  createActionItemRisks?: Maybe<Organization>;
  /** Creates all registered risks based on the answers of an organization when this mutation is called. */
  createAllRegisteredRisks: Array<Maybe<RegisteredRisk>>;
  /** Creates a document */
  createDocument?: Maybe<Document>;
  /** Creates a document using a GUID for verification */
  createDocumentByGuid?: Maybe<Document>;
  /** Creates an edited policy document */
  createEditedPolicyDocument?: Maybe<PolicyDocument>;
  /** Create an executive report for the given organization */
  createExecutiveReport?: Maybe<ExecutiveReport>;
  /** Creates a navigation event given the from and to pathname for the given navigation event */
  createNavigationEvent?: Maybe<NavigationEvent>;
  /** Creates an organization with the current user as the owner */
  createOrganization?: Maybe<Organization>;
  /** Creates a policy document */
  createPolicyDocument?: Maybe<PolicyDocument>;
  /** Create a new risk registry record with the information sent. */
  createRegisteredRisk: RegisteredRisk;
  /** Create a new risk with the information sent. */
  createRisk?: Maybe<Risk>;
  /** Creates a risk assessment document */
  createRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** Create a new risk comment with the information sent. */
  createRiskComment: RiskComment;
  createRiskRegistryAnswers: Array<Maybe<RiskRegistryAnswer>>;
  /** Create a new task */
  createTask: Task;
  /** Add a new comment to a given task */
  createTaskComment?: Maybe<TaskComment>;
  /** Creates a vendorRequest */
  createVendorRequest?: Maybe<VendorRequest>;
  /** Create a new vendor risk with the information sent. Verification is provided via guid. */
  createVendorRiskByGuid?: Maybe<VendorRisk>;
  /** Delete a registeredRisk */
  deleteRegisteredRisk: RegisteredRisk;
  /** Deletes a risk comment record. */
  deleteRiskComment: RiskComment;
  /** Remove a comment from a given task */
  deleteTaskComment?: Maybe<TaskComment>;
  /** Deletes a vendor organization and places it in the deleted status. */
  deleteVendorOrganization?: Maybe<VendorOrganization>;
  /** Edits an existing policy document */
  editPolicyDocument?: Maybe<PolicyDocument>;
  /** Remove an uploaded document given its ID. */
  removeDocument?: Maybe<Document>;
  /** Deletes an executive report for the given organization */
  removeExecutiveReport?: Maybe<ExecutiveReport>;
  /** Removes the connection between the user with *userId* from the organization with *organizationId* */
  removeMember?: Maybe<UserOrganization>;
  /** Deletes a policy documents */
  removePolicyDocument?: Maybe<PolicyDocument>;
  /** Deletes a risk assessment document */
  removeRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  removeRiskRegistryAnswers: Array<Maybe<RiskRegistryAnswer>>;
  /** Delete a task, associated to a risk. */
  removeTask?: Maybe<Task>;
  /** Send vendor request reminder email */
  sendVendorRequestReminderEmail?: Maybe<VendorRequest>;
  /** Set an acknowledgement item pending or complete given the acknowledgement item id and new status. */
  setAcknowledgementItemStatus?: Maybe<AcknowledgementItem>;
  /** Set the description of a task */
  setDescriptionTask: Task;
  /** Sets the archivedAt of a document. Will overwrite previous archivedAt. */
  setDocumentArchivedAt?: Maybe<Document>;
  /** Sets the description of a document. Will overwrite previous description. */
  setDocumentDescription?: Maybe<Document>;
  /** Sets the title of a document. Will overwrite previous title. */
  setDocumentTitle?: Maybe<Document>;
  /** Set the due date of a task */
  setDueDateTask: Task;
  /** Set the completion status of a task */
  setTaskCompletionStatus: Task;
  /** Set the completion status of all the Risk's tasks */
  setTasksCompletionStatus?: Maybe<Risk>;
  /** Set the title of a task */
  setTitleTask: Task;
  /** Set the status of a vendor request */
  setVendorRequestReviewStatus?: Maybe<VendorRequest>;
  /** System-level mutation to create a new AffiliateOrganization record. Only works with user tokens that include the admin:write scope. */
  systemAddAffiliateOrganization?: Maybe<AffiliateOrganization>;
  /** Adds a user to a given organization. Only works with API tokens with the admin:write scope. */
  systemAddUserToOrganization?: Maybe<User>;
  /** System-level mutation to create a new Affiliate Group. Only works with user tokens that include the admin:write scope. */
  systemCreateAffiliateGroup?: Maybe<AffiliateGroup>;
  /** Create a new custom notification draft. Requires admin:write scope. */
  systemCreateCustomNotificationDraft: CustomNotification;
  /** Creates a document. Only works with admin:write scope */
  systemCreateDocument?: Maybe<Document>;
  /** Creates an Organization with data from global */
  systemCreateOrganization?: Maybe<Organization>;
  /** Creates organization_mailing_recipient records when given a recipient and an organizationId. Requires a jwt with admin:write scope. */
  systemCreateOrganizationMailingRecipient?: Maybe<OrganizationMailingRecipient>;
  /** Create a new risk registry record with the information sent. Only works with API tokens with admin:write scope */
  systemCreateRegisteredRisk: RegisteredRisk;
  /** Create a new risk with the information sent. Only works with API tokens with the admin:write scope */
  systemCreateRisk?: Maybe<Risk>;
  /** Creates a risk assessment document. Only works with admin:write scope */
  systemCreateRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** Create a new task from global. Only works with  with API tokens with the system:write scope */
  systemCreateTask?: Maybe<Task>;
  /** Creates a new vendor in the system. Only works with tokens containing the admin:write scope. */
  systemCreateVendor?: Maybe<Vendor>;
  /** Deactivates the organization by setting arhivedAt date to the organization and associations. Requires a jwt with admin:write scope. */
  systemDeactivateOrganization?: Maybe<Organization>;
  /** Delete a custom notification draft. Requires admin:write scope. */
  systemDeleteCustomNotificationDraft: Scalars['Boolean'];
  /** Deletes the organization with *id* from the system. Requires a jwt with admin:write scope. */
  systemDeleteOrganization?: Maybe<Organization>;
  /** Delete a risk registry record. Only works with API tokens with admin:write scope */
  systemDeleteRegisteredRisk: RegisteredRisk;
  /** Deletes the user with the provided id */
  systemDeleteUser?: Maybe<User>;
  /** Reactivates the organization by setting arhivedAt to null on the organization and associations. Requires a jwt with admin:write scope. */
  systemReactivateOrganization?: Maybe<Organization>;
  /** System-level mutation to remove an Affiliate Group given the ID of the affiliate_groups record. Only works with user tokens that include the admin:write scope. */
  systemRemoveAffiliateGroup?: Maybe<AffiliateGroup>;
  /** System-level mutation to remove a AffiliateOrganization record. Only works with user tokens that include the admin:write scope. */
  systemRemoveAffiliateOrganization?: Maybe<AffiliateOrganization>;
  /** Removes the connection between the user with *userId* from the organization with *organizationId*, works with a jwt with admin:write scope */
  systemRemoveMember?: Maybe<UserOrganization>;
  /** Removes organization_mailing_recipient records when given the ID of the mailingRecipient. Requires a jwt with admin:write scope. */
  systemRemoveOrganizationMailingRecipient?: Maybe<OrganizationMailingRecipient>;
  /** Remove a risk with the global scope. Only works with admin:write scope */
  systemRemoveRisk?: Maybe<Risk>;
  /** Deletes a risk assessment document. Only works with API tokens with the admin:write scope */
  systemRemoveRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** This mutation will be responsible for removing any shadow entity record associated with the called user. Requires a jwt with admin:write scope. */
  systemRemoveShadowEntity?: Maybe<UserShadowEntity>;
  /** Delete a task from global. Only works with  with API tokens with the system:write scope. */
  systemRemoveTask?: Maybe<Task>;
  /** Removes a vendor risk from the system and the associated vendor risk organizations. Only works with tokens containing the admin:write scope */
  systemRemoveVendorRisk?: Maybe<VendorRisk>;
  /** Send a custom notification to all recipients in the selected dealerships. Requires admin:write scope. */
  systemSendCustomNotification: CustomNotification;
  /** Update support status of an OperatingSystem. Only works with tokens containing the adminScopes.adminWrite scope. */
  systemSetOperatingSystemSupportStatus?: Maybe<OperatingSystem>;
  /** Set the sections on a risk assessment document. Only works with API tokens with the admin:write scope */
  systemSetRiskAssessmentAnswers?: Maybe<RiskAssessmentDocument>;
  /** Set document completion status. Only works with API tokens with the admin:write scope */
  systemSetRiskAssessmentDocumentCompletionStatus?: Maybe<RiskAssessmentDocument>;
  /**
   * This mutation will update the user_shadow_entities record associated with
   * the calling user by setting the shadowType to Organization and shadowEntityId
   * to the provided organization ID.
   */
  systemSetShadowOrganization?: Maybe<UserShadowEntity>;
  /** This mutation will update the user_shadow_entities record associated with the calling user by setting the shadowType to User and shadowEntityId to the provided user ID. */
  systemSetShadowUser?: Maybe<UserShadowEntity>;
  /** Set the vendor risk assessment url authenticated as an admin */
  systemSetVendorRiskAssessmentUrl?: Maybe<VendorRisk>;
  /** Set the expiration timestamp for a vendor risk given the ID. Only works with tokens containing the admin:write scope */
  systemSetVendorRiskExpiredAt?: Maybe<VendorRisk>;
  /** System-level mutation to update an Affiliate Group given the ID of the affiliate_groups record and update input. Only works with user tokens that include the admin:write scope. */
  systemUpdateAffiliateGroup?: Maybe<AffiliateGroup>;
  /** Update an existing custom notification draft. Requires admin:write scope. */
  systemUpdateCustomNotificationDraft: CustomNotification;
  /** Updates the document. Only works with admin:write scope */
  systemUpdateDocument?: Maybe<Document>;
  /** Updates the organization knowBe4ApiKey with *organizationId* in the system. Requires a jwt with admin:write scope. */
  systemUpdateKnowBe4ApiKey?: Maybe<Organization>;
  /** Updates an Organization with Org Admin permissions */
  systemUpdateOrganization?: Maybe<Organization>;
  /** Updates the organization by setting the accountType value on the organization. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationAccountType?: Maybe<Organization>;
  /** Updates the organization billingStartedAt with *organizationId* in the system. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationBillingStartedAt?: Maybe<Organization>;
  /** Updates an OrganizationMailingRecipient. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationMailingRecipient?: Maybe<OrganizationMailingRecipient>;
  /** Updates the organization modalsMutedAt with *organizationId* in the system. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationModalsMutedAt?: Maybe<Organization>;
  /** Updates the notification_settings records for the provided organizationId. Requires a jwt with admin:write scope. */
  systemUpdateOrganizationNotificationSettings?: Maybe<Organization>;
  /** Update an existing risk registry record with the information sent. Only works with API tokens with admin:write scope */
  systemUpdateRegisteredRisk: RegisteredRisk;
  /** Update a risk with the information sent. Only works with API tokens with the admin:write scope */
  systemUpdateRisk?: Maybe<Risk>;
  /** Updates a riskTemplate record with given input */
  systemUpdateRiskTemplate: RiskTemplate;
  /** Updates the organization sentinelOneSiteId with *organizationId* in the system. Requires a jwt with admin:write scope. */
  systemUpdateSentinelOneSiteId?: Maybe<Organization>;
  /** Update a new task from global. Only works with with API tokens with the system:write scope */
  systemUpdateTask?: Maybe<Task>;
  /** Updates an User with User Admin permissions */
  systemUpdateUser?: Maybe<User>;
  /** Updates the role of a user-organization by taking in a userOrganizationId and a role to update the role of the user organization. */
  systemUpdateUserOrganizationRole?: Maybe<UserOrganization>;
  /** Updates a user's cognito scopes. Only works with API tokens with the admin:write scope. */
  systemUpdateUserPortalAccessRole?: Maybe<User>;
  /** Updates the vendor businessAddress given an ID and businessAddress. Only works with tokens containing the admin:write scope. */
  systemUpdateVendorAddress?: Maybe<Vendor>;
  /** Updates the vendor defaultContact given an ID and contactEmail. Only works with tokens containing the admin:write scope. */
  systemUpdateVendorDefaultContact?: Maybe<Vendor>;
  /** Updates the vendor name given an ID and name. Only works with tokens containing the admin:write scope. */
  systemUpdateVendorName?: Maybe<Vendor>;
  /** Updates the organization's settings regarding risk automation and reminder cadence. */
  updateAutomationSettings?: Maybe<Organization>;
  /** Updates the keyPersonnel of the organization. */
  updateKeyPersonnel?: Maybe<Organization>;
  updateMe?: Maybe<User>;
  /** Updates the organization with *id* using the passed params */
  updateOrganization?: Maybe<Organization>;
  /** Updates the notification_settings records for the provided organizationId */
  updateOrganizationNotificationSettings?: Maybe<Organization>;
  /** Update an existing risk registry record with the information sent. */
  updateRegisteredRisk: RegisteredRisk;
  /** Set the acceptedAt timestamp of a registeredRisk */
  updateRegisteredRiskAcceptedAt: RegisteredRisk;
  /** Set the resolvedAt timestamp of a registeredRisk */
  updateRegisteredRiskResolvedAt: RegisteredRisk;
  /**
   * Sends a heartbeat to the API with the organization and the time that the heartbeat was sent. Since this is fire-and-forget,
   * we won't check for a return but could with a simple boolean of whether it was recieved or not.
   */
  updateRiskHeartbeatRecords: Scalars['Boolean'];
  updateRiskRegistryAnswers: Array<Maybe<RiskRegistryAnswer>>;
  /** Updates the vendor organization with *id* using the passed params */
  updateVendorOrganization?: Maybe<VendorOrganization>;
  /** Update an existing vendor risk with the information sent. Verification is provided via guid. */
  updateVendorRiskByGuid?: Maybe<VendorRisk>;
};


export type MutationAddUserToOrganizationArgs = {
  userParams: AddUserInput;
};


export type MutationAssignTaskArgs = {
  assigneeId?: InputMaybe<Scalars['UserID']>;
  taskId: Scalars['ID'];
};


export type MutationCreateActionItemRisksArgs = {
  id: Scalars['ID'];
};


export type MutationCreateAllRegisteredRisksArgs = {
  input?: InputMaybe<CreateAllRegisteredRisksInput>;
};


export type MutationCreateDocumentArgs = {
  documentParams?: InputMaybe<CreateDocumentInput>;
};


export type MutationCreateDocumentByGuidArgs = {
  documentParams: CreateDocumentByGuidInput;
  guid: Scalars['String'];
};


export type MutationCreateEditedPolicyDocumentArgs = {
  editPolicyDocumentParams?: InputMaybe<CreateEditedPolicyDocumentInput>;
};


export type MutationCreateExecutiveReportArgs = {
  executiveReportParams?: InputMaybe<CreateExecutiveReportInput>;
};


export type MutationCreateNavigationEventArgs = {
  input?: InputMaybe<CreateNavigationEventInput>;
};


export type MutationCreateOrganizationArgs = {
  input?: InputMaybe<CreateOrganizationInput>;
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationCreatePolicyDocumentArgs = {
  policyDocumentParams?: InputMaybe<CreatePolicyDocumentInput>;
};


export type MutationCreateRegisteredRiskArgs = {
  input?: InputMaybe<CreateRegisteredRiskInput>;
};


export type MutationCreateRiskArgs = {
  input?: InputMaybe<RiskInput>;
};


export type MutationCreateRiskAssessmentDocumentArgs = {
  riskAssessmentParams?: InputMaybe<CreateRiskAssessmentInput>;
};


export type MutationCreateRiskCommentArgs = {
  input?: InputMaybe<CreateRiskCommentInput>;
};


export type MutationCreateRiskRegistryAnswersArgs = {
  answers: Array<InputMaybe<RiskRegistryAnswerInput>>;
  notFromModals?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};


export type MutationCreateTaskArgs = {
  task?: InputMaybe<TaskInput>;
};


export type MutationCreateTaskCommentArgs = {
  taskCommentParams?: InputMaybe<CreateTaskCommentInput>;
};


export type MutationCreateVendorRequestArgs = {
  vendorRequestParams?: InputMaybe<CreateVendorRequestInput>;
};


export type MutationCreateVendorRiskByGuidArgs = {
  guid: Scalars['String'];
  vendorRisk?: InputMaybe<CreateVendorRiskByGuidInput>;
};


export type MutationDeleteRegisteredRiskArgs = {
  registeredRiskId: Scalars['ID'];
};


export type MutationDeleteRiskCommentArgs = {
  riskCommentId: Scalars['ID'];
};


export type MutationDeleteTaskCommentArgs = {
  taskCommentRemovalParams?: InputMaybe<RemoveTaskCommentInput>;
};


export type MutationDeleteVendorOrganizationArgs = {
  vendorOrganizationId: Scalars['ID'];
};


export type MutationEditPolicyDocumentArgs = {
  policyDocumentParams?: InputMaybe<UpdatePolicyDocumentInput>;
};


export type MutationRemoveDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveExecutiveReportArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveMemberArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['UserID'];
};


export type MutationRemovePolicyDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveRiskAssessmentDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveRiskRegistryAnswersArgs = {
  answerIds: Array<InputMaybe<Scalars['ID']>>;
  notFromModals?: InputMaybe<Scalars['Boolean']>;
};


export type MutationRemoveTaskArgs = {
  id: Scalars['ID'];
  riskId: Scalars['ID'];
};


export type MutationSendVendorRequestReminderEmailArgs = {
  vendorRequestId: Scalars['ID'];
};


export type MutationSetAcknowledgementItemStatusArgs = {
  id: Scalars['ID'];
  status?: InputMaybe<AcknowledgementItemStatus>;
};


export type MutationSetDescriptionTaskArgs = {
  description?: InputMaybe<Scalars['String']>;
  taskId: Scalars['ID'];
};


export type MutationSetDocumentArchivedAtArgs = {
  archivedAt?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
};


export type MutationSetDocumentDescriptionArgs = {
  description: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationSetDocumentTitleArgs = {
  id: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationSetDueDateTaskArgs = {
  date?: InputMaybe<Scalars['Date']>;
  taskId: Scalars['ID'];
};


export type MutationSetTaskCompletionStatusArgs = {
  isComplete: Scalars['Boolean'];
  taskId: Scalars['ID'];
};


export type MutationSetTasksCompletionStatusArgs = {
  isComplete: Scalars['Boolean'];
  riskId: Scalars['ID'];
};


export type MutationSetTitleTaskArgs = {
  taskId: Scalars['ID'];
  title: Scalars['String'];
};


export type MutationSetVendorRequestReviewStatusArgs = {
  isReviewed: Scalars['Boolean'];
  vendorRequestId: Scalars['ID'];
};


export type MutationSystemAddAffiliateOrganizationArgs = {
  input?: InputMaybe<SystemAffiliateOrganizationInput>;
};


export type MutationSystemAddUserToOrganizationArgs = {
  userParams: AddUserInput;
};


export type MutationSystemCreateAffiliateGroupArgs = {
  input: SystemAffiliateGroupInput;
};


export type MutationSystemCreateCustomNotificationDraftArgs = {
  input: CreateCustomNotificationDraftInput;
};


export type MutationSystemCreateDocumentArgs = {
  documentParams?: InputMaybe<CreateDocumentInput>;
};


export type MutationSystemCreateOrganizationArgs = {
  organization?: InputMaybe<SystemOrganizationInput>;
};


export type MutationSystemCreateOrganizationMailingRecipientArgs = {
  organizationId: Scalars['ID'];
  recipient: SystemOrganizationMailingRecipient;
};


export type MutationSystemCreateRegisteredRiskArgs = {
  input?: InputMaybe<CreateRegisteredRiskInput>;
};


export type MutationSystemCreateRiskArgs = {
  input?: InputMaybe<RiskInput>;
};


export type MutationSystemCreateRiskAssessmentDocumentArgs = {
  riskAssessmentParams?: InputMaybe<CreateRiskAssessmentInput>;
};


export type MutationSystemCreateTaskArgs = {
  task: TaskInput;
};


export type MutationSystemCreateVendorArgs = {
  vendorParams?: InputMaybe<SystemCreateVendorInput>;
};


export type MutationSystemDeactivateOrganizationArgs = {
  id: Scalars['ID'];
};


export type MutationSystemDeleteCustomNotificationDraftArgs = {
  id: Scalars['ID'];
};


export type MutationSystemDeleteOrganizationArgs = {
  id: Scalars['ID'];
};


export type MutationSystemDeleteRegisteredRiskArgs = {
  registeredRiskId: Scalars['ID'];
};


export type MutationSystemDeleteUserArgs = {
  id: Scalars['UserID'];
};


export type MutationSystemReactivateOrganizationArgs = {
  id: Scalars['ID'];
};


export type MutationSystemRemoveAffiliateGroupArgs = {
  id: Scalars['ID'];
};


export type MutationSystemRemoveAffiliateOrganizationArgs = {
  affiliateOrganizationId: Scalars['ID'];
};


export type MutationSystemRemoveMemberArgs = {
  organizationId: Scalars['ID'];
  userId: Scalars['UserID'];
};


export type MutationSystemRemoveOrganizationMailingRecipientArgs = {
  mailingRecipientId: Scalars['ID'];
};


export type MutationSystemRemoveRiskArgs = {
  id: Scalars['ID'];
};


export type MutationSystemRemoveRiskAssessmentDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationSystemRemoveShadowEntityArgs = {
  userId: Scalars['UserID'];
};


export type MutationSystemRemoveTaskArgs = {
  id: Scalars['ID'];
  riskId: Scalars['ID'];
};


export type MutationSystemRemoveVendorRiskArgs = {
  id: Scalars['ID'];
};


export type MutationSystemSendCustomNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationSystemSetOperatingSystemSupportStatusArgs = {
  id: Scalars['ID'];
  status: OsSupportStatus;
};


export type MutationSystemSetRiskAssessmentAnswersArgs = {
  riskAssessmentDocumentId: Scalars['ID'];
  sections: RiskAssessmentSectionsInput;
};


export type MutationSystemSetRiskAssessmentDocumentCompletionStatusArgs = {
  riskAssessmentDocumentId: Scalars['ID'];
  status: RiskAssessmentStatus;
};


export type MutationSystemSetShadowOrganizationArgs = {
  organizationId: Scalars['ID'];
};


export type MutationSystemSetShadowUserArgs = {
  userId: Scalars['UserID'];
};


export type MutationSystemSetVendorRiskAssessmentUrlArgs = {
  assessmentUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type MutationSystemSetVendorRiskExpiredAtArgs = {
  expiredAt?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
};


export type MutationSystemUpdateAffiliateGroupArgs = {
  id: Scalars['ID'];
  input: UpdateAffiliateGroupInput;
};


export type MutationSystemUpdateCustomNotificationDraftArgs = {
  id: Scalars['ID'];
  input: UpdateCustomNotificationDraftInput;
};


export type MutationSystemUpdateDocumentArgs = {
  input: UpdateSystemDocumentInput;
};


export type MutationSystemUpdateKnowBe4ApiKeyArgs = {
  knowBe4ApiKey?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['ID'];
};


export type MutationSystemUpdateOrganizationArgs = {
  input?: InputMaybe<UpdateSystemOrganizationInput>;
};


export type MutationSystemUpdateOrganizationAccountTypeArgs = {
  accountType: OrganizationAccountType;
  id: Scalars['ID'];
};


export type MutationSystemUpdateOrganizationBillingStartedAtArgs = {
  billingStartedAt?: InputMaybe<Scalars['Date']>;
  organizationId: Scalars['ID'];
};


export type MutationSystemUpdateOrganizationMailingRecipientArgs = {
  input: UpdateSystemOrganizationMailingRecipientInput;
};


export type MutationSystemUpdateOrganizationModalsMutedAtArgs = {
  organizationId: Scalars['ID'];
};


export type MutationSystemUpdateOrganizationNotificationSettingsArgs = {
  organizationId: Scalars['ID'];
  updatedNotificationSettings: NotificationSettingsInput;
};


export type MutationSystemUpdateRegisteredRiskArgs = {
  input?: InputMaybe<UpdateRegisteredRiskInput>;
};


export type MutationSystemUpdateRiskArgs = {
  input?: InputMaybe<UpdateSystemRiskInput>;
};


export type MutationSystemUpdateRiskTemplateArgs = {
  input?: InputMaybe<UpdateRiskTemplateInput>;
};


export type MutationSystemUpdateSentinelOneSiteIdArgs = {
  organizationId: Scalars['ID'];
  sentinelOneSiteId?: InputMaybe<Scalars['String']>;
};


export type MutationSystemUpdateTaskArgs = {
  task: UpdateSystemTaskInput;
};


export type MutationSystemUpdateUserArgs = {
  input?: InputMaybe<UpdateSystemUserInput>;
};


export type MutationSystemUpdateUserOrganizationRoleArgs = {
  role: UserOrganizationRole;
  userOrganizationId: Scalars['ID'];
};


export type MutationSystemUpdateUserPortalAccessRoleArgs = {
  accessRoles?: InputMaybe<Array<InputMaybe<CognitoScope>>>;
  id: Scalars['UserID'];
};


export type MutationSystemUpdateVendorAddressArgs = {
  businessAddress?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};


export type MutationSystemUpdateVendorDefaultContactArgs = {
  contactEmail?: InputMaybe<Scalars['String']>;
  vendorId: Scalars['ID'];
};


export type MutationSystemUpdateVendorNameArgs = {
  businessName: Scalars['String'];
  vendorId: Scalars['ID'];
};


export type MutationUpdateAutomationSettingsArgs = {
  automationSettings: UpdateAutomationSettingsInput;
  id: Scalars['ID'];
};


export type MutationUpdateKeyPersonnelArgs = {
  input: UpdateKeyPersonnelInput;
};


export type MutationUpdateMeArgs = {
  user?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  input?: InputMaybe<UpdateOrganizationInput>;
  organization?: InputMaybe<OrganizationInput>;
};


export type MutationUpdateOrganizationNotificationSettingsArgs = {
  organizationId: Scalars['ID'];
  updatedNotificationSettings: NotificationSettingsInput;
};


export type MutationUpdateRegisteredRiskArgs = {
  input?: InputMaybe<UpdateRegisteredRiskInput>;
};


export type MutationUpdateRegisteredRiskAcceptedAtArgs = {
  date?: InputMaybe<Scalars['Date']>;
  registeredRiskId: Scalars['ID'];
};


export type MutationUpdateRegisteredRiskResolvedAtArgs = {
  date?: InputMaybe<Scalars['Date']>;
  registeredRiskId: Scalars['ID'];
};


export type MutationUpdateRiskHeartbeatRecordsArgs = {
  organizationIds: Array<InputMaybe<Scalars['ID']>>;
  sentAt: Scalars['Date'];
};


export type MutationUpdateRiskRegistryAnswersArgs = {
  answers: Array<InputMaybe<UpdateRiskRegistryAnswerInput>>;
  notFromModals?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};


export type MutationUpdateVendorOrganizationArgs = {
  updateVendorOrganizationParams: UpdateVendorOrganizationInput;
};


export type MutationUpdateVendorRiskByGuidArgs = {
  guid: Scalars['String'];
  vendorRisk?: InputMaybe<UpdateVendorRiskByGuidInput>;
};

export type NdaMeta = {
  acceptedAt?: Maybe<Scalars['Date']>;
};

export type NdaMetaInput = {
  acceptedAt?: InputMaybe<Scalars['Date']>;
};

export type NavigationEvent = {
  contextType: AppContextType;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  fromPathname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  toPathname: Scalars['String'];
  user: User;
};

export type NavigationEventConnection = {
  nodes?: Maybe<Array<Maybe<NavigationEvent>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type NavigationEventFilters = {
  contextTypes?: InputMaybe<Array<InputMaybe<AppContextType>>>;
  createdAt?: InputMaybe<DateRange>;
  fromPathname?: InputMaybe<Scalars['String']>;
  toPathname?: InputMaybe<Scalars['String']>;
};

export enum NavigationEventSortField {
  CreatedAt = 'createdAt',
  Id = 'id'
}

export enum NotificationFrequency {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  Realtime = 'Realtime',
  Weekly = 'Weekly'
}

export type NotificationSetting = {
  createdAt: Scalars['Date'];
  enabled: Scalars['Boolean'];
  frequency: NotificationFrequency;
  id: Scalars['ID'];
  notificationType: NotificationType;
  organization: Organization;
  sendTo: Array<Maybe<SendTo>>;
  updatedAt: Scalars['Date'];
};

export type NotificationSettingInput = {
  enabled: Scalars['Boolean'];
  frequency: NotificationFrequency;
  notificationType: NotificationType;
  sendTo: Array<InputMaybe<SendTo>>;
};

export type NotificationSettings = {
  deviceManagementReport?: Maybe<NotificationSetting>;
  documentUpload?: Maybe<NotificationSetting>;
  pendingActionItemsReport?: Maybe<NotificationSetting>;
  securityResponseReport?: Maybe<NotificationSetting>;
  trainingAndPhishingReport?: Maybe<NotificationSetting>;
};

export type NotificationSettingsInput = {
  deviceManagementReport?: InputMaybe<NotificationSettingInput>;
  documentUpload?: InputMaybe<NotificationSettingInput>;
  pendingActionItemsReport?: InputMaybe<NotificationSettingInput>;
  securityResponseReport?: InputMaybe<NotificationSettingInput>;
  trainingAndPhishingReport?: InputMaybe<NotificationSettingInput>;
};

export enum NotificationType {
  DeviceManagementReport = 'DeviceManagementReport',
  DocumentUpload = 'DocumentUpload',
  PendingActionItemsReport = 'PendingActionItemsReport',
  SecurityResponseReport = 'SecurityResponseReport',
  TrainingAndPhishingReport = 'TrainingAndPhishingReport'
}

export type OperatingSystem = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  revision?: Maybe<Scalars['String']>;
  status: OsSupportStatus;
  updatedAt: Scalars['Date'];
};

export type OperatingSystemConnection = {
  nodes?: Maybe<Array<Maybe<OperatingSystem>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OperatingSystemFilters = {
  name?: InputMaybe<Scalars['String']>;
  statuses?: InputMaybe<Array<InputMaybe<OsSupportStatus>>>;
};

export enum OperatingSystemSortField {
  CreatedAt = 'createdAt',
  Name = 'name'
}

export type Organization = {
  accountType?: Maybe<OrganizationAccountType>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  apiResponses?: Maybe<ApiResponses>;
  archivedAt?: Maybe<Scalars['Date']>;
  billingStartedAt?: Maybe<Scalars['Date']>;
  cif?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  executiveReports?: Maybe<Array<Maybe<ExecutiveReport>>>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  incidentResponsePolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  infoSecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  keyPersonnel?: Maybe<Array<Maybe<KeyPersonnel>>>;
  knowBe4Key?: Maybe<Scalars['String']>;
  legalName?: Maybe<Scalars['String']>;
  mailingRecipients?: Maybe<Array<Maybe<OrganizationMailingRecipient>>>;
  modalsMutedAt?: Maybe<Scalars['Date']>;
  name?: Maybe<Scalars['String']>;
  notificationSettings?: Maybe<NotificationSettings>;
  onboardingUntil?: Maybe<Scalars['Date']>;
  owned?: Maybe<Scalars['Boolean']>;
  paidSubscription?: Maybe<Scalars['Boolean']>;
  penetrationTests?: Maybe<Array<Maybe<Document>>>;
  phone?: Maybe<Scalars['String']>;
  policyDocuments?: Maybe<Array<Maybe<PolicyDocument>>>;
  riskAssessments?: Maybe<Array<Maybe<RiskAssessmentDocument>>>;
  roadmap?: Maybe<RoadmapSteps>;
  sentinelOneSiteId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  technologySecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  updatedAt?: Maybe<Scalars['Date']>;
  useIncidentResponseLastReminded?: Maybe<Scalars['Date']>;
  useIncidentResponsePlanAutomation?: Maybe<Scalars['Boolean']>;
  useIncidentResponsePlanCadence?: Maybe<AutomationReminderCadence>;
  usePolicyCreatorAutomation?: Maybe<Scalars['Boolean']>;
  usePolicyLastReminded?: Maybe<Scalars['Date']>;
  usePolicyReminderCadence?: Maybe<AutomationReminderCadence>;
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  userSecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  vendorOrganizations?: Maybe<Array<Maybe<VendorOrganization>>>;
  vulnerabilityScans?: Maybe<Array<Maybe<Document>>>;
  zip?: Maybe<Scalars['String']>;
};


export type OrganizationExecutiveReportsArgs = {
  executiveReportFilters?: InputMaybe<OrganizationExecutiveReportSubqueryFilters>;
};


export type OrganizationIncidentResponsePoliciesArgs = {
  incidentResponseFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
};


export type OrganizationInfoSecurityPoliciesArgs = {
  infoSecurityFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
};


export type OrganizationPenetrationTestsArgs = {
  penetrationTestFilters?: InputMaybe<OrganizationDocumentSubqueryFilters>;
};


export type OrganizationRiskAssessmentsArgs = {
  riskAssessmentFilters?: InputMaybe<OrganizationRiskAssessmentSubqueryFilters>;
};


export type OrganizationTechnologySecurityPoliciesArgs = {
  technologySecurityFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
};


export type OrganizationUserSecurityPoliciesArgs = {
  userSecurityFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
};


export type OrganizationVulnerabilityScansArgs = {
  vulnerabilityScanFilters?: InputMaybe<OrganizationDocumentSubqueryFilters>;
};

export enum OrganizationAccountType {
  Compliance = 'Compliance',
  Security = 'Security',
  Unassigned = 'Unassigned'
}

export type OrganizationConnection = {
  nodes?: Maybe<Array<Maybe<Organization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrganizationDocumentSubqueryFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DocumentFieldSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type OrganizationExecutiveReportSubqueryFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<ExecutiveReportFieldSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

/** Filters to  apply when using an organizations query. *hasCif* will only be applied when *cif* is falsy. */
export type OrganizationFilters = {
  accountTypes?: InputMaybe<Array<InputMaybe<OrganizationAccountType>>>;
  cif?: InputMaybe<Scalars['String']>;
  hasCif?: InputMaybe<Scalars['Boolean']>;
  hasKnowBe4Key?: InputMaybe<Scalars['Boolean']>;
  hasSentinelOneSiteId?: InputMaybe<Scalars['Boolean']>;
  knowBe4ApiKey?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sentinelOneSiteID?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrganizationStatus>;
  zip?: InputMaybe<Scalars['String']>;
};

export type OrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  useIncidentResponseLastReminded?: InputMaybe<Scalars['Date']>;
  usePolicyLastReminded?: InputMaybe<Scalars['Date']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type OrganizationMailingRecipient = {
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  organization?: Maybe<Organization>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type OrganizationMailingRecipientConnection = {
  nodes?: Maybe<Array<Maybe<OrganizationMailingRecipient>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type OrganizationMailingRecipientFilters = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type OrganizationRiskAssessmentSubqueryFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RiskAssessmentDocumentFieldSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};

export enum OrganizationSortFieldEnum {
  Cif = 'cif',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name'
}

export type OrganizationSorting = {
  sortField: Scalars['String'];
  sortOrder: SortOrder;
};

export enum OrganizationStatus {
  Active = 'active',
  Archived = 'archived'
}

export enum OsSupportStatus {
  SupportRisk = 'SupportRisk',
  Supported = 'Supported',
  Tbd = 'TBD',
  Unsupported = 'Unsupported'
}

export type OtherConsumerData = {
  assets: Scalars['Boolean'];
  education: Scalars['Boolean'];
  familialData: Scalars['Boolean'];
  insuranceData: Scalars['Boolean'];
};

export type OtherConsumerDataInput = {
  assets: Scalars['Boolean'];
  education: Scalars['Boolean'];
  familialData: Scalars['Boolean'];
  insuranceData: Scalars['Boolean'];
};

export type PageInfo = {
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items?. */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items?. */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type PhishingCampaign = {
  createdAt: Scalars['Date'];
  frequency: Scalars['String'];
  name: Scalars['String'];
  pstCount: Scalars['Int'];
  securityTests: Array<Maybe<PhishingSecurityTest>>;
  status: Scalars['String'];
};

export type PhishingSecurityTest = {
  bouncedCount: Scalars['Int'];
  clickedCount: Scalars['Int'];
  deliveredCount: Scalars['Int'];
  duration: Scalars['Int'];
  name: Scalars['String'];
  phishPronePercentage: Scalars['Float'];
  pstId: Scalars['Int'];
  recipients: Array<Maybe<Recipient>>;
  scheduledCount: Scalars['Int'];
  startedAt: Scalars['Date'];
};

export type PolicyDocument = {
  archivedAt?: Maybe<Scalars['Date']>;
  colorHex: Scalars['String'];
  createdAt: Scalars['Date'];
  createdByUser?: Maybe<User>;
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['ID']>;
  expiredAt?: Maybe<Scalars['Date']>;
  footer?: Maybe<Scalars['String']>;
  iconImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  isDraft: Scalars['Boolean'];
  organization: Organization;
  sections?: Maybe<Array<Maybe<Section>>>;
  sourcePolicyDocumentId?: Maybe<Scalars['ID']>;
  subtitle?: Maybe<Scalars['String']>;
  templateTitle?: Maybe<Scalars['String']>;
  templateType?: Maybe<PolicyDocumentTemplateType>;
  title: Scalars['String'];
};


export type PolicyDocumentOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type PolicyDocumentConnection = {
  nodes?: Maybe<Array<Maybe<PolicyDocument>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum PolicyDocumentFieldSortField {
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  Id = 'id'
}

export type PolicyDocumentTemplate = {
  id: Scalars['String'];
  sections?: Maybe<Array<Maybe<SectionTemplate>>>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type?: Maybe<PolicyDocumentTemplateType>;
};

export enum PolicyDocumentTemplateType {
  IncidentResponsePlan = 'IncidentResponsePlan',
  InformationSecurityPolicies = 'InformationSecurityPolicies',
  TechnologySecurityPolicies = 'TechnologySecurityPolicies',
  UserDefined = 'UserDefined',
  UserSecurityPolicies = 'UserSecurityPolicies'
}

export type Query = {
  _?: Maybe<Scalars['Boolean']>;
  /**
   * Given an array of organizationIds, it will only return organizations that have answers that are expired
   * or missing in the first place
   */
  checkRiskRegistryAnswers?: Maybe<Array<Maybe<CheckRiskRegistryAnswerOutput>>>;
  /** Get a document given its ID */
  document?: Maybe<Document>;
  /** Get organization documents */
  documents?: Maybe<DocumentConnection>;
  /** Get an executive report by ID */
  executiveReport?: Maybe<ExecutiveReport>;
  /** Get the lineage of an executive report based on ID */
  executiveReportLineage?: Maybe<Array<Maybe<ExecutiveReport>>>;
  /** Get executive report templates. */
  executiveReportTemplates: Array<Maybe<ExecutiveReportTemplate>>;
  /** Get organization executive reports. */
  executiveReports?: Maybe<ExecutiveReportConnection>;
  getCompletedSectionMap?: Maybe<GetCompletedSectionMapOutput>;
  /** Given a filter by set of questions and an organization ID, returns the answers for that organization if any exist. */
  getFilteredAnswers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  /** Get the record for an organization's heartbeat. */
  getRiskHeartbeatRecord?: Maybe<RiskRegistryQuestionsHeartbeat>;
  /** Retrieves a knowBe4Response from the backend. */
  knowBe4Response?: Maybe<ApiResponse>;
  /** Gets the last vendor organization record for a given organization and each of a set of vendors */
  lastVendorRequests: Array<LastVendorRequest>;
  /** Current authenticated user information and settings */
  me?: Maybe<User>;
  /** Get organization information. */
  organization?: Maybe<Organization>;
  /** Get organizations information. */
  organizations?: Maybe<Array<Maybe<Organization>>>;
  /** Get policy document information. */
  policyDocument?: Maybe<PolicyDocument>;
  /** Get the lineage of a policy document based on ID */
  policyDocumentLineage?: Maybe<Array<Maybe<PolicyDocument>>>;
  /** Get all sections associated with a given policy document */
  policyDocumentSections?: Maybe<Array<Maybe<Section>>>;
  /** Get policyDocumentTemplate by type. */
  policyDocumentTemplate?: Maybe<PolicyDocumentTemplate>;
  /** Get policyDocumentTemplates. */
  policyDocumentTemplates?: Maybe<Array<Maybe<PolicyDocumentTemplate>>>;
  /** Get organization policy documents. */
  policyDocuments?: Maybe<PolicyDocumentConnection>;
  registeredRisk?: Maybe<RegisteredRisk>;
  /** Fetch task by its Id */
  registeredRiskTask: Task;
  /** Given a registeredRisk ID, retrieve all of its tasks */
  registeredRiskTasks: Array<Maybe<Task>>;
  /** Return riskTemplates */
  registeredRiskTemplates?: Maybe<Array<RiskTemplate>>;
  registeredRisks?: Maybe<Array<Maybe<RegisteredRisk>>>;
  /** Get risk assessment document information. */
  riskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** Get organization risk assessment documents. */
  riskAssessmentDocuments?: Maybe<RiskAssessmentDocumentConnection>;
  /** Get riskAssessmentTemplate. */
  riskAssessmentTemplates: Array<Maybe<RiskAssessmentTemplate>>;
  riskComments?: Maybe<Array<Maybe<RiskComment>>>;
  /** Given an answerId, retrieves the riskRegistryAnswer record */
  riskRegistryAnswer?: Maybe<RiskRegistryAnswer>;
  /** Given an organizationId, retrieves all risk registry answers associated with that org if you are a member */
  riskRegistryAnswers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  risks?: Maybe<Array<Maybe<Risk>>>;
  /** Retrieves a roadmap for an organization by organization id. */
  roadmap?: Maybe<Roadmap>;
  /**
   * Retrieves the roadmaps for a a list of organizations by organization id if
   * provided or the roadmap for the current users organizations if not.
   */
  roadmaps?: Maybe<Array<Maybe<Roadmap>>>;
  /** Get all vendors in the system */
  searchVendorRisks?: Maybe<Array<Maybe<VendorRisk>>>;
  /** Get all vendors in the system using businessName. Returns every vendor if no businessName is provided */
  searchVendors?: Maybe<Array<Maybe<Vendor>>>;
  /** Get section information. */
  section?: Maybe<Section>;
  /** Retrieves a sentinelOneResponse from the backend. */
  sentinelOneResponse?: Maybe<ApiResponse>;
  /** System-level query to retrieve an Affiliate Group given the ID of the affiliate_groups record. Only works with user tokens that include the admin:read scope. */
  systemAffiliateGroup?: Maybe<AffiliateGroup>;
  /** System-level query to retrieve all affiliate groups paginated and with filters. Only works with user tokens that include the admin:read scope. */
  systemAffiliateGroups?: Maybe<AffiliateGroupConnection>;
  /** System-level query to retrieve all affiliate organizations paginated and with filters. Only works with users tokens that include the admin:read scope. */
  systemAffiliateOrganizations?: Maybe<AffiliateOrganizationConnection>;
  /** Retrieves a apiResponse from the backend. */
  systemApiResponses?: Maybe<ApiResponseConnection>;
  /** Get a single custom notification by id. Requires admin:read scope. */
  systemCustomNotification?: Maybe<CustomNotification>;
  /** Get all custom notifications (sent and drafts). Requires admin:read scope. */
  systemCustomNotifications: CustomNotificationConnection;
  /** Get a document given its ID. Requires admin:read scope. */
  systemDocument?: Maybe<Document>;
  /** Get documentOrganization information given the documentId */
  systemDocumentOrganizations?: Maybe<DocumentOrganizationConnection>;
  /** Get all documents in the system. Requires admin:read scope. */
  systemDocuments?: Maybe<DocumentConnection>;
  /** Get organization executive reports. only works with jwt admin:read */
  systemExecutiveReports?: Maybe<ExecutiveReportConnection>;
  /** List all the navigation events in the system. Only works with API tokens with the system:read scope. */
  systemNavigationEvents?: Maybe<NavigationEventConnection>;
  /** Get Operating Systems. Only works with the scope adminScopes.adminRead */
  systemOperatingSystems?: Maybe<OperatingSystemConnection>;
  /** Get organization information. Only works with API tokens with the admin:read scope. */
  systemOrganization?: Maybe<Organization>;
  /** Get all custom notifications sent to a specific dealership. Requires admin:read scope. */
  systemOrganizationCustomNotifications: Array<CustomNotification>;
  systemOrganizationMailingRecipients?: Maybe<OrganizationMailingRecipientConnection>;
  /** Get all organizations. Only works with API tokens with the admin:read scope. */
  systemOrganizations?: Maybe<OrganizationConnection>;
  /** Get organization policy documents. Only works with admin:read scope */
  systemPolicyDocuments?: Maybe<PolicyDocumentConnection>;
  systemRegisteredRisks?: Maybe<Array<Maybe<RegisteredRisk>>>;
  systemRisk?: Maybe<Risk>;
  /** Get risk assessment document information. Only works with API tokens with the admin:read scope */
  systemRiskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  /** Get all system risk assessment documents, optionally filtering on organizationId */
  systemRiskAssessmentDocuments?: Maybe<RiskAssessmentDocumentConnection>;
  systemRiskComments?: Maybe<Array<Maybe<RiskComment>>>;
  /** Given an organizationId, retrieves all risk registry answers regardless of if you are member of the organizations */
  systemRiskRegistryAnswers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  systemRiskTemplates?: Maybe<RiskTemplateConnection>;
  systemRisks?: Maybe<RiskConnection>;
  /** Get a task information by id. Only works with  with API tokens with the system:read scope */
  systemTask?: Maybe<Task>;
  /** Get all task comments in the system. Only works with API tokens with the admin:read scope. */
  systemTaskComments?: Maybe<TaskCommentConnection>;
  systemTasks?: Maybe<TaskConnection>;
  /** Get user information. Only works with API tokens with the system:read scope. */
  systemUser?: Maybe<User>;
  systemUserActions?: Maybe<UserActionConnection>;
  /** Get UserOrganization information. Only works with API tokens with the system:read scope. */
  systemUserOrganization?: Maybe<UserOrganization>;
  /** Get UserOrganization information. Only works with API tokens with the system:read scope. */
  systemUserOrganizations?: Maybe<UserOrganizationConnection>;
  /** List all the users in the system. Only works with API tokens with the system:read scope. */
  systemUsers?: Maybe<UserConnection>;
  /** Get vendor in the system based on id. Only works with tokens containing the admin:read scope. */
  systemVendor?: Maybe<Vendor>;
  /** Gets a vendor organization in the system by id. Only works with tokens containing admin:read. */
  systemVendorOrganization?: Maybe<VendorOrganization>;
  /** Gets all of the vendor organizations in the system. Only works with tokens containing admin:read. */
  systemVendorOrganizations?: Maybe<VendorOrganizationConnection>;
  /** Get a vendor request with the provided id. Only works with tokens containing the admin:read scope. */
  systemVendorRequest?: Maybe<VendorRequest>;
  /** Get all vendor requests in the system using pagination. Only works with tokens containing the admin:read scope. */
  systemVendorRequests?: Maybe<VendorRequestConnection>;
  /** Get vendor information provided the id. Only works with the scope admin:read */
  systemVendorRisk?: Maybe<VendorRisk>;
  /** Get all vendors in the system. It only works if the jwt has the scope admin:read */
  systemVendorRisks?: Maybe<VendorRiskConnection>;
  /** Get all vendors in the system using pagination. Only works with tokens containing the admin:read scope. */
  systemVendors?: Maybe<VendorConnection>;
  /** Given a task ID, retrieve all of its comments */
  taskComments: Array<Maybe<TaskComment>>;
  /** Get vendor based on id. */
  vendor?: Maybe<Vendor>;
  /** Gets a vendor organization in the system by id. */
  vendorOrganization?: Maybe<VendorOrganization>;
  /** Gets all of the vendor organizations in the system using pagination. Only returns vendor organizations visible to the token. */
  vendorOrganizations?: Maybe<VendorOrganizationConnection>;
  /** Get a vendor request with the provided id */
  vendorRequest?: Maybe<VendorRequest>;
  /** Get vendor risk information provided the id. */
  vendorRisk?: Maybe<VendorRisk>;
  /** Get vendorRiskTemplates. */
  vendorRiskTemplates: Array<Maybe<VendorRiskTemplate>>;
  /** Get all vendors in the system. */
  vendorRisks?: Maybe<VendorRiskConnection>;
  /** Get all vendors in the system using pagination. */
  vendors?: Maybe<VendorConnection>;
};


export type QueryCheckRiskRegistryAnswersArgs = {
  organizationInputs: Array<InputMaybe<CheckRiskRegistryAnswerInput>>;
};


export type QueryDocumentArgs = {
  documentId: Scalars['ID'];
};


export type QueryDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  documentFilters?: InputMaybe<DocumentFilters>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DocumentFieldSortFieldEnum>;
};


export type QueryExecutiveReportArgs = {
  id: Scalars['ID'];
};


export type QueryExecutiveReportLineageArgs = {
  executiveReportId: Scalars['ID'];
};


export type QueryExecutiveReportsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryGetCompletedSectionMapArgs = {
  isOnboarding?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['ID'];
};


export type QueryGetFilteredAnswersArgs = {
  organizationId: Scalars['ID'];
  questionSet: QuestionSet;
};


export type QueryGetRiskHeartbeatRecordArgs = {
  organizationId: Scalars['ID'];
};


export type QueryKnowBe4ResponseArgs = {
  organizationId: Scalars['ID'];
};


export type QueryLastVendorRequestsArgs = {
  organizationId: Scalars['ID'];
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID'];
};


export type QueryOrganizationsArgs = {
  organizationIds: Array<Scalars['ID']>;
};


export type QueryPolicyDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryPolicyDocumentLineageArgs = {
  policyDocumentId: Scalars['ID'];
};


export type QueryPolicyDocumentSectionsArgs = {
  policyDocumentId: Scalars['ID'];
};


export type QueryPolicyDocumentTemplateArgs = {
  type: PolicyDocumentTemplateType;
};


export type QueryPolicyDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type QueryRegisteredRiskArgs = {
  id: Scalars['ID'];
  organizationId: Scalars['ID'];
};


export type QueryRegisteredRiskTaskArgs = {
  id: Scalars['ID'];
};


export type QueryRegisteredRiskTasksArgs = {
  registeredRiskId: Scalars['ID'];
};


export type QueryRegisteredRisksArgs = {
  filters?: InputMaybe<RegisteredRiskFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RegisteredRiskSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QueryRiskAssessmentDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryRiskAssessmentDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<RiskAssessmentDocumentFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RiskAssessmentDocumentFieldSortFieldEnum>;
};


export type QueryRiskCommentsArgs = {
  registeredRiskId: Scalars['ID'];
};


export type QueryRiskRegistryAnswerArgs = {
  answerId: Scalars['ID'];
};


export type QueryRiskRegistryAnswersArgs = {
  organizationId: Scalars['ID'];
};


export type QueryRisksArgs = {
  riskAssessmentDocumentId: Scalars['ID'];
  riskFilters?: InputMaybe<RiskFilters>;
  taskFilters?: InputMaybe<TaskFilters>;
};


export type QueryRoadmapArgs = {
  organizationId: Scalars['ID'];
};


export type QueryRoadmapsArgs = {
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type QuerySearchVendorRisksArgs = {
  vendorRiskFilters?: InputMaybe<VendorRiskFilters>;
};


export type QuerySearchVendorsArgs = {
  businessName?: InputMaybe<Scalars['String']>;
};


export type QuerySectionArgs = {
  id: Scalars['ID'];
};


export type QuerySentinelOneResponseArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemAffiliateGroupArgs = {
  id: Scalars['ID'];
};


export type QuerySystemAffiliateGroupsArgs = {
  affiliateGroupFilters?: InputMaybe<AffiliateGroupFilters>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<AffiliateGroupSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemAffiliateOrganizationsArgs = {
  filters?: InputMaybe<AffiliateOrganizationsFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<AffiliateOrganizationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemApiResponsesArgs = {
  apiResponseFilters?: InputMaybe<ApiResponseFilters>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<ApiResponseSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemCustomNotificationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemCustomNotificationsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CustomNotificationStatus>;
};


export type QuerySystemDocumentArgs = {
  documentId: Scalars['ID'];
};


export type QuerySystemDocumentOrganizationsArgs = {
  documentFilters?: InputMaybe<DocumentFilters>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DocumentOrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemDocumentsArgs = {
  documentFilters?: InputMaybe<SystemDocumentFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InputMaybe<DocumentFieldSortFieldEnum>>>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemExecutiveReportsArgs = {
  executiveReportFilters?: InputMaybe<ExecutiveReportFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<ExecutiveReportFieldSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemNavigationEventsArgs = {
  filters?: InputMaybe<NavigationEventFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<NavigationEventSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  userFilters?: InputMaybe<UserFilters>;
};


export type QuerySystemOperatingSystemsArgs = {
  operatingSystemFilters?: InputMaybe<OperatingSystemFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<Array<InputMaybe<OperatingSystemSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemOrganizationCustomNotificationsArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemOrganizationMailingRecipientsArgs = {
  mailingRecipientFilters?: InputMaybe<OrganizationMailingRecipientFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<MailingRecipientSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemOrganizationsArgs = {
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<OrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemPolicyDocumentsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InputMaybe<PolicyDocumentFieldSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
  systemPolicyDocumentFilters?: InputMaybe<SystemPolicyDocumentFilters>;
};


export type QuerySystemRegisteredRisksArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemRiskArgs = {
  id: Scalars['ID'];
};


export type QuerySystemRiskAssessmentDocumentArgs = {
  id: Scalars['ID'];
};


export type QuerySystemRiskAssessmentDocumentsArgs = {
  filter?: InputMaybe<RiskAssessmentDocumentFilter>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RiskAssessmentDocumentFieldSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemRiskCommentsArgs = {
  registeredRiskId: Scalars['ID'];
};


export type QuerySystemRiskRegistryAnswersArgs = {
  organizationId: Scalars['ID'];
};


export type QuerySystemRiskTemplatesArgs = {
  filters?: InputMaybe<RiskTemplateFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<RiskTemplateSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemRisksArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  riskFilters?: InputMaybe<SystemRiskFilters>;
  sortFields?: InputMaybe<Array<InputMaybe<RiskSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemTaskArgs = {
  id: Scalars['ID'];
};


export type QuerySystemTaskCommentsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InputMaybe<TaskCommentSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
  taskCommentFilters?: InputMaybe<TaskCommentFilters>;
};


export type QuerySystemTasksArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<Array<InputMaybe<TaskSortField>>>;
  sortOrder?: InputMaybe<SortOrder>;
  taskFilters?: InputMaybe<TaskFilters>;
};


export type QuerySystemUserArgs = {
  id: Scalars['UserID'];
};


export type QuerySystemUserActionsArgs = {
  filters?: InputMaybe<UserActionsFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<UserActionSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySystemUserOrganizationArgs = {
  id: Scalars['ID'];
};


export type QuerySystemUserOrganizationsArgs = {
  organizationFilters?: InputMaybe<OrganizationFilters>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<UserOrganizationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  userFilters?: InputMaybe<UserFilters>;
  userOrganizationFilters?: InputMaybe<UserOrganizationFilters>;
};


export type QuerySystemUsersArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<UserSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  userFilters?: InputMaybe<UserFilters>;
  userOrganizationFilters?: InputMaybe<UserOrganizationFilters>;
};


export type QuerySystemVendorArgs = {
  id: Scalars['ID'];
};


export type QuerySystemVendorOrganizationArgs = {
  vendorOrganizationContactFilters?: InputMaybe<VendorOrganizationContactFilters>;
  vendorOrganizationId: Scalars['ID'];
};


export type QuerySystemVendorOrganizationsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorOrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  systemVendorOrganizationFilters?: InputMaybe<SystemVendorOrganizationFilters>;
  vendorOrganizationContactFilters?: InputMaybe<VendorOrganizationContactFilters>;
};


export type QuerySystemVendorRequestArgs = {
  id: Scalars['ID'];
};


export type QuerySystemVendorRequestsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorRequestSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  vendorRequestFilters?: InputMaybe<VendorRequestFilters>;
};


export type QuerySystemVendorRiskArgs = {
  id: Scalars['ID'];
};


export type QuerySystemVendorRisksArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorRiskFieldSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  vendorFilters?: InputMaybe<VendorFilters>;
  vendorRiskFilters?: InputMaybe<VendorRiskFilters>;
};


export type QuerySystemVendorsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  vendorFilters?: InputMaybe<VendorFilters>;
};


export type QueryTaskCommentsArgs = {
  taskId: Scalars['ID'];
};


export type QueryVendorArgs = {
  id: Scalars['ID'];
};


export type QueryVendorOrganizationArgs = {
  vendorOrganizationContactFilters?: InputMaybe<VendorOrganizationContactFilters>;
  vendorOrganizationId: Scalars['ID'];
};


export type QueryVendorOrganizationsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortFields?: InputMaybe<VendorOrganizationSortFields>;
  vendorOrganizationContactFilters?: InputMaybe<VendorOrganizationContactFilters>;
  vendorOrganizationFilters?: InputMaybe<VendorOrganizationFilters>;
};


export type QueryVendorRequestArgs = {
  id: Scalars['ID'];
};


export type QueryVendorRiskArgs = {
  id: Scalars['ID'];
};


export type QueryVendorRiskTemplatesArgs = {
  guid: Scalars['String'];
};


export type QueryVendorRisksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorRiskFieldSortEnum>;
  vendorFilters?: InputMaybe<VendorFilters>;
  vendorRiskFilters?: InputMaybe<VendorRiskFilters>;
};


export type QueryVendorsArgs = {
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<VendorSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  vendorFilters?: InputMaybe<VendorFilters>;
};

export enum QuestionPrefix {
  AssetInventory = 'AssetInventory',
  ByodPractices = 'BYODPractices',
  CloudBasedIdentityProtection = 'CloudBasedIdentityProtection',
  CorporateEmailDomain = 'CorporateEmailDomain',
  CriticalData = 'CriticalData',
  CriticalSystemList = 'CriticalSystemList',
  DataStorage = 'DataStorage',
  EmailConfigurations = 'EmailConfigurations',
  EmailFilter = 'EmailFilter',
  EndpointProtection = 'EndpointProtection',
  InboxSecurity = 'InboxSecurity',
  IncidentResponsePlan = 'IncidentResponsePlan',
  InfrastructureProjects = 'InfrastructureProjects',
  LocalAdminPermissions = 'LocalAdminPermissions',
  MfaForCloud = 'MFAForCloud',
  MfaForEmail = 'MFAForEmail',
  PasswordManagement = 'PasswordManagement',
  PatchManagement = 'PatchManagement',
  PenTestingAndVulnerabilityScans = 'PenTestingAndVulnerabilityScans',
  PhishingSimulation = 'PhishingSimulation',
  PrimaryIdentityManagement = 'PrimaryIdentityManagement',
  PriorSecurityBreach = 'PriorSecurityBreach',
  QualifiedIndividual = 'QualifiedIndividual',
  RemoteAccess = 'RemoteAccess',
  SecurityAwarenessTraining = 'SecurityAwarenessTraining',
  SecurityPersonnel = 'SecurityPersonnel',
  SystemPatching = 'SystemPatching',
  TechnologySecurityPolicies = 'TechnologySecurityPolicies',
  UnusedUserAccounts = 'UnusedUserAccounts',
  UserSecurityPolicies = 'UserSecurityPolicies',
  VendorEndpointAccess = 'VendorEndpointAccess',
  VendorRisk = 'VendorRisk',
  VulnerabilityTracking = 'VulnerabilityTracking',
  WrittenIsp = 'WrittenISP'
}

export enum QuestionSet {
  AccessManagement = 'AccessManagement',
  BusinessAndCompliance = 'BusinessAndCompliance',
  DeviceManagement = 'DeviceManagement',
  EmailSecurity = 'EmailSecurity',
  EndpointSecurity = 'EndpointSecurity',
  NetworkManagement = 'NetworkManagement'
}

export enum QuestionShorthand {
  AssetInventoryReviewedDate = 'AssetInventory_ReviewedDate',
  AssetInventoryReviewedPastYear = 'AssetInventory_ReviewedPastYear',
  ByodPracticesAllowed = 'BYODPractices_Allowed',
  ByodPracticesCriticalInfo = 'BYODPractices_CriticalInfo',
  CloudBasedIdentityProtectionPresent = 'CloudBasedIdentityProtection_Present',
  CloudBasedIdentityProtectionProvider = 'CloudBasedIdentityProtection_Provider',
  CorporateEmailDomainPresent = 'CorporateEmailDomain_Present',
  CriticalDataDataType = 'CriticalData_DataType',
  CriticalDataStorageLocation = 'CriticalData_StorageLocation',
  CriticalDataStoredOutside = 'CriticalData_StoredOutside',
  CriticalSystemListDocumented = 'CriticalSystemList_Documented',
  DataStorageStorageLocation = 'DataStorage_StorageLocation',
  EmailConfigurationsDkim = 'EmailConfigurations_DKIM',
  EmailConfigurationsDmarc = 'EmailConfigurations_DMARC',
  EmailConfigurationsEnforced = 'EmailConfigurations_Enforced',
  EmailConfigurationsSpf = 'EmailConfigurations_SPF',
  EmailFilterPresent = 'EmailFilter_Present',
  EmailFilterTool = 'EmailFilter_Tool',
  EndpointProtectionIsAllDevices = 'EndpointProtection_IsAllDevices',
  EndpointProtectionLogging = 'EndpointProtection_Logging',
  EndpointProtectionPresent = 'EndpointProtection_Present',
  EndpointProtectionWasAllDevices = 'EndpointProtection_WasAllDevices',
  InboxSecurityInactiveMailboxRemoved = 'InboxSecurity_InactiveMailboxRemoved',
  InboxSecuritySharedMailboxReviewed = 'InboxSecurity_SharedMailboxReviewed',
  IncidentResponsePlanReviewedDate = 'IncidentResponsePlan_ReviewedDate',
  IncidentResponsePlanReviewedPastYear = 'IncidentResponsePlan_ReviewedPastYear',
  InfrastructureProjectsDateOfOccurrence = 'InfrastructureProjects_DateOfOccurrence',
  InfrastructureProjectsPresent = 'InfrastructureProjects_Present',
  LocalAdminPermissionsGranted = 'LocalAdminPermissions_Granted',
  LocalAdminPermissionsMfaRequired = 'LocalAdminPermissions_MFARequired',
  MfaForCloudReviewedDate = 'MFAForCloud_ReviewedDate',
  MfaForCloudReviewedPastYear = 'MFAForCloud_ReviewedPastYear',
  MfaForEmailRequired = 'MFAForEmail_Required',
  PasswordManagementEnforced = 'PasswordManagement_Enforced',
  PasswordManagementManagementTool = 'PasswordManagement_ManagementTool',
  PasswordManagementRequirements = 'PasswordManagement_Requirements',
  PatchManagementPresent = 'PatchManagement_Present',
  PenTestingAndVulnerabilityScansCadence = 'PenTestingAndVulnerabilityScans_Cadence',
  PenTestingAndVulnerabilityScansExternal = 'PenTestingAndVulnerabilityScans_External',
  PhishingSimulationCadence = 'PhishingSimulation_Cadence',
  PhishingSimulationEnrollmentTimeline = 'PhishingSimulation_EnrollmentTimeline',
  PhishingSimulationPresent = 'PhishingSimulation_Present',
  PrimaryIdentityManagementPrimarySolution = 'PrimaryIdentityManagement_PrimarySolution',
  PriorSecurityBreachDateOfBreach = 'PriorSecurityBreach_DateOfBreach',
  PriorSecurityBreachKnownBreach = 'PriorSecurityBreach_KnownBreach',
  QualifiedIndividualAppointed = 'QualifiedIndividual_Appointed',
  RemoteAccessAllow = 'RemoteAccess_Allow',
  RemoteAccessCriticalDevices = 'RemoteAccess_CriticalDevices',
  RemoteAccessMfa = 'RemoteAccess_MFA',
  SecurityAwarenessTrainingCadence = 'SecurityAwarenessTraining_Cadence',
  SecurityAwarenessTrainingEnrollmentTimeline = 'SecurityAwarenessTraining_EnrollmentTimeline',
  SecurityAwarenessTrainingPresent = 'SecurityAwarenessTraining_Present',
  SecurityPersonnelPresent = 'SecurityPersonnel_Present',
  SecurityPersonnelType = 'SecurityPersonnel_Type',
  SystemPatchingPatchedRegularly = 'SystemPatching_PatchedRegularly',
  TechnologySecurityPoliciesPresent = 'TechnologySecurityPolicies_Present',
  TechnologySecurityPoliciesReviewed = 'TechnologySecurityPolicies_Reviewed',
  TechnologySecurityPoliciesReviewedDate = 'TechnologySecurityPolicies_ReviewedDate',
  UnusedUserAccountsReviewedDate = 'UnusedUserAccounts_ReviewedDate',
  UnusedUserAccountsReviewedPastYear = 'UnusedUserAccounts_ReviewedPastYear',
  UserSecurityPoliciesPresent = 'UserSecurityPolicies_Present',
  UserSecurityPoliciesReviewed = 'UserSecurityPolicies_Reviewed',
  UserSecurityPoliciesReviewedDate = 'UserSecurityPolicies_ReviewedDate',
  VendorEndpointAccessAllowed = 'VendorEndpointAccess_Allowed',
  VendorEndpointAccessMfa = 'VendorEndpointAccess_MFA',
  VendorRiskReviewedDate = 'VendorRisk_ReviewedDate',
  VendorRiskReviewedPastYear = 'VendorRisk_ReviewedPastYear',
  VulnerabilityTrackingPresent = 'VulnerabilityTracking_Present',
  WrittenIspReviewedDate = 'WrittenISP_ReviewedDate',
  WrittenIspReviewedPastYear = 'WrittenISP_ReviewedPastYear'
}

export enum QuestionType {
  Both = 'Both',
  Onboarding = 'Onboarding',
  Standard = 'Standard'
}

export type Recipient = {
  bouncedAt?: Maybe<Scalars['Date']>;
  clickedAt?: Maybe<Scalars['Date']>;
  deliveredAt?: Maybe<Scalars['Date']>;
  email: Scalars['String'];
  emailTemplate: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  scheduledAt: Scalars['Date'];
};

export type RegisteredRisk = {
  acceptedAt?: Maybe<Scalars['Date']>;
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  functionCategory: RegisteredRiskFunctionCategory;
  id: Scalars['ID'];
  isMuted?: Maybe<Scalars['Boolean']>;
  organization: Organization;
  rating: RiskRating;
  resolvedAt?: Maybe<Scalars['Date']>;
  riskComments?: Maybe<Array<Maybe<RiskComment>>>;
  riskTemplate?: Maybe<RiskTemplate>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
};

export type RegisteredRiskFilters = {
  accepted?: InputMaybe<Scalars['Boolean']>;
  active?: InputMaybe<Scalars['Boolean']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  functionCategory?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rating?: InputMaybe<Scalars['String']>;
  resolved?: InputMaybe<Scalars['Boolean']>;
};

export enum RegisteredRiskFunctionCategory {
  Access = 'Access',
  Compliance = 'Compliance',
  Device = 'Device',
  Email = 'Email',
  Endpoint = 'Endpoint',
  Network = 'Network'
}

export enum RegisteredRiskSortField {
  CreatedAt = 'createdAt'
}

export type RemoveTaskCommentInput = {
  taskCommentId: Scalars['ID'];
  taskId: Scalars['ID'];
};

export type RestVendorQuestionnaireDocumentData = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type RestVendorQuestionnaireResponseData = {
  documentData?: Maybe<RestVendorQuestionnaireDocumentData>;
  sections?: Maybe<Array<VendorRiskSectionWithAnswer>>;
  stepState: StepState;
  vendorRequests: Array<RestVendorRequestInformation>;
};

export type RestVendorRequestInformation = {
  id: Scalars['ID'];
  organizationName: Scalars['String'];
};

export type Risk = {
  coreFunction: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  functionCategory: FunctionCategory;
  id: Scalars['ID'];
  rating: Scalars['String'];
  riskAssessmentDocument?: Maybe<RiskAssessmentDocument>;
  tasks?: Maybe<Array<Maybe<Task>>>;
  title: Scalars['String'];
  updatedAt: Scalars['Date'];
};


export type RiskRiskAssessmentDocumentArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type RiskTasksArgs = {
  taskFilters?: InputMaybe<TaskFilters>;
};

export type RiskAssessmentDocument = {
  archivedAt?: Maybe<Scalars['Date']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  document?: Maybe<Document>;
  expiredAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isDraft: Scalars['Boolean'];
  organization: Organization;
  risks?: Maybe<Array<Maybe<Risk>>>;
  sections?: Maybe<RiskAssessmentSectionsWithAnswers>;
  status: RiskAssessmentStatus;
  updatedAt: Scalars['Date'];
  user: User;
};


export type RiskAssessmentDocumentOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type RiskAssessmentDocumentConnection = {
  nodes?: Maybe<Array<Maybe<RiskAssessmentDocument>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum RiskAssessmentDocumentFieldSortFieldEnum {
  ArchivedAt = 'archivedAt',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName',
  UpdatedAt = 'updatedAt'
}

export type RiskAssessmentDocumentFilter = {
  isUploaded?: InputMaybe<Scalars['Boolean']>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Array<InputMaybe<RiskAssessmentStatus>>>;
};

export type RiskAssessmentQuestion = {
  code: Scalars['String'];
  coreFunction: Scalars['String'];
  description: Scalars['String'];
  functionCategory: FunctionCategory;
  options: Array<RiskAssessmentResponseOption>;
  title: Scalars['String'];
};

export type RiskAssessmentQuestionInput = {
  answer?: InputMaybe<AnswerInput>;
  code: Scalars['String'];
  coreFunction: Scalars['String'];
  description: Scalars['String'];
  functionCategory: FunctionCategory;
  note?: InputMaybe<Scalars['String']>;
  options: Array<RiskAssessmentResponseOptionInput>;
  title: Scalars['String'];
};

export type RiskAssessmentQuestionWithAnswer = {
  answer?: Maybe<Answer>;
  code: Scalars['String'];
  coreFunction: Scalars['String'];
  description: Scalars['String'];
  functionCategory: FunctionCategory;
  note?: Maybe<Scalars['String']>;
  options: Array<RiskAssessmentResponseOption>;
  title: Scalars['String'];
};

export type RiskAssessmentResponseOption = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type RiskAssessmentResponseOptionInput = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type RiskAssessmentSection = {
  code: Scalars['String'];
  helperHtml?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  questions: Array<RiskAssessmentQuestion>;
  title: Scalars['String'];
};

export type RiskAssessmentSectionInput = {
  code: Scalars['String'];
  id: Scalars['String'];
  questions: Array<RiskAssessmentQuestionInput>;
  title: Scalars['String'];
};

export type RiskAssessmentSectionWithAnswer = {
  code: Scalars['String'];
  id: Scalars['String'];
  questions: Array<RiskAssessmentQuestionWithAnswer>;
  title: Scalars['String'];
};

export type RiskAssessmentSections = {
  AccessControl: RiskAssessmentSection;
  BusinessContinuityAndDisasterRecovery: RiskAssessmentSection;
  DataProtection: RiskAssessmentSection;
  IncidentResponse: RiskAssessmentSection;
  NetworkSecurity: RiskAssessmentSection;
  OrganizationalOversight: RiskAssessmentSection;
  RiskManagementStrategy: RiskAssessmentSection;
  SecurityLoggingAndMonitoring: RiskAssessmentSection;
  SystemDeploymentAndMaintenance: RiskAssessmentSection;
};

export type RiskAssessmentSectionsInput = {
  AccessControl: RiskAssessmentSectionInput;
  BusinessContinuityAndDisasterRecovery: RiskAssessmentSectionInput;
  DataProtection: RiskAssessmentSectionInput;
  IncidentResponse: RiskAssessmentSectionInput;
  NetworkSecurity: RiskAssessmentSectionInput;
  OrganizationalOversight: RiskAssessmentSectionInput;
  RiskManagementStrategy: RiskAssessmentSectionInput;
  SecurityLoggingAndMonitoring: RiskAssessmentSectionInput;
  SystemDeploymentAndMaintenance: RiskAssessmentSectionInput;
};

export type RiskAssessmentSectionsWithAnswers = {
  AccessControl: RiskAssessmentSectionWithAnswer;
  BusinessContinuityAndDisasterRecovery: RiskAssessmentSectionWithAnswer;
  DataProtection: RiskAssessmentSectionWithAnswer;
  IncidentResponse: RiskAssessmentSectionWithAnswer;
  NetworkSecurity: RiskAssessmentSectionWithAnswer;
  OrganizationalOversight: RiskAssessmentSectionWithAnswer;
  RiskManagementStrategy: RiskAssessmentSectionWithAnswer;
  SecurityLoggingAndMonitoring: RiskAssessmentSectionWithAnswer;
  SystemDeploymentAndMaintenance: RiskAssessmentSectionWithAnswer;
};

export enum RiskAssessmentStatus {
  Archived = 'Archived',
  Completed = 'Completed',
  Deleted = 'Deleted',
  Expired = 'Expired',
  Pending = 'Pending',
  PendingReview = 'PendingReview'
}

export type RiskAssessmentTemplate = {
  sections: RiskAssessmentSections;
};

export type RiskComment = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  registeredRisk: RegisteredRisk;
  text: Scalars['String'];
  updatedAt: Scalars['Date'];
  user: User;
};

export type RiskConnection = {
  nodes?: Maybe<Array<Maybe<Risk>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export enum RiskDropdownFilter {
  MostRecent = 'MostRecent',
  PriorityLevel = 'PriorityLevel'
}

export type RiskFilters = {
  coreFunction?: InputMaybe<Scalars['String']>;
  rating?: InputMaybe<Scalars['String']>;
};

export type RiskInput = {
  coreFunction: Scalars['String'];
  functionCategory: FunctionCategory;
  rating: Scalars['String'];
  riskAssessmentDocumentId: Scalars['ID'];
  title: Scalars['String'];
};

export enum RiskRating {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type RiskRegistryAnswer = {
  answer?: Maybe<Scalars['String']>;
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  expiresAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  organization: Organization;
  question: RiskRegistryQuestion;
  updatedAt: Scalars['Date'];
  user: User;
};


export type RiskRegistryAnswerOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type RiskRegistryAnswerUserArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type RiskRegistryAnswerInput = {
  answer: Scalars['String'];
  questionShorthand: Scalars['String'];
};

export type RiskRegistryQuestion = {
  answers?: Maybe<Array<Maybe<RiskRegistryAnswer>>>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  question: Scalars['String'];
  questionShorthand: QuestionShorthand;
  triggerConditions?: Maybe<Array<Maybe<TriggerCondition>>>;
  type?: Maybe<QuestionType>;
  updatedAt: Scalars['Date'];
};

export type RiskRegistryQuestionsHeartbeat = {
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lastHeartbeat?: Maybe<Scalars['Date']>;
  organization: Organization;
  user: User;
};


export type RiskRegistryQuestionsHeartbeatOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type RiskRegistryQuestionsHeartbeatUserArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum RiskSortField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Title = 'title'
}

export type RiskTemplate = {
  archivedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description: Scalars['String'];
  functionCategory: RegisteredRiskFunctionCategory;
  groupName: RiskTemplateGroup;
  id: Scalars['ID'];
  rating: RiskRating;
  registeredRisks?: Maybe<Array<Maybe<RegisteredRisk>>>;
  templateShorthand: TemplateShorthand;
  title: Scalars['String'];
  triggerConditions?: Maybe<Array<Maybe<TriggerCondition>>>;
  updatedAt: Scalars['Date'];
};

export type RiskTemplateConnection = {
  nodes?: Maybe<Array<Maybe<RiskTemplate>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type RiskTemplateFilters = {
  functionCategories?: InputMaybe<Array<InputMaybe<RegisteredRiskFunctionCategory>>>;
};

export enum RiskTemplateGroup {
  Access = 'Access',
  BusinessAndCompliance = 'BusinessAndCompliance',
  DeviceManagement = 'DeviceManagement',
  EmailSecurity = 'EmailSecurity',
  EndpointSecurity = 'EndpointSecurity',
  NetworkSecurity = 'NetworkSecurity'
}

export enum RiskTemplateSortField {
  Id = 'id'
}

export type Roadmap = {
  executiveReports?: Maybe<Array<Maybe<ExecutiveReport>>>;
  organization?: Maybe<Organization>;
  policyDocuments?: Maybe<RoadmapPolicyDocuments>;
  riskAssessmentDocuments?: Maybe<Array<Maybe<RiskAssessmentDocument>>>;
  steps?: Maybe<RoadmapSteps>;
};

export type RoadmapPolicyDocuments = {
  IncidentResponsePlan?: Maybe<Array<Maybe<PolicyDocument>>>;
  InformationSecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  TechnologySecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
  UserSecurityPolicies?: Maybe<Array<Maybe<PolicyDocument>>>;
};

export type RoadmapStep = {
  acknowledgementItems?: Maybe<Array<Maybe<AcknowledgementItem>>>;
  actionItems?: Maybe<Array<Maybe<ActionItem>>>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  name: RoadmapStepName;
  organization: Organization;
  updatedAt: Scalars['Date'];
};


export type RoadmapStepOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export enum RoadmapStepName {
  AccessControl = 'AccessControl',
  DevelopResponsePlan = 'DevelopResponsePlan',
  ExecutiveReporting = 'ExecutiveReporting',
  OverseeServiceProviders = 'OverseeServiceProviders',
  SecurityAwarenessProgram = 'SecurityAwarenessProgram',
  SecurityTesting = 'SecurityTesting',
  TechnicalRequirements = 'TechnicalRequirements',
  WrittenInformationSecurityProgram = 'WrittenInformationSecurityProgram',
  WrittenRiskAssessment = 'WrittenRiskAssessment'
}

export type RoadmapSteps = {
  AccessControl?: Maybe<RoadmapStep>;
  DevelopResponsePlan?: Maybe<RoadmapStep>;
  ExecutiveReporting?: Maybe<RoadmapStep>;
  OverseeServiceProviders?: Maybe<RoadmapStep>;
  SecurityAwarenessProgram?: Maybe<RoadmapStep>;
  SecurityTesting?: Maybe<RoadmapStep>;
  TechnicalRequirements?: Maybe<RoadmapStep>;
  WrittenInformationSecurityProgram?: Maybe<RoadmapStep>;
  WrittenRiskAssessment?: Maybe<RoadmapStep>;
};

export type S3PutPsuData = {
  message?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
  s3ObjectKey?: Maybe<Scalars['String']>;
};

export type Section = {
  hidden: Scalars['Boolean'];
  htmlBody?: Maybe<Scalars['String']>;
  htmlVars?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  isAdvancedMode: Scalars['Boolean'];
  policyDocument?: Maybe<PolicyDocument>;
  title?: Maybe<Scalars['String']>;
};

export type SectionInput = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  htmlBody?: InputMaybe<Scalars['String']>;
  htmlVars?: InputMaybe<Scalars['JSON']>;
  isAdvancedMode: Scalars['Boolean'];
  title: Scalars['String'];
};

export type SectionTemplate = {
  helperHtml?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  templateHtml: Scalars['String'];
  templateVars?: Maybe<Array<Maybe<TemplateVars>>>;
  title: Scalars['String'];
};

export enum SecurityReportDateRange {
  Last3Months = 'last3Months',
  LastMonth = 'lastMonth',
  LastQuarter = 'lastQuarter',
  LastWeek = 'lastWeek',
  LastYear = 'lastYear'
}

export enum SecurityReportTemplateType {
  DeviceManagement = 'deviceManagement',
  PhishingSimulation = 'phishingSimulation',
  SecurityAwareness = 'securityAwareness',
  SecurityResponse = 'securityResponse'
}

export enum SendTo {
  Admins = 'Admins',
  MailingList = 'MailingList',
  Members = 'Members'
}

export type SensitiveConsumerData = {
  dateOfBirth: Scalars['Boolean'];
  driverLicenseNumber: Scalars['Boolean'];
  ssn: Scalars['Boolean'];
};

export type SensitiveConsumerDataInput = {
  dateOfBirth: Scalars['Boolean'];
  driverLicenseNumber: Scalars['Boolean'];
  ssn: Scalars['Boolean'];
};

/**
 * Device Types as specified by the Sentinel One Agents (machineType field) API
 * documentation with spaces replaced with underscores and converted to uppercase.
 * COMPLIANCE_FALLBACK is used in the event of a SentinelOne schema change.
 */
export enum SentinelOneDeviceType {
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  Desktop = 'DESKTOP',
  KubernetesNode = 'KUBERNETES_NODE',
  KubernetesPod = 'KUBERNETES_POD',
  Laptop = 'LAPTOP',
  Server = 'SERVER',
  Storage = 'STORAGE',
  Unknown = 'UNKNOWN'
}

export type SentinelOneResponse = {
  endpoints?: Maybe<Array<Maybe<Endpoint>>>;
  groupCount?: Maybe<Scalars['Int']>;
  threats?: Maybe<Array<Maybe<Threat>>>;
};

export type ShadowEntity = Organization | User;

export enum ShadowType {
  Organization = 'Organization',
  User = 'User'
}

export type SharedData = {
  consumerFinancialData: ConsumerFinancialData;
  consumerIdentityData: ConsumerIdentityData;
  otherConsumerData: OtherConsumerData;
  sensitiveConsumerData: SensitiveConsumerData;
};

export type SharedDataInput = {
  consumerFinancialData: ConsumerFinancialDataInput;
  consumerIdentityData: ConsumerIdentityDataInput;
  otherConsumerData: OtherConsumerDataInput;
  sensitiveConsumerData: SensitiveConsumerDataInput;
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StepState = {
  dealershipRequestAnswers: DealershipRequestMeta;
  nda: NdaMeta;
  vendorAgreementAnswers: VendorAgreementMeta;
  welcome: Scalars['Boolean'];
};

export type StepStateInput = {
  dealershipRequestAnswers: DealershipRequestMetaInput;
  nda?: InputMaybe<NdaMetaInput>;
  vendorAgreementAnswers: VendorAgreementMetaInput;
  welcome: Scalars['Boolean'];
};

export type Subscription = {
  _?: Maybe<Scalars['Boolean']>;
};

/** System-level AffiliateGroup input */
export type SystemAffiliateGroupInput = {
  /** User provided name used to identify the AffiliateGroup. Max 255 characters. Does not need to be unique. Input value is automatically trimmed and validated that it is not nullish. */
  name: Scalars['String'];
};

export type SystemAffiliateOrganizationInput = {
  affiliateGroupId: Scalars['ID'];
  organizationId: Scalars['ID'];
};

export type SystemCreateVendorInput = {
  businessAddress?: InputMaybe<Scalars['String']>;
  businessName: Scalars['String'];
  contactEmail?: InputMaybe<Scalars['String']>;
};

export type SystemDocumentFilters = {
  categories?: InputMaybe<Array<InputMaybe<DocumentCategory>>>;
  isExpired?: InputMaybe<Scalars['Boolean']>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  title?: InputMaybe<Scalars['String']>;
};

export type SystemOrganizationInput = {
  accountType: OrganizationAccountType;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  cif?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  knowBe4ApiKey?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  sentinelOneSiteId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type SystemOrganizationMailingRecipient = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type SystemPolicyDocumentFilters = {
  createdByUser?: InputMaybe<Scalars['UserID']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  isExpired?: InputMaybe<Scalars['Boolean']>;
  isUploaded?: InputMaybe<Scalars['Boolean']>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  templateTypes?: InputMaybe<Array<InputMaybe<PolicyDocumentTemplateType>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type SystemRiskFilters = {
  coreFunctions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  functionCategories?: InputMaybe<Array<InputMaybe<FunctionCategory>>>;
  ratings?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  riskAssessmentDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type SystemVendorOrganizationFilters = {
  businessName?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  hasContactEmail?: InputMaybe<Scalars['Boolean']>;
  organizationCif?: InputMaybe<Scalars['String']>;
  organizationName?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vendors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type Task = {
  assignee?: Maybe<User>;
  comments?: Maybe<Array<Maybe<TaskComment>>>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isComplete?: Maybe<Scalars['Boolean']>;
  registeredRisk?: Maybe<RegisteredRisk>;
  risk?: Maybe<Risk>;
  status?: Maybe<TaskStatus>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};


export type TaskRiskArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type TaskComment = {
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  task?: Maybe<Task>;
  text: Scalars['String'];
  updatedAt?: Maybe<Scalars['Date']>;
  user?: Maybe<User>;
};


export type TaskCommentTaskArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type TaskCommentConnection = {
  nodes?: Maybe<Array<Maybe<TaskComment>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TaskCommentFilters = {
  taskIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum TaskCommentSortField {
  CreatedAt = 'createdAt',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type TaskConnection = {
  nodes?: Maybe<Array<Maybe<Task>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type TaskFilters = {
  dueDate?: InputMaybe<DateFilter>;
  hasAssignedUser?: InputMaybe<Scalars['Boolean']>;
  hasDueDate?: InputMaybe<Scalars['Boolean']>;
  isComplete?: InputMaybe<Scalars['Boolean']>;
  riskIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Array<InputMaybe<TaskStatus>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type TaskInput = {
  assigneeId?: InputMaybe<Scalars['UserID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  isComplete: Scalars['Boolean'];
  registeredRiskId?: InputMaybe<Scalars['ID']>;
  riskId?: InputMaybe<Scalars['ID']>;
  title: Scalars['String'];
};

export enum TaskSortField {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  DueDate = 'dueDate',
  Id = 'id',
  Title = 'title'
}

export enum TaskStatus {
  Completed = 'Completed',
  PastDue = 'PastDue',
  Pending = 'Pending'
}

export enum TemplateShorthand {
  AnnualReviewAccessToCustomerInformationNotCompleted = 'AnnualReviewAccessToCustomerInformationNotCompleted',
  AnnualReviewDealershipAssetsNotCompleted = 'AnnualReviewDealershipAssetsNotCompleted',
  AnnualReviewInformationSecurityPoliciesNotCompleted = 'AnnualReviewInformationSecurityPoliciesNotCompleted',
  AnnualReviewMfaCloudServicesNotCompleted = 'AnnualReviewMFACloudServicesNotCompleted',
  AnnualReviewOfIncidentResponseNotCompleted = 'AnnualReviewOfIncidentResponseNotCompleted',
  AnnualReviewOfTechnologySecurityNotCompleted = 'AnnualReviewOfTechnologySecurityNotCompleted',
  AnnualReviewOfUserSecurityNotCompleted = 'AnnualReviewOfUserSecurityNotCompleted',
  AnnualReviewOfVendors = 'AnnualReviewOfVendors',
  CentralizedPasswordSolutionNotImplemented = 'CentralizedPasswordSolutionNotImplemented',
  CriticalDateStoredOutside = 'CriticalDateStoredOutside',
  CriticalDeviceViaRemoteAccess = 'CriticalDeviceViaRemoteAccess',
  DkimNotImplemented = 'DKIMNotImplemented',
  DmarcNotImplemented = 'DMARCNotImplemented',
  EmailFilteringNotImplemented = 'EmailFilteringNotImplemented',
  HistoryCyberIncidents = 'HistoryCyberIncidents',
  InactiveMailboxReviewNotPerformed = 'InactiveMailboxReviewNotPerformed',
  IncidentResponseNotDocumented = 'IncidentResponseNotDocumented',
  InformationSecurityProgramNotEstablished = 'InformationSecurityProgramNotEstablished',
  InsecureUserTerminationPractices = 'InsecureUserTerminationPractices',
  MfaForCloudAccountsNotRequired = 'MFAForCloudAccountsNotRequired',
  MfaForEmailAccessNotEnforced = 'MFAForEmailAccessNotEnforced',
  MfaForPrivilegedAccounts = 'MFAForPrivilegedAccounts',
  MinimumPasswordLengthNotEnforced = 'MinimumPasswordLengthNotEnforced',
  NewHirePhishingSimulation30DayEnrollment = 'NewHirePhishingSimulation30DayEnrollment',
  NewHireSecurityTraining30DayEnrollment = 'NewHireSecurityTraining30DayEnrollment',
  NoInternalHardwareInventoryMaintained = 'NoInternalHardwareInventoryMaintained',
  NoInternalSoftwareInventoryMaintained = 'NoInternalSoftwareInventoryMaintained',
  PasswordComplexityNotEnforced = 'PasswordComplexityNotEnforced',
  PasswordRequirementsNotEnforced = 'PasswordRequirementsNotEnforced',
  PhishingSimulationConductedInfrequently = 'PhishingSimulationConductedInfrequently',
  PhishingSimulationNotImplemented = 'PhishingSimulationNotImplemented',
  ProcessForRemovingUnusedAccountNotDocumented = 'ProcessForRemovingUnusedAccountNotDocumented',
  ProcessForReviewingVendorsNotDocumented = 'ProcessForReviewingVendorsNotDocumented',
  QiNotAppointed = 'QINotAppointed',
  RemoteAccessWithoutMfa = 'RemoteAccessWithoutMFA',
  ReportSecurityProgramStatus = 'ReportSecurityProgramStatus',
  ReviewMonthlyTrainingResults = 'ReviewMonthlyTrainingResults',
  SpfNotImplemented = 'SPFNotImplemented',
  SecurityAwarenessTrainingConductedInfrequently = 'SecurityAwarenessTrainingConductedInfrequently',
  SecurityAwarenessTrainingNotImplemented = 'SecurityAwarenessTrainingNotImplemented',
  SharedMailboxReviewNotPerformed = 'SharedMailboxReviewNotPerformed',
  TechnologySecurityPolicyNotDocumented = 'TechnologySecurityPolicyNotDocumented',
  UnmanagedByodAccess = 'UnmanagedBYODAccess',
  UnsupportedOperatingSystems = 'UnsupportedOperatingSystems',
  UserSecurityPolicyNotDocumented = 'UserSecurityPolicyNotDocumented',
  VendorEndpointAccessWithoutMfa = 'VendorEndpointAccessWithoutMFA',
  VendorRequestDenied = 'VendorRequestDenied',
  VendorRiskResponseNotReviewed = 'VendorRiskResponseNotReviewed'
}

export type TemplateVars = {
  key: Scalars['String'];
  optional?: Maybe<Scalars['Boolean']>;
  recommendedValue?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Threat = {
  analystVerdict: ThreatAnalystVerdict;
  classification: Scalars['String'];
  createdAt?: Maybe<Scalars['String']>;
  deviceName: Scalars['String'];
  deviceType: SentinelOneDeviceType;
  identifiedAt?: Maybe<Scalars['String']>;
  ipAddress: Scalars['String'];
  osVersion: Scalars['String'];
  responseStatus: ThreatResponseStatus;
  siteId?: Maybe<Scalars['String']>;
};

/**
 * Analyst Verdict as specified by the Sentinel One Threats (analystVerdict field) API
 * documentation converted to uppercase.
 * COMPLIANCE_FALLBACK is used in the event of a SentinelOne schema change.
 */
export enum ThreatAnalystVerdict {
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  FalsePositive = 'FALSE_POSITIVE',
  Suspicious = 'SUSPICIOUS',
  TruePositive = 'TRUE_POSITIVE',
  Undefined = 'UNDEFINED'
}

export type ThreatClassification = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['Date'];
};

/**
 * Response Status as specified by the Sentinel One Threats (incidentResponse field)
 * API documentation.
 * COMPLIANCE_FALLBACK is used in the event of a SentinelOne schema change.
 */
export enum ThreatResponseStatus {
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  InProgress = 'IN_PROGRESS',
  Resolved = 'RESOLVED',
  Unresolved = 'UNRESOLVED'
}

/** Training Campaign as defined by the KnowBe4 documentation [https://developer.knowbe4.com/rest/reporting#tag/Training/paths/~1v1~1training~1campaigns/get] */
export type TrainingCampaign = {
  /** The ID used by a training campaign for KnowBe4 */
  campaign_id: Scalars['Int'];
  endedAt?: Maybe<Scalars['Date']>;
  /** Derived from content field on the RawTrainingCampaign received from KnowBe4 */
  modules: Array<Maybe<TrainingModule>>;
  name: Scalars['String'];
  startedAt: Scalars['Date'];
  /** Status of the training campaign (ex. IN_PROGRESS, COMPLETED, etc.) */
  status: TrainingCampaignStatus;
};

/**
 * Training Campaign status as defined by the KnowBe4 API documentation with spaces
 * in the values replaced with underscores and converted to uppercase.
 * COMPLIANCE_FALLBACK is used in the event of a KnowBe4 schema change.
 */
export enum TrainingCampaignStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  ComplianceFallback = 'COMPLIANCE_FALLBACK',
  Created = 'CREATED',
  Enrolling = 'ENROLLING',
  InProgress = 'IN_PROGRESS'
}

export type TrainingModule = {
  enrolledUsers: Array<Maybe<EnrolledUser>>;
  name: Scalars['String'];
};

export type TriggerCondition = {
  condition: Scalars['String'];
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  question: RiskRegistryQuestion;
  riskTemplate: RiskTemplate;
  updatedAt: Scalars['Date'];
};

export type TypedPoliciesSubqueryFilters = {
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<PolicyDocumentFieldSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

/** AffiliateGroup Update input */
export type UpdateAffiliateGroupInput = {
  /** User provided name used to the update the AffiliateGroup. Max 255 characters. Does not need to be unique. Input value is automatically trimmed and validated that it is not nullish. */
  name: Scalars['String'];
};

export type UpdateAutomationSettingsInput = {
  useIncidentResponsePlanAutomation: Scalars['Boolean'];
  useIncidentResponsePlanCadence: AutomationReminderCadence;
  usePolicyCreatorAutomation: Scalars['Boolean'];
  usePolicyReminderCadence: AutomationReminderCadence;
};

export type UpdateCustomNotificationDraftInput = {
  emailBody?: InputMaybe<Scalars['String']>;
  emailSubject?: InputMaybe<Scalars['String']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']>>;
  vendorId?: InputMaybe<Scalars['ID']>;
};

export type UpdateKeyPersonnelInput = {
  keyPersonnel?: InputMaybe<Array<InputMaybe<KeyPersonnelInput>>>;
  organizationId: Scalars['ID'];
};

export type UpdateOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  cif?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdatePolicyDocumentInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateRegisteredRiskInput = {
  description: Scalars['String'];
  functionCategory: Scalars['String'];
  organizationId: Scalars['ID'];
  rating: Scalars['String'];
  registeredRiskId: Scalars['ID'];
  title: Scalars['String'];
};

export type UpdateRiskRegistryAnswerInput = {
  answer?: InputMaybe<Scalars['String']>;
  answerId: Scalars['ID'];
};

export type UpdateSystemDocumentInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateSystemOrganizationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  cif?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  legalName?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  sentinelOneSiteId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemOrganizationMailingRecipientInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemRiskInput = {
  coreFunction?: InputMaybe<Scalars['String']>;
  functionCategory?: InputMaybe<FunctionCategory>;
  id: Scalars['ID'];
  rating?: InputMaybe<Scalars['String']>;
  riskAssessmentDocumentId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemTaskInput = {
  assigneeId?: InputMaybe<Scalars['UserID']>;
  description?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  isComplete?: InputMaybe<Scalars['Boolean']>;
  riskId?: InputMaybe<Scalars['ID']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['UserID'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorRiskByGuidInput = {
  data: VendorRiskResponseDataInput;
  documentId?: InputMaybe<Scalars['ID']>;
  isDraft: Scalars['Boolean'];
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  vendorRequestIds: Array<InputMaybe<Scalars['ID']>>;
};

export type User = {
  createdAt?: Maybe<Scalars['Date']>;
  disableOrgs?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UserID'];
  imageUrl?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  phone?: Maybe<Scalars['String']>;
  portalAccessRole?: Maybe<Array<Maybe<CognitoScope>>>;
  shadowEntity?: Maybe<UserShadowEntity>;
  updatedAt?: Maybe<Scalars['Date']>;
  userActions?: Maybe<Array<Maybe<UserAction>>>;
};


export type UserUserActionsArgs = {
  userActionFilters?: InputMaybe<UserActionSubqueryFilters>;
};

export type UserAction = {
  actionEntity?: Maybe<UserActionEntity>;
  actionTag: ActionTag;
  contextType: AppContextType;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  user: User;
};


export type UserActionActionEntityArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UserActionConnection = {
  nodes?: Maybe<Array<Maybe<UserAction>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserActionEntity = AcknowledgementItem | Document | ExecutiveReport | Organization | PolicyDocument | Risk | RiskAssessmentDocument | Task | TaskComment | UserOrganization | VendorOrganization | VendorRequest;

export enum UserActionSortField {
  CreatedAt = 'createdAt'
}

export type UserActionSubqueryFilters = {
  actionTags?: InputMaybe<Array<InputMaybe<ActionTag>>>;
  contextTypes?: InputMaybe<Array<InputMaybe<AppContextType>>>;
  limit?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<UserActionSortField>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type UserActionsFilters = {
  actionTags?: InputMaybe<Array<InputMaybe<ActionTag>>>;
  contextTypes?: InputMaybe<Array<InputMaybe<AppContextType>>>;
  createdAt?: InputMaybe<DateRange>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  /** The only userFilters that will be supported by systemUserActions at this time will be userIds and emails */
  userFilters?: InputMaybe<UserFilters>;
};

export type UserConnection = {
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  nodes?: Maybe<Array<Maybe<User>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserEdge = {
  cursor: Scalars['String'];
  node?: Maybe<User>;
};

export type UserFilters = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  isProtonAdmin?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  portalAccessRoles?: InputMaybe<Array<InputMaybe<CognitoScope>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UserOrganization = {
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  organization: Organization;
  owner: Scalars['Boolean'];
  user?: Maybe<User>;
};


export type UserOrganizationOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};


export type UserOrganizationUserArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type UserOrganizationConnection = {
  nodes?: Maybe<Array<Maybe<UserOrganization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type UserOrganizationFilters = {
  role?: InputMaybe<UserOrganizationRole>;
};

export enum UserOrganizationRole {
  Admin = 'Admin',
  Member = 'Member'
}

export enum UserOrganizationSortField {
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName',
  UserEmail = 'userEmail',
  UserFirstName = 'userFirstName',
  UserLastName = 'userLastName'
}

export type UserRole = {
  createdAt?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  owner: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UserShadowEntity = {
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  shadowEntity?: Maybe<ShadowEntity>;
  shadowType?: Maybe<ShadowType>;
  updatedAt: Scalars['Date'];
  user: User;
};

export enum UserSortFieldEnum {
  CreatedAt = 'createdAt',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName'
}

export type Vendor = {
  businessAddress?: Maybe<Scalars['String']>;
  businessName: Scalars['String'];
  contactEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  hasDefaultContact?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  risks?: Maybe<Array<Maybe<VendorRisk>>>;
  updatedAt: Scalars['Date'];
};

export type VendorAgreementMeta = {
  hasNecessaryPrivacyDisclosure?: Maybe<Scalars['Boolean']>;
  isPersonAuthorizedToAnswer?: Maybe<Scalars['Boolean']>;
  maintainsSafeguardsForCustInfo?: Maybe<Scalars['Boolean']>;
  responsesCompleteAndTruthful?: Maybe<Scalars['Boolean']>;
};

export type VendorAgreementMetaInput = {
  hasNecessaryPrivacyDisclosure?: InputMaybe<Scalars['Boolean']>;
  isPersonAuthorizedToAnswer?: InputMaybe<Scalars['Boolean']>;
  maintainsSafeguardsForCustInfo?: InputMaybe<Scalars['Boolean']>;
  responsesCompleteAndTruthful?: InputMaybe<Scalars['Boolean']>;
};

export type VendorConnection = {
  nodes?: Maybe<Array<Maybe<Vendor>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VendorFilters = {
  businessName?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  hasDefaultContact?: InputMaybe<Scalars['Boolean']>;
};

export type VendorOrganization = {
  contactEmail?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  lastVendorRequest?: Maybe<VendorRequest>;
  organization: Organization;
  sharedData?: Maybe<SharedData>;
  updatedAt: Scalars['Date'];
  vendor: Vendor;
  vendorRequests?: Maybe<Array<Maybe<VendorRequest>>>;
};


export type VendorOrganizationOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type VendorOrganizationConnection = {
  nodes?: Maybe<Array<Maybe<VendorOrganization>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VendorOrganizationContactFilters = {
  includeContactIfDefault?: InputMaybe<Scalars['Boolean']>;
};

export type VendorOrganizationFilters = {
  businessName?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  requestStatuses?: InputMaybe<Array<InputMaybe<VendorRequestStatus>>>;
  vendors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum VendorOrganizationSortFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrgName = 'orgName',
  UpdatedAt = 'updatedAt',
  VendorName = 'vendorName'
}

export type VendorOrganizationSortFields = {
  fields?: InputMaybe<Array<InputMaybe<VendorOrganizationSortFieldEnum>>>;
  order?: InputMaybe<SortOrder>;
};

export type VendorQuestionnaireResponse = {
  data?: Maybe<RestVendorQuestionnaireResponseData>;
  status: VendorQuestionnaireStatus;
};

export enum VendorQuestionnaireStatus {
  Complete = 'Complete',
  Incomplete = 'Incomplete',
  LinkExpired = 'LinkExpired',
  LinkInvalid = 'LinkInvalid',
  Unopened = 'Unopened'
}

export type VendorRequest = {
  archivedAt?: Maybe<Scalars['Date']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  deletedAt?: Maybe<Scalars['Date']>;
  deniedAt?: Maybe<Scalars['Date']>;
  guid?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  linkExpiredAt?: Maybe<Scalars['Date']>;
  openedAt?: Maybe<Scalars['Date']>;
  organization: Organization;
  reviewedAt?: Maybe<Scalars['Date']>;
  sentAt?: Maybe<Scalars['Date']>;
  startedAt?: Maybe<Scalars['Date']>;
  status?: Maybe<VendorRequestStatus>;
  updatedAt: Scalars['Date'];
  vendor: Vendor;
  vendorOrganization?: Maybe<VendorOrganization>;
  vendorRisk?: Maybe<VendorRisk>;
};


export type VendorRequestOrganizationArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
};

export type VendorRequestConnection = {
  nodes?: Maybe<Array<Maybe<VendorRequest>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VendorRequestFilters = {
  organizationFilters?: InputMaybe<OrganizationFilters>;
  organizationIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status?: InputMaybe<Array<InputMaybe<VendorRequestStatus>>>;
  vendorFilters?: InputMaybe<VendorFilters>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  vendorRiskIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export enum VendorRequestSortFieldEnum {
  CompletedAt = 'completedAt',
  DeniedAt = 'deniedAt',
  Id = 'id',
  LinkExpiredAt = 'linkExpiredAt',
  OrganizationCif = 'organizationCif',
  OrganizationName = 'organizationName',
  SentAt = 'sentAt',
  VendorName = 'vendorName'
}

export enum VendorRequestStatus {
  Archived = 'Archived',
  Completed = 'Completed',
  Denied = 'Denied',
  LinkExpired = 'LinkExpired',
  Opened = 'Opened',
  Reviewed = 'Reviewed',
  Sent = 'Sent',
  Started = 'Started'
}

export type VendorRisk = {
  archivedAt?: Maybe<Scalars['Date']>;
  assessmentUrl?: Maybe<Scalars['String']>;
  completedAt?: Maybe<Scalars['Date']>;
  createdAt: Scalars['Date'];
  data?: Maybe<VendorRiskResponseData>;
  deletedAt?: Maybe<Scalars['Date']>;
  document?: Maybe<Document>;
  expiredAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  isGlobal?: Maybe<Scalars['Boolean']>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  status?: Maybe<VendorRiskStatus>;
  updatedAt: Scalars['Date'];
  vendor?: Maybe<Vendor>;
  vendorRequests?: Maybe<Array<Maybe<VendorRequest>>>;
};


export type VendorRiskOrganizationsArgs = {
  organizationSorting?: InputMaybe<OrganizationSorting>;
};

export type VendorRiskAnswer = {
  code: Scalars['String'];
  otherText?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type VendorRiskAnswerInput = {
  code: Scalars['String'];
  otherText?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type VendorRiskConnection = {
  nodes?: Maybe<Array<Maybe<VendorRisk>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type VendorRiskDocumentInput = {
  businessAddress?: InputMaybe<Scalars['String']>;
  businessName?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['ID']>;
  vendorRiskId?: InputMaybe<Scalars['ID']>;
};

export enum VendorRiskFieldSortEnum {
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  ExpiredAt = 'expiredAt',
  Id = 'id',
  VendorName = 'vendorName'
}

export type VendorRiskFilters = {
  isGlobal?: InputMaybe<Scalars['Boolean']>;
  organizations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  responseTypes?: InputMaybe<Array<InputMaybe<VendorRiskResponseType>>>;
  status?: InputMaybe<Array<InputMaybe<VendorRiskStatus>>>;
  vendors?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type VendorRiskQuestion = {
  code: Scalars['String'];
  description: Scalars['String'];
  options: Array<VendorRiskResponseOption>;
  title: Scalars['String'];
};

export type VendorRiskQuestionInput = {
  answer?: InputMaybe<VendorRiskAnswerInput>;
  code: Scalars['String'];
  description: Scalars['String'];
  options: Array<VendorRiskResponseOptionInput>;
  title: Scalars['String'];
};

export type VendorRiskQuestionWithAnswer = {
  answer?: Maybe<VendorRiskAnswer>;
  code: Scalars['String'];
  description: Scalars['String'];
  options: Array<VendorRiskResponseOption>;
  title: Scalars['String'];
};

export type VendorRiskResponseData = {
  sections?: Maybe<Array<VendorRiskSectionWithAnswer>>;
  stepState?: Maybe<StepState>;
};

export type VendorRiskResponseDataInput = {
  sections?: InputMaybe<Array<VendorRiskSectionInput>>;
  stepState?: InputMaybe<StepStateInput>;
};

export type VendorRiskResponseOption = {
  code: Scalars['String'];
  title: Scalars['String'];
};

export type VendorRiskResponseOptionInput = {
  code: Scalars['String'];
  otherText?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum VendorRiskResponseType {
  DealershipUpload = 'DealershipUpload',
  VendorUpload = 'VendorUpload'
}

export type VendorRiskSection = {
  code: Scalars['String'];
  id: Scalars['String'];
  questions: Array<VendorRiskQuestion>;
  title: Scalars['String'];
};

export type VendorRiskSectionInput = {
  code: Scalars['String'];
  id: Scalars['String'];
  questions: Array<VendorRiskQuestionInput>;
  title: Scalars['String'];
};

export type VendorRiskSectionWithAnswer = {
  code: Scalars['String'];
  id: Scalars['ID'];
  questions: Array<VendorRiskQuestionWithAnswer>;
  title: Scalars['String'];
};

export enum VendorRiskStatus {
  Archived = 'Archived',
  Completed = 'Completed',
  Deleted = 'Deleted',
  Expired = 'Expired',
  Started = 'Started'
}

export type VendorRiskTemplate = {
  sections: Array<VendorRiskSection>;
};

export enum VendorSortFieldEnum {
  BusinessName = 'businessName',
  ContactEmail = 'contactEmail',
  CreatedAt = 'createdAt',
  Id = 'id'
}

export type UpdateRiskTemplateInput = {
  description?: InputMaybe<Scalars['String']>;
  functionCategory?: InputMaybe<RegisteredRiskFunctionCategory>;
  rating?: InputMaybe<RiskRating>;
  templateId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateVendorOrganizationInput = {
  contactEmail?: InputMaybe<Scalars['String']>;
  sharedData?: InputMaybe<SharedDataInput>;
  vendorOrganizationId: Scalars['ID'];
};

export type SystemAddUserToOrganizationMutationVariables = Exact<{
  userParams: AddUserInput;
}>;


export type SystemAddUserToOrganizationMutation = { systemAddUserToOrganization?: { id: string } | null };

export type SystemAffiliateGroupQueryVariables = Exact<{
  systemAffiliateGroupId: Scalars['ID'];
}>;


export type SystemAffiliateGroupQuery = { systemAffiliateGroup?: { id: string, name: string, createdAt: string, updatedAt: string, deletedAt?: string | null, organizations?: Array<{ id: string } | null> | null } | null };

export type SystemAffiliateGroupsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  affiliateGroupFilters?: InputMaybe<AffiliateGroupFilters>;
  sortField?: InputMaybe<AffiliateGroupSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
}>;


export type SystemAffiliateGroupsQuery = { systemAffiliateGroups?: { totalCount: number, nodes?: Array<{ id: string, name: string, createdAt: string, updatedAt: string, deletedAt?: string | null, organizations?: Array<{ id: string } | null> | null } | null> | null } | null };

export type SystemAffiliateOrganizationsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<AffiliateOrganizationsFilters>;
  sortField?: InputMaybe<AffiliateOrganizationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemAffiliateOrganizationsQuery = { systemAffiliateOrganizations?: { totalCount: number, nodes?: Array<{ id: string, createdAt: string, organization: { id: string, cif?: string | null, name?: string | null }, affiliateGroup: { id: string, name: string } } | null> | null } | null };

export type SystemCreateAffiliateGroupMutationVariables = Exact<{
  input: SystemAffiliateGroupInput;
}>;


export type SystemCreateAffiliateGroupMutation = { systemCreateAffiliateGroup?: { id: string, name: string } | null };

export type SystemAddAffiliateOrganizationMutationVariables = Exact<{
  input: SystemAffiliateOrganizationInput;
}>;


export type SystemAddAffiliateOrganizationMutation = { systemAddAffiliateOrganization?: { id: string } | null };

export type SystemCreateDocumentMutationVariables = Exact<{
  documentParams?: InputMaybe<CreateDocumentInput>;
}>;


export type SystemCreateDocumentMutation = { systemCreateDocument?: { id: string, category: DocumentCategory } | null };

export type SystemCreateOrganizationMutationVariables = Exact<{
  organization?: InputMaybe<SystemOrganizationInput>;
}>;


export type SystemCreateOrganizationMutation = { systemCreateOrganization?: { addressLine1?: string | null, addressLine2?: string | null, city?: string | null, country?: string | null, createdAt?: string | null, id: string, imageUrl?: string | null, legalName?: string | null, name?: string | null, paidSubscription?: boolean | null, owned?: boolean | null, phone?: string | null, state?: string | null, updatedAt?: string | null, zip?: string | null, userRoles?: Array<{ createdAt?: string | null, id: string, owner: boolean, updatedAt?: string | null, user?: { id: string } | null } | null> | null } | null };

export type SystemCreateOrganizationMailingRecipientMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  recipient: SystemOrganizationMailingRecipient;
}>;


export type SystemCreateOrganizationMailingRecipientMutation = { systemCreateOrganizationMailingRecipient?: { firstName?: string | null, lastName?: string | null, email?: string | null } | null };

export type SystemCreateRiskMutationVariables = Exact<{
  input?: InputMaybe<RiskInput>;
}>;


export type SystemCreateRiskMutation = { systemCreateRisk?: { id: string } | null };

export type SystemCreateTaskMutationVariables = Exact<{
  task: TaskInput;
}>;


export type SystemCreateTaskMutation = { systemCreateTask?: { id: string } | null };

export type SystemCustomNotificationsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<CustomNotificationStatus>;
}>;


export type SystemCustomNotificationsQuery = { systemCustomNotifications: { totalCount: number, nodes?: Array<{ id: string, emailSubject?: string | null, status: CustomNotificationStatus, sentAt?: string | null, createdAt: string, dealerships: Array<{ id: string, name?: string | null }>, recipients: { totalCount: number }, createdBy: { id: string, firstName?: string | null, lastName?: string | null }, sentBy?: { id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } };

export type SystemCustomNotificationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemCustomNotificationQuery = { systemCustomNotification?: { id: string, emailSubject?: string | null, emailBody?: string | null, status: CustomNotificationStatus, sentAt?: string | null, createdAt: string, updatedAt: string, vendor?: { id: string, businessName: string } | null, dealerships: Array<{ id: string, name?: string | null, cif?: string | null }>, createdBy: { id: string, firstName?: string | null, lastName?: string | null }, sentBy?: { id: string, firstName?: string | null, lastName?: string | null } | null, recipients: { totalCount: number, nodes?: Array<{ id: string, firstName: string, lastName: string, emailAddress: string, organization: { id: string, name?: string | null, cif?: string | null } } | null> | null } } | null };

export type SystemCreateCustomNotificationDraftMutationVariables = Exact<{
  input: CreateCustomNotificationDraftInput;
}>;


export type SystemCreateCustomNotificationDraftMutation = { systemCreateCustomNotificationDraft: { id: string } };

export type SystemUpdateCustomNotificationDraftMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateCustomNotificationDraftInput;
}>;


export type SystemUpdateCustomNotificationDraftMutation = { systemUpdateCustomNotificationDraft: { id: string, emailSubject?: string | null, emailBody?: string | null, dealerships: Array<{ id: string, name?: string | null, cif?: string | null }> } };

export type SystemDeleteCustomNotificationDraftMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemDeleteCustomNotificationDraftMutation = { systemDeleteCustomNotificationDraft: boolean };

export type SystemSendCustomNotificationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemSendCustomNotificationMutation = { systemSendCustomNotification: { id: string, status: CustomNotificationStatus, sentAt?: string | null } };

export type SystemDeactivateOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemDeactivateOrganizationMutation = { systemDeactivateOrganization?: { id: string } | null };

export type SystemDealershipsOverviewQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  infoSecurityFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
  incidentResponseFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
  userSecurityFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
  technologySecurityFilters?: InputMaybe<TypedPoliciesSubqueryFilters>;
  vulnerabilityScanFilters?: InputMaybe<OrganizationDocumentSubqueryFilters>;
  penetrationTestFilters?: InputMaybe<OrganizationDocumentSubqueryFilters>;
  executiveReportFilters?: InputMaybe<OrganizationExecutiveReportSubqueryFilters>;
  riskAssessmentFilters?: InputMaybe<OrganizationRiskAssessmentSubqueryFilters>;
  sortField?: InputMaybe<OrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemDealershipsOverviewQuery = { systemOrganizations?: { totalCount: number, nodes?: Array<{ id: string, cif?: string | null, name?: string | null, accountType?: OrganizationAccountType | null, sentinelOneSiteId?: string | null, knowBe4Key?: string | null, infoSecurityPolicies?: Array<{ id: string, isDraft: boolean, expiredAt?: string | null } | null> | null, incidentResponsePolicies?: Array<{ id: string, isDraft: boolean, expiredAt?: string | null } | null> | null, userSecurityPolicies?: Array<{ id: string, isDraft: boolean, expiredAt?: string | null } | null> | null, technologySecurityPolicies?: Array<{ id: string, isDraft: boolean, expiredAt?: string | null } | null> | null, vulnerabilityScans?: Array<{ id: string, conductedAt?: string | null, expiresAt: string } | null> | null, penetrationTests?: Array<{ id: string, conductedAt?: string | null, expiresAt: string } | null> | null, executiveReports?: Array<{ id: string, isDraft: boolean, expiredAt?: string | null } | null> | null, riskAssessments?: Array<{ status: RiskAssessmentStatus } | null> | null, vendorOrganizations?: Array<{ id: string } | null> | null } | null> | null } | null };

export type SystemDeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemDeleteOrganizationMutation = { systemDeleteOrganization?: { id: string } | null };

export type SystemDocumentQueryVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type SystemDocumentQuery = { systemDocument?: { id: string, title: string, category: DocumentCategory, expiresAt: string, description?: string | null, createdAt?: string | null, conductedAt?: string | null, uploadedByUser?: { firstName?: string | null, lastName?: string | null, id: string, email?: string | null } | null } | null };

export type SystemDocumentOrganizationsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<DocumentOrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  documentFilters?: InputMaybe<DocumentFilters>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
}>;


export type SystemDocumentOrganizationsQuery = { systemDocumentOrganizations?: { totalCount: number, nodes?: Array<{ id: string, organization?: { id: string, cif?: string | null, name?: string | null } | null, document?: { id: string, title: string, category: DocumentCategory, description?: string | null } | null } | null> | null, pageInfo: { endCursor?: string | null } } | null };

export type SystemDocumentsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  documentFilters?: InputMaybe<SystemDocumentFilters>;
  sortFields?: InputMaybe<Array<InputMaybe<DocumentFieldSortFieldEnum>> | InputMaybe<DocumentFieldSortFieldEnum>>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemDocumentsQuery = { systemDocuments?: { totalCount: number, nodes?: Array<{ id: string, title: string, category: DocumentCategory, createdAt?: string | null, expiresAt: string, conductedAt?: string | null } | null> | null } | null };

export type SystemExecutiveReportsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<ExecutiveReportFieldSortField>;
  executiveReportFilters?: InputMaybe<ExecutiveReportFilters>;
}>;


export type SystemExecutiveReportsQuery = { systemExecutiveReports?: { totalCount: number, nodes?: Array<{ id: string, expiredAt?: string | null, createdAt?: string | null, isDraft: boolean } | null> | null } | null };

export type SystemNavigationEventsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  userFilters?: InputMaybe<UserFilters>;
  sortField?: InputMaybe<NavigationEventSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  filters?: InputMaybe<NavigationEventFilters>;
}>;


export type SystemNavigationEventsQuery = { systemNavigationEvents?: { totalCount: number, nodes?: Array<{ createdAt: string, fromPathname?: string | null, toPathname: string, user: { id: string, email?: string | null } } | null> | null } | null };

export type SystemOperatingSystemsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  operatingSystemFilters?: InputMaybe<OperatingSystemFilters>;
  sortField?: InputMaybe<Array<InputMaybe<OperatingSystemSortField>> | InputMaybe<OperatingSystemSortField>>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemOperatingSystemsQuery = { systemOperatingSystems?: { totalCount: number, nodes?: Array<{ id: string, createdAt: string, deletedAt?: string | null, name: string, revision?: string | null, status: OsSupportStatus, updatedAt: string } | null> | null, pageInfo: { endCursor?: string | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null } } | null };

export type SystemOrganizationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemOrganizationQuery = { systemOrganization?: { addressLine1?: string | null, addressLine2?: string | null, city?: string | null, country?: string | null, createdAt?: string | null, id: string, cif?: string | null, sentinelOneSiteId?: string | null, knowBe4Key?: string | null, imageUrl?: string | null, legalName?: string | null, name?: string | null, paidSubscription?: boolean | null, owned?: boolean | null, phone?: string | null, state?: string | null, updatedAt?: string | null, zip?: string | null, accountType?: OrganizationAccountType | null, archivedAt?: string | null, billingStartedAt?: string | null, modalsMutedAt?: string | null, userRoles?: Array<{ createdAt?: string | null, id: string, owner: boolean, user?: { id: string } | null } | null> | null, notificationSettings?: { deviceManagementReport?: { enabled: boolean, frequency: NotificationFrequency, sendTo: Array<SendTo | null>, notificationType: NotificationType } | null, documentUpload?: { enabled: boolean, frequency: NotificationFrequency, sendTo: Array<SendTo | null>, notificationType: NotificationType } | null, pendingActionItemsReport?: { enabled: boolean, frequency: NotificationFrequency, sendTo: Array<SendTo | null>, notificationType: NotificationType } | null, securityResponseReport?: { enabled: boolean, frequency: NotificationFrequency, sendTo: Array<SendTo | null>, notificationType: NotificationType } | null, trainingAndPhishingReport?: { enabled: boolean, frequency: NotificationFrequency, sendTo: Array<SendTo | null>, notificationType: NotificationType } | null } | null } | null };

export type SystemOrganizationCustomNotificationsQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SystemOrganizationCustomNotificationsQuery = { systemOrganizationCustomNotifications: Array<{ id: string, emailSubject?: string | null, status: CustomNotificationStatus, sentAt?: string | null, createdAt: string }> };

export type SystemOrganizationMailingRecipientsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  mailingRecipientFilters?: InputMaybe<OrganizationMailingRecipientFilters>;
  sortField?: InputMaybe<MailingRecipientSortField>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemOrganizationMailingRecipientsQuery = { systemOrganizationMailingRecipients?: { totalCount: number, nodes?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: string | null } | null> | null } | null };

export type SystemOrganizationsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  sortField?: InputMaybe<OrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemOrganizationsQuery = { systemOrganizations?: { totalCount: number, nodes?: Array<{ addressLine1?: string | null, addressLine2?: string | null, city?: string | null, country?: string | null, createdAt?: string | null, id: string, cif?: string | null, imageUrl?: string | null, legalName?: string | null, name?: string | null, paidSubscription?: boolean | null, owned?: boolean | null, phone?: string | null, state?: string | null, updatedAt?: string | null, modalsMutedAt?: string | null, zip?: string | null, userRoles?: Array<{ createdAt?: string | null, id: string, owner: boolean, updatedAt?: string | null, user?: { id: string } | null } | null> | null } | null> | null } | null };

export type SystemPolicyDocumentsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  systemPolicyDocumentFilters?: InputMaybe<SystemPolicyDocumentFilters>;
  sortFields?: InputMaybe<Array<InputMaybe<PolicyDocumentFieldSortField>> | InputMaybe<PolicyDocumentFieldSortField>>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemPolicyDocumentsQuery = { systemPolicyDocuments?: { totalCount: number, nodes?: Array<{ createdAt: string, expiredAt?: string | null, id: string, isDraft: boolean, templateType?: PolicyDocumentTemplateType | null } | null> | null } | null };

export type SystemReactivateOrganizationMutationVariables = Exact<{
  systemReactivateOrganizationId: Scalars['ID'];
}>;


export type SystemReactivateOrganizationMutation = { systemReactivateOrganization?: { id: string } | null };

export type SystemRemoveAffiliateGroupMutationVariables = Exact<{
  systemRemoveAffiliateGroupId: Scalars['ID'];
}>;


export type SystemRemoveAffiliateGroupMutation = { systemRemoveAffiliateGroup?: { id: string } | null };

export type SystemRemoveAffiliateOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemRemoveAffiliateOrganizationMutation = { systemRemoveAffiliateOrganization?: { id: string } | null };

export type SystemRemoveMemberMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  userId: Scalars['UserID'];
}>;


export type SystemRemoveMemberMutation = { systemRemoveMember?: { id: string } | null };

export type SystemRemoveOrganizationMailingRecipientMutationVariables = Exact<{
  mailingRecipientId: Scalars['ID'];
}>;


export type SystemRemoveOrganizationMailingRecipientMutation = { systemRemoveOrganizationMailingRecipient?: { id: string } | null };

export type SystemRemoveRiskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemRemoveRiskMutation = { systemRemoveRisk?: { id: string } | null };

export type SystemRemoveRiskAssessmentDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemRemoveRiskAssessmentDocumentMutation = { systemRemoveRiskAssessmentDocument?: { id: string } | null };

export type SystemRemoveShadowEntityMutationVariables = Exact<{
  userId: Scalars['UserID'];
}>;


export type SystemRemoveShadowEntityMutation = { systemRemoveShadowEntity?: { id: string, deletedAt?: string | null } | null };

export type SystemRemoveTaskMutationVariables = Exact<{
  id: Scalars['ID'];
  riskId: Scalars['ID'];
}>;


export type SystemRemoveTaskMutation = { systemRemoveTask?: { id: string } | null };

export type SystemRemoveVendorRiskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemRemoveVendorRiskMutation = { systemRemoveVendorRisk?: { id: string } | null };

export type SystemRiskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemRiskQuery = { systemRisk?: { id: string, rating: string, title: string, coreFunction: string, functionCategory: FunctionCategory, createdAt: string, updatedAt: string, tasks?: Array<{ id: string } | null> | null, riskAssessmentDocument?: { id: string, organization: { name?: string | null } } | null } | null };

export type SystemRiskAssessmentDocumentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemRiskAssessmentDocumentQuery = { systemRiskAssessmentDocument?: { id: string, createdAt: string, updatedAt: string, completedAt?: string | null, expiredAt?: string | null, isDraft: boolean, status: RiskAssessmentStatus, sections?: { OrganizationalOversight: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, coreFunction: string, functionCategory: FunctionCategory, answer?: { title: string, code: string } | null, options: Array<{ title: string, code: string }> }> }, AccessControl: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, coreFunction: string, functionCategory: FunctionCategory, answer?: { title: string, code: string } | null, options: Array<{ title: string, code: string }> }> }, SystemDeploymentAndMaintenance: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, coreFunction: string, functionCategory: FunctionCategory, answer?: { title: string, code: string } | null, options: Array<{ title: string, code: string }> }> }, DataProtection: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, coreFunction: string, functionCategory: FunctionCategory, answer?: { title: string, code: string } | null, options: Array<{ title: string, code: string }> }> }, NetworkSecurity: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, coreFunction: string, functionCategory: FunctionCategory, answer?: { title: string, code: string } | null, options: Array<{ title: string, code: string }> }> }, SecurityLoggingAndMonitoring: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, coreFunction: string, functionCategory: FunctionCategory, answer?: { title: string, code: string } | null, options: Array<{ title: string, code: string }> }> }, RiskManagementStrategy: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, coreFunction: string, functionCategory: FunctionCategory, answer?: { title: string, code: string } | null, options: Array<{ title: string, code: string }> }> }, IncidentResponse: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, coreFunction: string, functionCategory: FunctionCategory, answer?: { title: string, code: string } | null, options: Array<{ title: string, code: string }> }> }, BusinessContinuityAndDisasterRecovery: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, coreFunction: string, functionCategory: FunctionCategory, answer?: { title: string, code: string } | null, options: Array<{ title: string, code: string }> }> } } | null, document?: { documentUrl?: string | null, title: string } | null, organization: { id: string, cif?: string | null, name?: string | null, imageUrl?: string | null, legalName?: string | null }, user: { id: string, email?: string | null, firstName?: string | null, lastName?: string | null }, risks?: Array<{ id: string, tasks?: Array<{ id: string } | null> | null } | null> | null } | null };

export type SystemRiskAssessmentDocumentsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  filter?: InputMaybe<RiskAssessmentDocumentFilter>;
  sortField?: InputMaybe<RiskAssessmentDocumentFieldSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemRiskAssessmentDocumentsQuery = { systemRiskAssessmentDocuments?: { totalCount: number, nodes?: Array<{ id: string, status: RiskAssessmentStatus, createdAt: string, expiredAt?: string | null, completedAt?: string | null, isDraft: boolean, document?: { id: string } | null, organization: { id: string, name?: string | null, cif?: string | null, imageUrl?: string | null, legalName?: string | null }, user: { id: string, email?: string | null, firstName?: string | null, lastName?: string | null }, risks?: Array<{ id: string } | null> | null } | null> | null } | null };

export type SystemRisksQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  riskFilters?: InputMaybe<SystemRiskFilters>;
  sortFields?: InputMaybe<Array<InputMaybe<RiskSortField>> | InputMaybe<RiskSortField>>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemRisksQuery = { systemRisks?: { totalCount: number, nodes?: Array<{ id: string, createdAt: string, functionCategory: FunctionCategory, rating: string, title: string, updatedAt: string, riskAssessmentDocument?: { organization: { id: string } } | null, tasks?: Array<{ id: string, title?: string | null, description?: string | null, completedAt?: string | null, dueDate?: string | null, assignee?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null> | null } | null> | null } | null };

export type SystemSetOperatingSystemSupportStatusMutationVariables = Exact<{
  operatingSystemId: Scalars['ID'];
  status: OsSupportStatus;
}>;


export type SystemSetOperatingSystemSupportStatusMutation = { systemSetOperatingSystemSupportStatus?: { id: string } | null };

export type SystemSetRiskAssessmentAnswersMutationVariables = Exact<{
  id: Scalars['ID'];
  sections: RiskAssessmentSectionsInput;
}>;


export type SystemSetRiskAssessmentAnswersMutation = { systemSetRiskAssessmentAnswers?: { id: string, sections?: { OrganizationalOversight: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, answer?: { title: string, code: string } | null }> }, AccessControl: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, answer?: { title: string, code: string } | null }> }, SystemDeploymentAndMaintenance: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, answer?: { title: string, code: string } | null }> }, DataProtection: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, answer?: { title: string, code: string } | null }> }, NetworkSecurity: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, answer?: { title: string, code: string } | null }> }, SecurityLoggingAndMonitoring: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, answer?: { title: string, code: string } | null }> }, RiskManagementStrategy: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, answer?: { title: string, code: string } | null }> }, IncidentResponse: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, answer?: { title: string, code: string } | null }> }, BusinessContinuityAndDisasterRecovery: { id: string, title: string, code: string, questions: Array<{ title: string, code: string, description: string, note?: string | null, answer?: { title: string, code: string } | null }> } } | null } | null };

export type SystemSetRiskAssessmentDocumentCompletionStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: RiskAssessmentStatus;
}>;


export type SystemSetRiskAssessmentDocumentCompletionStatusMutation = { systemSetRiskAssessmentDocumentCompletionStatus?: { id: string, status: RiskAssessmentStatus } | null };

export type SystemSetShadowOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SystemSetShadowOrganizationMutation = { systemSetShadowOrganization?: { id: string } | null };

export type SystemSetShadowUserMutationVariables = Exact<{
  userId: Scalars['UserID'];
}>;


export type SystemSetShadowUserMutation = { systemSetShadowUser?: { id: string } | null };

export type SystemTaskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemTaskQuery = { systemTask?: { id: string, title?: string | null, description?: string | null, dueDate?: string | null, isComplete?: boolean | null, completedAt?: string | null, createdAt?: string | null, updatedAt?: string | null, risk?: { id: string, riskAssessmentDocument?: { id: string, organization: { id: string, name?: string | null } } | null } | null, assignee?: { id: string, firstName?: string | null, email?: string | null, lastName?: string | null } | null, comments?: Array<{ id: string, text: string, createdAt?: string | null, updatedAt?: string | null, user?: { id: string, firstName?: string | null, email?: string | null, lastName?: string | null } | null } | null> | null } | null };

export type SystemTaskCommentsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  taskCommentFilters?: InputMaybe<TaskCommentFilters>;
  sortFields?: InputMaybe<Array<InputMaybe<TaskCommentSortField>> | InputMaybe<TaskCommentSortField>>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemTaskCommentsQuery = { systemTaskComments?: { totalCount: number, nodes?: Array<{ id: string, text: string, createdAt?: string | null, updatedAt?: string | null, user?: { firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null> | null } | null };

export type SystemTasksQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  taskFilters?: InputMaybe<TaskFilters>;
  sortFields?: InputMaybe<Array<InputMaybe<TaskSortField>> | InputMaybe<TaskSortField>>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemTasksQuery = { systemTasks?: { totalCount: number, nodes?: Array<{ id: string, title?: string | null, dueDate?: string | null, completedAt?: string | null, status?: TaskStatus | null, assignee?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null, comments?: Array<{ id: string, text: string, createdAt?: string | null, user?: { id: string, firstName?: string | null, lastName?: string | null } | null } | null> | null } | null> | null } | null };

export type SystemUpdateAffiliateGroupMutationVariables = Exact<{
  systemUpdateAffiliateGroupId: Scalars['ID'];
  input: UpdateAffiliateGroupInput;
}>;


export type SystemUpdateAffiliateGroupMutation = { systemUpdateAffiliateGroup?: { id: string, name: string, createdAt: string, updatedAt: string, deletedAt?: string | null, organizations?: Array<{ id: string } | null> | null } | null };

export type SystemUpdateDocumentMutationVariables = Exact<{
  input: UpdateSystemDocumentInput;
}>;


export type SystemUpdateDocumentMutation = { systemUpdateDocument?: { id: string, description?: string | null } | null };

export type SystemUpdateOrganizationMutationVariables = Exact<{
  organization?: InputMaybe<UpdateSystemOrganizationInput>;
  organizationId: Scalars['ID'];
  sentinelOneSiteId?: InputMaybe<Scalars['String']>;
  knowBe4ApiKey?: InputMaybe<Scalars['String']>;
  billingStartedAt?: InputMaybe<Scalars['Date']>;
}>;


export type SystemUpdateOrganizationMutation = { systemUpdateOrganization?: { addressLine1?: string | null, addressLine2?: string | null, city?: string | null, country?: string | null, createdAt?: string | null, id: string, cif?: string | null, sentinelOneSiteId?: string | null, knowBe4Key?: string | null, imageUrl?: string | null, legalName?: string | null, name?: string | null, paidSubscription?: boolean | null, owned?: boolean | null, phone?: string | null, state?: string | null, updatedAt?: string | null, zip?: string | null } | null, systemUpdateSentinelOneSiteId?: { id: string, sentinelOneSiteId?: string | null } | null, systemUpdateKnowBe4ApiKey?: { id: string, knowBe4Key?: string | null } | null, systemUpdateOrganizationBillingStartedAt?: { id: string, billingStartedAt?: string | null } | null };

export type SystemUpdateOrganizationAccountTypeMutationVariables = Exact<{
  id: Scalars['ID'];
  accountType: OrganizationAccountType;
}>;


export type SystemUpdateOrganizationAccountTypeMutation = { systemUpdateOrganizationAccountType?: { id: string, accountType?: OrganizationAccountType | null } | null };

export type SystemUpdateOrganizationMailingRecipientMutationVariables = Exact<{
  input: UpdateSystemOrganizationMailingRecipientInput;
}>;


export type SystemUpdateOrganizationMailingRecipientMutation = { systemUpdateOrganizationMailingRecipient?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null };

export type SystemUpdateOrganizationModalsMutedAtMutationVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type SystemUpdateOrganizationModalsMutedAtMutation = { systemUpdateOrganizationModalsMutedAt?: { id: string } | null };

export type SystemUpdateOrganizationNotificationSettingsMutationVariables = Exact<{
  organizationId: Scalars['ID'];
  updatedNotificationSettings: NotificationSettingsInput;
}>;


export type SystemUpdateOrganizationNotificationSettingsMutation = { systemUpdateOrganizationNotificationSettings?: { id: string } | null };

export type SystemUpdateRiskMutationVariables = Exact<{
  input?: InputMaybe<UpdateSystemRiskInput>;
}>;


export type SystemUpdateRiskMutation = { systemUpdateRisk?: { id: string, rating: string, functionCategory: FunctionCategory, title: string } | null };

export type SystemUpdateTaskMutationVariables = Exact<{
  task: UpdateSystemTaskInput;
}>;


export type SystemUpdateTaskMutation = { systemUpdateTask?: { id: string } | null };

export type SystemUpdateUserMutationVariables = Exact<{
  input?: InputMaybe<UpdateSystemUserInput>;
}>;


export type SystemUpdateUserMutation = { systemUpdateUser?: { id: string, firstName?: string | null, lastName?: string | null } | null };

export type SystemUpdateUserOrganizationRoleMutationVariables = Exact<{
  userOrganizationId: Scalars['ID'];
  role: UserOrganizationRole;
}>;


export type SystemUpdateUserOrganizationRoleMutation = { systemUpdateUserOrganizationRole?: { id: string } | null };

export type SystemUpdateUserPortalAccessRoleMutationVariables = Exact<{
  systemUpdateUserPortalAccessRoleId: Scalars['UserID'];
  accessRoles?: InputMaybe<Array<InputMaybe<CognitoScope>> | InputMaybe<CognitoScope>>;
}>;


export type SystemUpdateUserPortalAccessRoleMutation = { systemUpdateUserPortalAccessRole?: { id: string } | null };

export type SystemUserQueryVariables = Exact<{
  id: Scalars['UserID'];
  userActionFilters?: InputMaybe<UserActionSubqueryFilters>;
}>;


export type SystemUserQuery = { systemUser?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, createdAt?: string | null, updatedAt?: string | null, portalAccessRole?: Array<CognitoScope | null> | null, organizations?: Array<{ id: string } | null> | null, userActions?: Array<{ createdAt: string } | null> | null } | null };

export type SystemUserActionsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<UserActionsFilters>;
  sortField?: InputMaybe<UserActionSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  includeDeleted?: InputMaybe<Scalars['Boolean']>;
}>;


export type SystemUserActionsQuery = { systemUserActions?: { totalCount: number, nodes?: Array<{ actionTag: ActionTag, contextType: AppContextType, createdAt: string, user: { id: string, email?: string | null }, actionEntity?: { __typename: 'AcknowledgementItem', id: string, roadmapStep: { organization: { id: string, cif?: string | null, name?: string | null } } } | { __typename: 'Document', id: string, organizations?: Array<{ id: string, cif?: string | null, name?: string | null } | null> | null } | { __typename: 'ExecutiveReport', id: string, organization: { id: string, cif?: string | null, name?: string | null } } | { __typename: 'Organization', id: string, cif?: string | null, name?: string | null } | { __typename: 'PolicyDocument', id: string, organization: { id: string, cif?: string | null, name?: string | null } } | { __typename: 'Risk', id: string, riskAssessmentDocument?: { organization: { id: string, cif?: string | null, name?: string | null } } | null } | { __typename: 'RiskAssessmentDocument', id: string, organization: { id: string, cif?: string | null, name?: string | null } } | { __typename: 'Task', id: string, risk?: { riskAssessmentDocument?: { organization: { id: string, cif?: string | null, name?: string | null } } | null } | null } | { __typename: 'TaskComment', id: string, task?: { risk?: { riskAssessmentDocument?: { organization: { id: string, cif?: string | null, name?: string | null } } | null } | null } | null } | { __typename: 'UserOrganization', id: string, user?: { id: string } | null, organization: { id: string, cif?: string | null, name?: string | null } } | { __typename: 'VendorOrganization', id: string, organization: { id: string, cif?: string | null, name?: string | null } } | { __typename: 'VendorRequest', id: string, organization: { id: string, cif?: string | null, name?: string | null } } | null } | null> | null } | null };

export type SystemDealershipUsersQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  userOrganizationFilters?: InputMaybe<UserOrganizationFilters>;
  userFilters?: InputMaybe<UserFilters>;
  organizationFilters?: InputMaybe<OrganizationFilters>;
  sortField?: InputMaybe<UserOrganizationSortField>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemDealershipUsersQuery = { systemUserOrganizations?: { totalCount: number, nodes?: Array<{ id: string, owner: boolean, user?: { id: string, email?: string | null, firstName?: string | null, lastName?: string | null, phone?: string | null } | null, organization: { id: string, cif?: string | null, name?: string | null } } | null> | null } | null };

export type SystemUsersQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  userFilters?: InputMaybe<UserFilters>;
  userOrganizationFilters?: InputMaybe<UserOrganizationFilters>;
  sortField?: InputMaybe<UserSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  userActionFilters?: InputMaybe<UserActionSubqueryFilters>;
}>;


export type SystemUsersQuery = { systemUsers?: { totalCount: number, nodes?: Array<{ id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, organizations?: Array<{ id: string } | null> | null, userActions?: Array<{ createdAt: string } | null> | null } | null> | null } | null };

export type SystemVendorOrganizationsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  systemVendorOrganizationFilters?: InputMaybe<SystemVendorOrganizationFilters>;
  sortField?: InputMaybe<VendorOrganizationSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemVendorOrganizationsQuery = { systemVendorOrganizations?: { totalCount: number, nodes?: Array<{ id: string, createdAt: string, contactEmail?: string | null, vendor: { id: string, businessName: string }, organization: { id: string, cif?: string | null, name?: string | null } } | null> | null } | null };

export type SystemVendorRequestQueryVariables = Exact<{
  systemVendorRequestId: Scalars['ID'];
}>;


export type SystemVendorRequestQuery = { systemVendorRequest?: { id: string, status?: VendorRequestStatus | null, sentAt?: string | null, startedAt?: string | null, openedAt?: string | null, reviewedAt?: string | null, linkExpiredAt?: string | null, deniedAt?: string | null, completedAt?: string | null, vendor: { businessName: string, contactEmail?: string | null }, organization: { cif?: string | null, name?: string | null }, vendorOrganization?: { contactEmail?: string | null } | null, vendorRisk?: { completedAt?: string | null, data?: { sections?: Array<{ title: string, questions: Array<{ description: string, code: string, options: Array<{ code: string, title: string }>, answer?: { code: string, otherText?: string | null } | null }> }> | null, stepState?: { vendorAgreementAnswers: { maintainsSafeguardsForCustInfo?: boolean | null, hasNecessaryPrivacyDisclosure?: boolean | null, responsesCompleteAndTruthful?: boolean | null, isPersonAuthorizedToAnswer?: boolean | null } } | null } | null, document?: { id: string, documentUrl?: string | null, fileExtension?: DocumentFileExtension | null, uploadedByUser?: { id: string } | null } | null } | null } | null };

export type SystemVendorRequestsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  vendorRequestFilters?: InputMaybe<VendorRequestFilters>;
  sortField?: InputMaybe<VendorRequestSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemVendorRequestsQuery = { systemVendorRequests?: { totalCount: number, nodes?: Array<{ id: string, status?: VendorRequestStatus | null, sentAt?: string | null, completedAt?: string | null, deniedAt?: string | null, linkExpiredAt?: string | null, vendor: { businessName: string }, organization: { id: string, cif?: string | null, name?: string | null } } | null> | null } | null };

export type SystemVendorRiskQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemVendorRiskQuery = { systemVendorRisk?: { id: string, assessmentUrl?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null, expiredAt?: string | null, archivedAt?: string | null, status?: VendorRiskStatus | null, isGlobal?: boolean | null, organizations?: Array<{ id: string } | null> | null, vendor?: { id: string, businessName: string, businessAddress?: string | null, contactEmail?: string | null } | null, data?: { sections?: Array<{ title: string, questions: Array<{ description: string, code: string, options: Array<{ code: string, title: string }>, answer?: { code: string, otherText?: string | null } | null }> }> | null, stepState?: { vendorAgreementAnswers: { maintainsSafeguardsForCustInfo?: boolean | null, hasNecessaryPrivacyDisclosure?: boolean | null, responsesCompleteAndTruthful?: boolean | null, isPersonAuthorizedToAnswer?: boolean | null } } | null } | null, document?: { id: string, documentUrl?: string | null, fileExtension?: DocumentFileExtension | null, uploadedByUser?: { id: string } | null } | null } | null };

export type SystemVendorRisksQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  vendorRiskFilters?: InputMaybe<VendorRiskFilters>;
  sortField?: InputMaybe<VendorRiskFieldSortEnum>;
  sortOrder?: InputMaybe<SortOrder>;
  vendorFilters?: InputMaybe<VendorFilters>;
}>;


export type SystemVendorRisksQuery = { systemVendorRisks?: { totalCount: number, nodes?: Array<{ id: string, assessmentUrl?: string | null, createdAt: string, updatedAt: string, completedAt?: string | null, expiredAt?: string | null, archivedAt?: string | null, status?: VendorRiskStatus | null, isGlobal?: boolean | null, organizations?: Array<{ id: string, cif?: string | null, name?: string | null } | null> | null, vendor?: { id: string, businessName: string, businessAddress?: string | null, contactEmail?: string | null } | null, document?: { id: string, documentUrl?: string | null, expiresAt: string, uploadedByUser?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null } | null } | null> | null } | null };

export type SystemVendorsQueryVariables = Exact<{
  pageNumber?: InputMaybe<Scalars['Int']>;
  pageItemsCount?: InputMaybe<Scalars['Int']>;
  vendorFilters?: InputMaybe<VendorFilters>;
  sortField?: InputMaybe<VendorSortFieldEnum>;
  sortOrder?: InputMaybe<SortOrder>;
}>;


export type SystemVendorsQuery = { systemVendors?: { totalCount: number, nodes?: Array<{ id: string, businessName: string, businessAddress?: string | null, contactEmail?: string | null, createdAt: string, deletedAt?: string | null } | null> | null } | null };

export type SystemVendorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SystemVendorQuery = { systemVendor?: { id: string, businessName: string, businessAddress?: string | null, contactEmail?: string | null, createdAt: string, updatedAt: string, deletedAt?: string | null } | null };

export type SystemCreateVendorMutationVariables = Exact<{
  vendorParams?: InputMaybe<SystemCreateVendorInput>;
}>;


export type SystemCreateVendorMutation = { systemCreateVendor?: { id: string } | null };

export type SystemUpdateVendorMutationVariables = Exact<{
  id: Scalars['ID'];
  businessName: Scalars['String'];
  businessAddress?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
}>;


export type SystemUpdateVendorMutation = { systemUpdateVendorName?: { id: string, businessName: string } | null, systemUpdateVendorAddress?: { id: string, businessAddress?: string | null } | null, systemUpdateVendorDefaultContact?: { id: string, contactEmail?: string | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me?: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, phone?: string | null, imageUrl?: string | null, disableOrgs?: boolean | null, organizations?: Array<{ id: string, name?: string | null, legalName?: string | null, addressLine1?: string | null, addressLine2?: string | null, state?: string | null, zip?: string | null, country?: string | null, paidSubscription?: boolean | null, city?: string | null, imageUrl?: string | null, phone?: string | null, createdAt?: string | null, updatedAt?: string | null, owned?: boolean | null, userRoles?: Array<{ id: string, owner: boolean, createdAt?: string | null, updatedAt?: string | null } | null> | null } | null> | null, shadowEntity?: { id: string, shadowType?: ShadowType | null, createdAt: string, updatedAt: string, shadowEntity?: { __typename: 'Organization', name?: string | null } | { __typename: 'User', firstName?: string | null, lastName?: string | null } | null, user: { id: string } } | null } | null };


export const SystemAddUserToOrganizationDocument = gql`
    mutation SystemAddUserToOrganization($userParams: AddUserInput!) {
  systemAddUserToOrganization(userParams: $userParams) {
    id
  }
}
    `;
export type SystemAddUserToOrganizationMutationFn = Apollo.MutationFunction<SystemAddUserToOrganizationMutation, SystemAddUserToOrganizationMutationVariables>;

/**
 * __useSystemAddUserToOrganizationMutation__
 *
 * To run a mutation, you first call `useSystemAddUserToOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemAddUserToOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemAddUserToOrganizationMutation, { data, loading, error }] = useSystemAddUserToOrganizationMutation({
 *   variables: {
 *      userParams: // value for 'userParams'
 *   },
 * });
 */
export function useSystemAddUserToOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SystemAddUserToOrganizationMutation, SystemAddUserToOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemAddUserToOrganizationMutation, SystemAddUserToOrganizationMutationVariables>(SystemAddUserToOrganizationDocument, options);
      }
export type SystemAddUserToOrganizationMutationHookResult = ReturnType<typeof useSystemAddUserToOrganizationMutation>;
export type SystemAddUserToOrganizationMutationResult = Apollo.MutationResult<SystemAddUserToOrganizationMutation>;
export type SystemAddUserToOrganizationMutationOptions = Apollo.BaseMutationOptions<SystemAddUserToOrganizationMutation, SystemAddUserToOrganizationMutationVariables>;
export const SystemAffiliateGroupDocument = gql`
    query SystemAffiliateGroup($systemAffiliateGroupId: ID!) {
  systemAffiliateGroup(id: $systemAffiliateGroupId) {
    id
    name
    organizations {
      id
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useSystemAffiliateGroupQuery__
 *
 * To run a query within a React component, call `useSystemAffiliateGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemAffiliateGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemAffiliateGroupQuery({
 *   variables: {
 *      systemAffiliateGroupId: // value for 'systemAffiliateGroupId'
 *   },
 * });
 */
export function useSystemAffiliateGroupQuery(baseOptions: Apollo.QueryHookOptions<SystemAffiliateGroupQuery, SystemAffiliateGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemAffiliateGroupQuery, SystemAffiliateGroupQueryVariables>(SystemAffiliateGroupDocument, options);
      }
export function useSystemAffiliateGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemAffiliateGroupQuery, SystemAffiliateGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemAffiliateGroupQuery, SystemAffiliateGroupQueryVariables>(SystemAffiliateGroupDocument, options);
        }
export type SystemAffiliateGroupQueryHookResult = ReturnType<typeof useSystemAffiliateGroupQuery>;
export type SystemAffiliateGroupLazyQueryHookResult = ReturnType<typeof useSystemAffiliateGroupLazyQuery>;
export type SystemAffiliateGroupQueryResult = Apollo.QueryResult<SystemAffiliateGroupQuery, SystemAffiliateGroupQueryVariables>;
export const SystemAffiliateGroupsDocument = gql`
    query SystemAffiliateGroups($pageNumber: Int, $pageItemsCount: Int, $affiliateGroupFilters: AffiliateGroupFilters, $sortField: AffiliateGroupSortField, $sortOrder: SortOrder, $organizationFilters: OrganizationFilters) {
  systemAffiliateGroups(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    affiliateGroupFilters: $affiliateGroupFilters
    sortField: $sortField
    sortOrder: $sortOrder
    organizationFilters: $organizationFilters
  ) {
    nodes {
      id
      name
      createdAt
      updatedAt
      deletedAt
      organizations {
        id
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemAffiliateGroupsQuery__
 *
 * To run a query within a React component, call `useSystemAffiliateGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemAffiliateGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemAffiliateGroupsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      affiliateGroupFilters: // value for 'affiliateGroupFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      organizationFilters: // value for 'organizationFilters'
 *   },
 * });
 */
export function useSystemAffiliateGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SystemAffiliateGroupsQuery, SystemAffiliateGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemAffiliateGroupsQuery, SystemAffiliateGroupsQueryVariables>(SystemAffiliateGroupsDocument, options);
      }
export function useSystemAffiliateGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemAffiliateGroupsQuery, SystemAffiliateGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemAffiliateGroupsQuery, SystemAffiliateGroupsQueryVariables>(SystemAffiliateGroupsDocument, options);
        }
export type SystemAffiliateGroupsQueryHookResult = ReturnType<typeof useSystemAffiliateGroupsQuery>;
export type SystemAffiliateGroupsLazyQueryHookResult = ReturnType<typeof useSystemAffiliateGroupsLazyQuery>;
export type SystemAffiliateGroupsQueryResult = Apollo.QueryResult<SystemAffiliateGroupsQuery, SystemAffiliateGroupsQueryVariables>;
export const SystemAffiliateOrganizationsDocument = gql`
    query SystemAffiliateOrganizations($pageNumber: Int, $pageItemsCount: Int, $filters: AffiliateOrganizationsFilters, $sortField: AffiliateOrganizationSortField, $sortOrder: SortOrder) {
  systemAffiliateOrganizations(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    filters: $filters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      createdAt
      organization {
        id
        cif
        name
      }
      affiliateGroup {
        id
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemAffiliateOrganizationsQuery__
 *
 * To run a query within a React component, call `useSystemAffiliateOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemAffiliateOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemAffiliateOrganizationsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      filters: // value for 'filters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemAffiliateOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<SystemAffiliateOrganizationsQuery, SystemAffiliateOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemAffiliateOrganizationsQuery, SystemAffiliateOrganizationsQueryVariables>(SystemAffiliateOrganizationsDocument, options);
      }
export function useSystemAffiliateOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemAffiliateOrganizationsQuery, SystemAffiliateOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemAffiliateOrganizationsQuery, SystemAffiliateOrganizationsQueryVariables>(SystemAffiliateOrganizationsDocument, options);
        }
export type SystemAffiliateOrganizationsQueryHookResult = ReturnType<typeof useSystemAffiliateOrganizationsQuery>;
export type SystemAffiliateOrganizationsLazyQueryHookResult = ReturnType<typeof useSystemAffiliateOrganizationsLazyQuery>;
export type SystemAffiliateOrganizationsQueryResult = Apollo.QueryResult<SystemAffiliateOrganizationsQuery, SystemAffiliateOrganizationsQueryVariables>;
export const SystemCreateAffiliateGroupDocument = gql`
    mutation SystemCreateAffiliateGroup($input: SystemAffiliateGroupInput!) {
  systemCreateAffiliateGroup(input: $input) {
    id
    name
  }
}
    `;
export type SystemCreateAffiliateGroupMutationFn = Apollo.MutationFunction<SystemCreateAffiliateGroupMutation, SystemCreateAffiliateGroupMutationVariables>;

/**
 * __useSystemCreateAffiliateGroupMutation__
 *
 * To run a mutation, you first call `useSystemCreateAffiliateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemCreateAffiliateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemCreateAffiliateGroupMutation, { data, loading, error }] = useSystemCreateAffiliateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemCreateAffiliateGroupMutation(baseOptions?: Apollo.MutationHookOptions<SystemCreateAffiliateGroupMutation, SystemCreateAffiliateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemCreateAffiliateGroupMutation, SystemCreateAffiliateGroupMutationVariables>(SystemCreateAffiliateGroupDocument, options);
      }
export type SystemCreateAffiliateGroupMutationHookResult = ReturnType<typeof useSystemCreateAffiliateGroupMutation>;
export type SystemCreateAffiliateGroupMutationResult = Apollo.MutationResult<SystemCreateAffiliateGroupMutation>;
export type SystemCreateAffiliateGroupMutationOptions = Apollo.BaseMutationOptions<SystemCreateAffiliateGroupMutation, SystemCreateAffiliateGroupMutationVariables>;
export const SystemAddAffiliateOrganizationDocument = gql`
    mutation SystemAddAffiliateOrganization($input: SystemAffiliateOrganizationInput!) {
  systemAddAffiliateOrganization(input: $input) {
    id
  }
}
    `;
export type SystemAddAffiliateOrganizationMutationFn = Apollo.MutationFunction<SystemAddAffiliateOrganizationMutation, SystemAddAffiliateOrganizationMutationVariables>;

/**
 * __useSystemAddAffiliateOrganizationMutation__
 *
 * To run a mutation, you first call `useSystemAddAffiliateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemAddAffiliateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemAddAffiliateOrganizationMutation, { data, loading, error }] = useSystemAddAffiliateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemAddAffiliateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SystemAddAffiliateOrganizationMutation, SystemAddAffiliateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemAddAffiliateOrganizationMutation, SystemAddAffiliateOrganizationMutationVariables>(SystemAddAffiliateOrganizationDocument, options);
      }
export type SystemAddAffiliateOrganizationMutationHookResult = ReturnType<typeof useSystemAddAffiliateOrganizationMutation>;
export type SystemAddAffiliateOrganizationMutationResult = Apollo.MutationResult<SystemAddAffiliateOrganizationMutation>;
export type SystemAddAffiliateOrganizationMutationOptions = Apollo.BaseMutationOptions<SystemAddAffiliateOrganizationMutation, SystemAddAffiliateOrganizationMutationVariables>;
export const SystemCreateDocumentDocument = gql`
    mutation SystemCreateDocument($documentParams: CreateDocumentInput) {
  systemCreateDocument(documentParams: $documentParams) {
    id
    category
  }
}
    `;
export type SystemCreateDocumentMutationFn = Apollo.MutationFunction<SystemCreateDocumentMutation, SystemCreateDocumentMutationVariables>;

/**
 * __useSystemCreateDocumentMutation__
 *
 * To run a mutation, you first call `useSystemCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemCreateDocumentMutation, { data, loading, error }] = useSystemCreateDocumentMutation({
 *   variables: {
 *      documentParams: // value for 'documentParams'
 *   },
 * });
 */
export function useSystemCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SystemCreateDocumentMutation, SystemCreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemCreateDocumentMutation, SystemCreateDocumentMutationVariables>(SystemCreateDocumentDocument, options);
      }
export type SystemCreateDocumentMutationHookResult = ReturnType<typeof useSystemCreateDocumentMutation>;
export type SystemCreateDocumentMutationResult = Apollo.MutationResult<SystemCreateDocumentMutation>;
export type SystemCreateDocumentMutationOptions = Apollo.BaseMutationOptions<SystemCreateDocumentMutation, SystemCreateDocumentMutationVariables>;
export const SystemCreateOrganizationDocument = gql`
    mutation SystemCreateOrganization($organization: SystemOrganizationInput) {
  systemCreateOrganization(organization: $organization) {
    addressLine1
    addressLine2
    city
    country
    createdAt
    id
    imageUrl
    legalName
    name
    paidSubscription
    owned
    phone
    state
    updatedAt
    zip
    userRoles {
      createdAt
      id
      owner
      updatedAt
      user {
        id
      }
    }
  }
}
    `;
export type SystemCreateOrganizationMutationFn = Apollo.MutationFunction<SystemCreateOrganizationMutation, SystemCreateOrganizationMutationVariables>;

/**
 * __useSystemCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useSystemCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemCreateOrganizationMutation, { data, loading, error }] = useSystemCreateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *   },
 * });
 */
export function useSystemCreateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SystemCreateOrganizationMutation, SystemCreateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemCreateOrganizationMutation, SystemCreateOrganizationMutationVariables>(SystemCreateOrganizationDocument, options);
      }
export type SystemCreateOrganizationMutationHookResult = ReturnType<typeof useSystemCreateOrganizationMutation>;
export type SystemCreateOrganizationMutationResult = Apollo.MutationResult<SystemCreateOrganizationMutation>;
export type SystemCreateOrganizationMutationOptions = Apollo.BaseMutationOptions<SystemCreateOrganizationMutation, SystemCreateOrganizationMutationVariables>;
export const SystemCreateOrganizationMailingRecipientDocument = gql`
    mutation systemCreateOrganizationMailingRecipient($organizationId: ID!, $recipient: SystemOrganizationMailingRecipient!) {
  systemCreateOrganizationMailingRecipient(
    organizationId: $organizationId
    recipient: $recipient
  ) {
    firstName
    lastName
    email
  }
}
    `;
export type SystemCreateOrganizationMailingRecipientMutationFn = Apollo.MutationFunction<SystemCreateOrganizationMailingRecipientMutation, SystemCreateOrganizationMailingRecipientMutationVariables>;

/**
 * __useSystemCreateOrganizationMailingRecipientMutation__
 *
 * To run a mutation, you first call `useSystemCreateOrganizationMailingRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemCreateOrganizationMailingRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemCreateOrganizationMailingRecipientMutation, { data, loading, error }] = useSystemCreateOrganizationMailingRecipientMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      recipient: // value for 'recipient'
 *   },
 * });
 */
export function useSystemCreateOrganizationMailingRecipientMutation(baseOptions?: Apollo.MutationHookOptions<SystemCreateOrganizationMailingRecipientMutation, SystemCreateOrganizationMailingRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemCreateOrganizationMailingRecipientMutation, SystemCreateOrganizationMailingRecipientMutationVariables>(SystemCreateOrganizationMailingRecipientDocument, options);
      }
export type SystemCreateOrganizationMailingRecipientMutationHookResult = ReturnType<typeof useSystemCreateOrganizationMailingRecipientMutation>;
export type SystemCreateOrganizationMailingRecipientMutationResult = Apollo.MutationResult<SystemCreateOrganizationMailingRecipientMutation>;
export type SystemCreateOrganizationMailingRecipientMutationOptions = Apollo.BaseMutationOptions<SystemCreateOrganizationMailingRecipientMutation, SystemCreateOrganizationMailingRecipientMutationVariables>;
export const SystemCreateRiskDocument = gql`
    mutation SystemCreateRisk($input: RiskInput) {
  systemCreateRisk(input: $input) {
    id
  }
}
    `;
export type SystemCreateRiskMutationFn = Apollo.MutationFunction<SystemCreateRiskMutation, SystemCreateRiskMutationVariables>;

/**
 * __useSystemCreateRiskMutation__
 *
 * To run a mutation, you first call `useSystemCreateRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemCreateRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemCreateRiskMutation, { data, loading, error }] = useSystemCreateRiskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemCreateRiskMutation(baseOptions?: Apollo.MutationHookOptions<SystemCreateRiskMutation, SystemCreateRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemCreateRiskMutation, SystemCreateRiskMutationVariables>(SystemCreateRiskDocument, options);
      }
export type SystemCreateRiskMutationHookResult = ReturnType<typeof useSystemCreateRiskMutation>;
export type SystemCreateRiskMutationResult = Apollo.MutationResult<SystemCreateRiskMutation>;
export type SystemCreateRiskMutationOptions = Apollo.BaseMutationOptions<SystemCreateRiskMutation, SystemCreateRiskMutationVariables>;
export const SystemCreateTaskDocument = gql`
    mutation SystemCreateTask($task: TaskInput!) {
  systemCreateTask(task: $task) {
    id
  }
}
    `;
export type SystemCreateTaskMutationFn = Apollo.MutationFunction<SystemCreateTaskMutation, SystemCreateTaskMutationVariables>;

/**
 * __useSystemCreateTaskMutation__
 *
 * To run a mutation, you first call `useSystemCreateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemCreateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemCreateTaskMutation, { data, loading, error }] = useSystemCreateTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useSystemCreateTaskMutation(baseOptions?: Apollo.MutationHookOptions<SystemCreateTaskMutation, SystemCreateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemCreateTaskMutation, SystemCreateTaskMutationVariables>(SystemCreateTaskDocument, options);
      }
export type SystemCreateTaskMutationHookResult = ReturnType<typeof useSystemCreateTaskMutation>;
export type SystemCreateTaskMutationResult = Apollo.MutationResult<SystemCreateTaskMutation>;
export type SystemCreateTaskMutationOptions = Apollo.BaseMutationOptions<SystemCreateTaskMutation, SystemCreateTaskMutationVariables>;
export const SystemCustomNotificationsDocument = gql`
    query SystemCustomNotifications($pageNumber: Int, $pageItemsCount: Int, $status: CustomNotificationStatus) {
  systemCustomNotifications(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    status: $status
  ) {
    nodes {
      id
      emailSubject
      status
      sentAt
      createdAt
      dealerships {
        id
        name
      }
      recipients(pageNumber: 1, pageItemsCount: 1) {
        totalCount
      }
      createdBy {
        id
        firstName
        lastName
      }
      sentBy {
        id
        firstName
        lastName
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemCustomNotificationsQuery__
 *
 * To run a query within a React component, call `useSystemCustomNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemCustomNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemCustomNotificationsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSystemCustomNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<SystemCustomNotificationsQuery, SystemCustomNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemCustomNotificationsQuery, SystemCustomNotificationsQueryVariables>(SystemCustomNotificationsDocument, options);
      }
export function useSystemCustomNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemCustomNotificationsQuery, SystemCustomNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemCustomNotificationsQuery, SystemCustomNotificationsQueryVariables>(SystemCustomNotificationsDocument, options);
        }
export type SystemCustomNotificationsQueryHookResult = ReturnType<typeof useSystemCustomNotificationsQuery>;
export type SystemCustomNotificationsLazyQueryHookResult = ReturnType<typeof useSystemCustomNotificationsLazyQuery>;
export type SystemCustomNotificationsQueryResult = Apollo.QueryResult<SystemCustomNotificationsQuery, SystemCustomNotificationsQueryVariables>;
export const SystemCustomNotificationDocument = gql`
    query SystemCustomNotification($id: ID!) {
  systemCustomNotification(id: $id) {
    id
    emailSubject
    emailBody
    status
    sentAt
    createdAt
    updatedAt
    vendor {
      id
      businessName
    }
    dealerships {
      id
      name
      cif
    }
    createdBy {
      id
      firstName
      lastName
    }
    sentBy {
      id
      firstName
      lastName
    }
    recipients(pageNumber: 1, pageItemsCount: 200) {
      nodes {
        id
        firstName
        lastName
        emailAddress
        organization {
          id
          name
          cif
        }
      }
      totalCount
    }
  }
}
    `;

/**
 * __useSystemCustomNotificationQuery__
 *
 * To run a query within a React component, call `useSystemCustomNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemCustomNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemCustomNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemCustomNotificationQuery(baseOptions: Apollo.QueryHookOptions<SystemCustomNotificationQuery, SystemCustomNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemCustomNotificationQuery, SystemCustomNotificationQueryVariables>(SystemCustomNotificationDocument, options);
      }
export function useSystemCustomNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemCustomNotificationQuery, SystemCustomNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemCustomNotificationQuery, SystemCustomNotificationQueryVariables>(SystemCustomNotificationDocument, options);
        }
export type SystemCustomNotificationQueryHookResult = ReturnType<typeof useSystemCustomNotificationQuery>;
export type SystemCustomNotificationLazyQueryHookResult = ReturnType<typeof useSystemCustomNotificationLazyQuery>;
export type SystemCustomNotificationQueryResult = Apollo.QueryResult<SystemCustomNotificationQuery, SystemCustomNotificationQueryVariables>;
export const SystemCreateCustomNotificationDraftDocument = gql`
    mutation SystemCreateCustomNotificationDraft($input: CreateCustomNotificationDraftInput!) {
  systemCreateCustomNotificationDraft(input: $input) {
    id
  }
}
    `;
export type SystemCreateCustomNotificationDraftMutationFn = Apollo.MutationFunction<SystemCreateCustomNotificationDraftMutation, SystemCreateCustomNotificationDraftMutationVariables>;

/**
 * __useSystemCreateCustomNotificationDraftMutation__
 *
 * To run a mutation, you first call `useSystemCreateCustomNotificationDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemCreateCustomNotificationDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemCreateCustomNotificationDraftMutation, { data, loading, error }] = useSystemCreateCustomNotificationDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemCreateCustomNotificationDraftMutation(baseOptions?: Apollo.MutationHookOptions<SystemCreateCustomNotificationDraftMutation, SystemCreateCustomNotificationDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemCreateCustomNotificationDraftMutation, SystemCreateCustomNotificationDraftMutationVariables>(SystemCreateCustomNotificationDraftDocument, options);
      }
export type SystemCreateCustomNotificationDraftMutationHookResult = ReturnType<typeof useSystemCreateCustomNotificationDraftMutation>;
export type SystemCreateCustomNotificationDraftMutationResult = Apollo.MutationResult<SystemCreateCustomNotificationDraftMutation>;
export type SystemCreateCustomNotificationDraftMutationOptions = Apollo.BaseMutationOptions<SystemCreateCustomNotificationDraftMutation, SystemCreateCustomNotificationDraftMutationVariables>;
export const SystemUpdateCustomNotificationDraftDocument = gql`
    mutation SystemUpdateCustomNotificationDraft($id: ID!, $input: UpdateCustomNotificationDraftInput!) {
  systemUpdateCustomNotificationDraft(id: $id, input: $input) {
    id
    emailSubject
    emailBody
    dealerships {
      id
      name
      cif
    }
  }
}
    `;
export type SystemUpdateCustomNotificationDraftMutationFn = Apollo.MutationFunction<SystemUpdateCustomNotificationDraftMutation, SystemUpdateCustomNotificationDraftMutationVariables>;

/**
 * __useSystemUpdateCustomNotificationDraftMutation__
 *
 * To run a mutation, you first call `useSystemUpdateCustomNotificationDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateCustomNotificationDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateCustomNotificationDraftMutation, { data, loading, error }] = useSystemUpdateCustomNotificationDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemUpdateCustomNotificationDraftMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateCustomNotificationDraftMutation, SystemUpdateCustomNotificationDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateCustomNotificationDraftMutation, SystemUpdateCustomNotificationDraftMutationVariables>(SystemUpdateCustomNotificationDraftDocument, options);
      }
export type SystemUpdateCustomNotificationDraftMutationHookResult = ReturnType<typeof useSystemUpdateCustomNotificationDraftMutation>;
export type SystemUpdateCustomNotificationDraftMutationResult = Apollo.MutationResult<SystemUpdateCustomNotificationDraftMutation>;
export type SystemUpdateCustomNotificationDraftMutationOptions = Apollo.BaseMutationOptions<SystemUpdateCustomNotificationDraftMutation, SystemUpdateCustomNotificationDraftMutationVariables>;
export const SystemDeleteCustomNotificationDraftDocument = gql`
    mutation SystemDeleteCustomNotificationDraft($id: ID!) {
  systemDeleteCustomNotificationDraft(id: $id)
}
    `;
export type SystemDeleteCustomNotificationDraftMutationFn = Apollo.MutationFunction<SystemDeleteCustomNotificationDraftMutation, SystemDeleteCustomNotificationDraftMutationVariables>;

/**
 * __useSystemDeleteCustomNotificationDraftMutation__
 *
 * To run a mutation, you first call `useSystemDeleteCustomNotificationDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemDeleteCustomNotificationDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemDeleteCustomNotificationDraftMutation, { data, loading, error }] = useSystemDeleteCustomNotificationDraftMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemDeleteCustomNotificationDraftMutation(baseOptions?: Apollo.MutationHookOptions<SystemDeleteCustomNotificationDraftMutation, SystemDeleteCustomNotificationDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemDeleteCustomNotificationDraftMutation, SystemDeleteCustomNotificationDraftMutationVariables>(SystemDeleteCustomNotificationDraftDocument, options);
      }
export type SystemDeleteCustomNotificationDraftMutationHookResult = ReturnType<typeof useSystemDeleteCustomNotificationDraftMutation>;
export type SystemDeleteCustomNotificationDraftMutationResult = Apollo.MutationResult<SystemDeleteCustomNotificationDraftMutation>;
export type SystemDeleteCustomNotificationDraftMutationOptions = Apollo.BaseMutationOptions<SystemDeleteCustomNotificationDraftMutation, SystemDeleteCustomNotificationDraftMutationVariables>;
export const SystemSendCustomNotificationDocument = gql`
    mutation SystemSendCustomNotification($id: ID!) {
  systemSendCustomNotification(id: $id) {
    id
    status
    sentAt
  }
}
    `;
export type SystemSendCustomNotificationMutationFn = Apollo.MutationFunction<SystemSendCustomNotificationMutation, SystemSendCustomNotificationMutationVariables>;

/**
 * __useSystemSendCustomNotificationMutation__
 *
 * To run a mutation, you first call `useSystemSendCustomNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemSendCustomNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemSendCustomNotificationMutation, { data, loading, error }] = useSystemSendCustomNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemSendCustomNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SystemSendCustomNotificationMutation, SystemSendCustomNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemSendCustomNotificationMutation, SystemSendCustomNotificationMutationVariables>(SystemSendCustomNotificationDocument, options);
      }
export type SystemSendCustomNotificationMutationHookResult = ReturnType<typeof useSystemSendCustomNotificationMutation>;
export type SystemSendCustomNotificationMutationResult = Apollo.MutationResult<SystemSendCustomNotificationMutation>;
export type SystemSendCustomNotificationMutationOptions = Apollo.BaseMutationOptions<SystemSendCustomNotificationMutation, SystemSendCustomNotificationMutationVariables>;
export const SystemDeactivateOrganizationDocument = gql`
    mutation SystemDeactivateOrganization($id: ID!) {
  systemDeactivateOrganization(id: $id) {
    id
  }
}
    `;
export type SystemDeactivateOrganizationMutationFn = Apollo.MutationFunction<SystemDeactivateOrganizationMutation, SystemDeactivateOrganizationMutationVariables>;

/**
 * __useSystemDeactivateOrganizationMutation__
 *
 * To run a mutation, you first call `useSystemDeactivateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemDeactivateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemDeactivateOrganizationMutation, { data, loading, error }] = useSystemDeactivateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemDeactivateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SystemDeactivateOrganizationMutation, SystemDeactivateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemDeactivateOrganizationMutation, SystemDeactivateOrganizationMutationVariables>(SystemDeactivateOrganizationDocument, options);
      }
export type SystemDeactivateOrganizationMutationHookResult = ReturnType<typeof useSystemDeactivateOrganizationMutation>;
export type SystemDeactivateOrganizationMutationResult = Apollo.MutationResult<SystemDeactivateOrganizationMutation>;
export type SystemDeactivateOrganizationMutationOptions = Apollo.BaseMutationOptions<SystemDeactivateOrganizationMutation, SystemDeactivateOrganizationMutationVariables>;
export const SystemDealershipsOverviewDocument = gql`
    query SystemDealershipsOverview($pageNumber: Int, $pageItemsCount: Int, $organizationFilters: OrganizationFilters, $infoSecurityFilters: TypedPoliciesSubqueryFilters, $incidentResponseFilters: TypedPoliciesSubqueryFilters, $userSecurityFilters: TypedPoliciesSubqueryFilters, $technologySecurityFilters: TypedPoliciesSubqueryFilters, $vulnerabilityScanFilters: OrganizationDocumentSubqueryFilters, $penetrationTestFilters: OrganizationDocumentSubqueryFilters, $executiveReportFilters: OrganizationExecutiveReportSubqueryFilters, $riskAssessmentFilters: OrganizationRiskAssessmentSubqueryFilters, $sortField: OrganizationSortFieldEnum, $sortOrder: SortOrder) {
  systemOrganizations(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    organizationFilters: $organizationFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      cif
      name
      accountType
      sentinelOneSiteId
      knowBe4Key
      infoSecurityPolicies(infoSecurityFilters: $infoSecurityFilters) {
        id
        isDraft
        expiredAt
      }
      incidentResponsePolicies(incidentResponseFilters: $incidentResponseFilters) {
        id
        isDraft
        expiredAt
      }
      userSecurityPolicies(userSecurityFilters: $userSecurityFilters) {
        id
        isDraft
        expiredAt
      }
      technologySecurityPolicies(
        technologySecurityFilters: $technologySecurityFilters
      ) {
        id
        isDraft
        expiredAt
      }
      vulnerabilityScans(vulnerabilityScanFilters: $vulnerabilityScanFilters) {
        id
        conductedAt
        expiresAt
      }
      penetrationTests(penetrationTestFilters: $penetrationTestFilters) {
        id
        conductedAt
        expiresAt
      }
      executiveReports(executiveReportFilters: $executiveReportFilters) {
        id
        isDraft
        expiredAt
      }
      riskAssessments(riskAssessmentFilters: $riskAssessmentFilters) {
        status
      }
      vendorOrganizations {
        id
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemDealershipsOverviewQuery__
 *
 * To run a query within a React component, call `useSystemDealershipsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemDealershipsOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemDealershipsOverviewQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      organizationFilters: // value for 'organizationFilters'
 *      infoSecurityFilters: // value for 'infoSecurityFilters'
 *      incidentResponseFilters: // value for 'incidentResponseFilters'
 *      userSecurityFilters: // value for 'userSecurityFilters'
 *      technologySecurityFilters: // value for 'technologySecurityFilters'
 *      vulnerabilityScanFilters: // value for 'vulnerabilityScanFilters'
 *      penetrationTestFilters: // value for 'penetrationTestFilters'
 *      executiveReportFilters: // value for 'executiveReportFilters'
 *      riskAssessmentFilters: // value for 'riskAssessmentFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemDealershipsOverviewQuery(baseOptions?: Apollo.QueryHookOptions<SystemDealershipsOverviewQuery, SystemDealershipsOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemDealershipsOverviewQuery, SystemDealershipsOverviewQueryVariables>(SystemDealershipsOverviewDocument, options);
      }
export function useSystemDealershipsOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemDealershipsOverviewQuery, SystemDealershipsOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemDealershipsOverviewQuery, SystemDealershipsOverviewQueryVariables>(SystemDealershipsOverviewDocument, options);
        }
export type SystemDealershipsOverviewQueryHookResult = ReturnType<typeof useSystemDealershipsOverviewQuery>;
export type SystemDealershipsOverviewLazyQueryHookResult = ReturnType<typeof useSystemDealershipsOverviewLazyQuery>;
export type SystemDealershipsOverviewQueryResult = Apollo.QueryResult<SystemDealershipsOverviewQuery, SystemDealershipsOverviewQueryVariables>;
export const SystemDeleteOrganizationDocument = gql`
    mutation SystemDeleteOrganization($id: ID!) {
  systemDeleteOrganization(id: $id) {
    id
  }
}
    `;
export type SystemDeleteOrganizationMutationFn = Apollo.MutationFunction<SystemDeleteOrganizationMutation, SystemDeleteOrganizationMutationVariables>;

/**
 * __useSystemDeleteOrganizationMutation__
 *
 * To run a mutation, you first call `useSystemDeleteOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemDeleteOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemDeleteOrganizationMutation, { data, loading, error }] = useSystemDeleteOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemDeleteOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SystemDeleteOrganizationMutation, SystemDeleteOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemDeleteOrganizationMutation, SystemDeleteOrganizationMutationVariables>(SystemDeleteOrganizationDocument, options);
      }
export type SystemDeleteOrganizationMutationHookResult = ReturnType<typeof useSystemDeleteOrganizationMutation>;
export type SystemDeleteOrganizationMutationResult = Apollo.MutationResult<SystemDeleteOrganizationMutation>;
export type SystemDeleteOrganizationMutationOptions = Apollo.BaseMutationOptions<SystemDeleteOrganizationMutation, SystemDeleteOrganizationMutationVariables>;
export const SystemDocumentDocument = gql`
    query SystemDocument($documentId: ID!) {
  systemDocument(documentId: $documentId) {
    id
    title
    uploadedByUser {
      firstName
      lastName
      id
      email
    }
    category
    expiresAt
    description
    createdAt
    conductedAt
  }
}
    `;

/**
 * __useSystemDocumentQuery__
 *
 * To run a query within a React component, call `useSystemDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemDocumentQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useSystemDocumentQuery(baseOptions: Apollo.QueryHookOptions<SystemDocumentQuery, SystemDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemDocumentQuery, SystemDocumentQueryVariables>(SystemDocumentDocument, options);
      }
export function useSystemDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemDocumentQuery, SystemDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemDocumentQuery, SystemDocumentQueryVariables>(SystemDocumentDocument, options);
        }
export type SystemDocumentQueryHookResult = ReturnType<typeof useSystemDocumentQuery>;
export type SystemDocumentLazyQueryHookResult = ReturnType<typeof useSystemDocumentLazyQuery>;
export type SystemDocumentQueryResult = Apollo.QueryResult<SystemDocumentQuery, SystemDocumentQueryVariables>;
export const SystemDocumentOrganizationsDocument = gql`
    query SystemDocumentOrganizations($pageNumber: Int, $pageItemsCount: Int, $sortField: DocumentOrganizationSortFieldEnum, $sortOrder: SortOrder, $documentFilters: DocumentFilters, $organizationFilters: OrganizationFilters) {
  systemDocumentOrganizations(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    sortField: $sortField
    sortOrder: $sortOrder
    documentFilters: $documentFilters
    organizationFilters: $organizationFilters
  ) {
    nodes {
      id
      organization {
        id
        cif
        name
      }
      document {
        id
        title
        category
        description
      }
    }
    pageInfo {
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useSystemDocumentOrganizationsQuery__
 *
 * To run a query within a React component, call `useSystemDocumentOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemDocumentOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemDocumentOrganizationsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      documentFilters: // value for 'documentFilters'
 *      organizationFilters: // value for 'organizationFilters'
 *   },
 * });
 */
export function useSystemDocumentOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<SystemDocumentOrganizationsQuery, SystemDocumentOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemDocumentOrganizationsQuery, SystemDocumentOrganizationsQueryVariables>(SystemDocumentOrganizationsDocument, options);
      }
export function useSystemDocumentOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemDocumentOrganizationsQuery, SystemDocumentOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemDocumentOrganizationsQuery, SystemDocumentOrganizationsQueryVariables>(SystemDocumentOrganizationsDocument, options);
        }
export type SystemDocumentOrganizationsQueryHookResult = ReturnType<typeof useSystemDocumentOrganizationsQuery>;
export type SystemDocumentOrganizationsLazyQueryHookResult = ReturnType<typeof useSystemDocumentOrganizationsLazyQuery>;
export type SystemDocumentOrganizationsQueryResult = Apollo.QueryResult<SystemDocumentOrganizationsQuery, SystemDocumentOrganizationsQueryVariables>;
export const SystemDocumentsDocument = gql`
    query SystemDocuments($pageNumber: Int, $pageItemsCount: Int, $documentFilters: SystemDocumentFilters, $sortFields: [DocumentFieldSortFieldEnum], $sortOrder: SortOrder) {
  systemDocuments(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    documentFilters: $documentFilters
    sortFields: $sortFields
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      title
      category
      createdAt
      expiresAt
      conductedAt
    }
    totalCount
  }
}
    `;

/**
 * __useSystemDocumentsQuery__
 *
 * To run a query within a React component, call `useSystemDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemDocumentsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      documentFilters: // value for 'documentFilters'
 *      sortFields: // value for 'sortFields'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<SystemDocumentsQuery, SystemDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemDocumentsQuery, SystemDocumentsQueryVariables>(SystemDocumentsDocument, options);
      }
export function useSystemDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemDocumentsQuery, SystemDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemDocumentsQuery, SystemDocumentsQueryVariables>(SystemDocumentsDocument, options);
        }
export type SystemDocumentsQueryHookResult = ReturnType<typeof useSystemDocumentsQuery>;
export type SystemDocumentsLazyQueryHookResult = ReturnType<typeof useSystemDocumentsLazyQuery>;
export type SystemDocumentsQueryResult = Apollo.QueryResult<SystemDocumentsQuery, SystemDocumentsQueryVariables>;
export const SystemExecutiveReportsDocument = gql`
    query SystemExecutiveReports($pageNumber: Int, $pageItemsCount: Int, $sortOrder: SortOrder, $sortField: ExecutiveReportFieldSortField, $executiveReportFilters: ExecutiveReportFilters) {
  systemExecutiveReports(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    sortOrder: $sortOrder
    sortField: $sortField
    executiveReportFilters: $executiveReportFilters
  ) {
    nodes {
      id
      expiredAt
      createdAt
      isDraft
    }
    totalCount
  }
}
    `;

/**
 * __useSystemExecutiveReportsQuery__
 *
 * To run a query within a React component, call `useSystemExecutiveReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemExecutiveReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemExecutiveReportsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      sortOrder: // value for 'sortOrder'
 *      sortField: // value for 'sortField'
 *      executiveReportFilters: // value for 'executiveReportFilters'
 *   },
 * });
 */
export function useSystemExecutiveReportsQuery(baseOptions?: Apollo.QueryHookOptions<SystemExecutiveReportsQuery, SystemExecutiveReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemExecutiveReportsQuery, SystemExecutiveReportsQueryVariables>(SystemExecutiveReportsDocument, options);
      }
export function useSystemExecutiveReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemExecutiveReportsQuery, SystemExecutiveReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemExecutiveReportsQuery, SystemExecutiveReportsQueryVariables>(SystemExecutiveReportsDocument, options);
        }
export type SystemExecutiveReportsQueryHookResult = ReturnType<typeof useSystemExecutiveReportsQuery>;
export type SystemExecutiveReportsLazyQueryHookResult = ReturnType<typeof useSystemExecutiveReportsLazyQuery>;
export type SystemExecutiveReportsQueryResult = Apollo.QueryResult<SystemExecutiveReportsQuery, SystemExecutiveReportsQueryVariables>;
export const SystemNavigationEventsDocument = gql`
    query SystemNavigationEvents($pageNumber: Int, $pageItemsCount: Int, $userFilters: UserFilters, $sortField: NavigationEventSortField, $sortOrder: SortOrder, $filters: NavigationEventFilters) {
  systemNavigationEvents(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    userFilters: $userFilters
    sortField: $sortField
    sortOrder: $sortOrder
    filters: $filters
  ) {
    nodes {
      createdAt
      fromPathname
      toPathname
      user {
        id
        email
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemNavigationEventsQuery__
 *
 * To run a query within a React component, call `useSystemNavigationEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemNavigationEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemNavigationEventsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      userFilters: // value for 'userFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSystemNavigationEventsQuery(baseOptions?: Apollo.QueryHookOptions<SystemNavigationEventsQuery, SystemNavigationEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemNavigationEventsQuery, SystemNavigationEventsQueryVariables>(SystemNavigationEventsDocument, options);
      }
export function useSystemNavigationEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemNavigationEventsQuery, SystemNavigationEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemNavigationEventsQuery, SystemNavigationEventsQueryVariables>(SystemNavigationEventsDocument, options);
        }
export type SystemNavigationEventsQueryHookResult = ReturnType<typeof useSystemNavigationEventsQuery>;
export type SystemNavigationEventsLazyQueryHookResult = ReturnType<typeof useSystemNavigationEventsLazyQuery>;
export type SystemNavigationEventsQueryResult = Apollo.QueryResult<SystemNavigationEventsQuery, SystemNavigationEventsQueryVariables>;
export const SystemOperatingSystemsDocument = gql`
    query SystemOperatingSystems($pageNumber: Int, $pageItemsCount: Int, $operatingSystemFilters: OperatingSystemFilters, $sortField: [OperatingSystemSortField], $sortOrder: SortOrder) {
  systemOperatingSystems(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    operatingSystemFilters: $operatingSystemFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      createdAt
      deletedAt
      name
      revision
      status
      updatedAt
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useSystemOperatingSystemsQuery__
 *
 * To run a query within a React component, call `useSystemOperatingSystemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemOperatingSystemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemOperatingSystemsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      operatingSystemFilters: // value for 'operatingSystemFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemOperatingSystemsQuery(baseOptions?: Apollo.QueryHookOptions<SystemOperatingSystemsQuery, SystemOperatingSystemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemOperatingSystemsQuery, SystemOperatingSystemsQueryVariables>(SystemOperatingSystemsDocument, options);
      }
export function useSystemOperatingSystemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemOperatingSystemsQuery, SystemOperatingSystemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemOperatingSystemsQuery, SystemOperatingSystemsQueryVariables>(SystemOperatingSystemsDocument, options);
        }
export type SystemOperatingSystemsQueryHookResult = ReturnType<typeof useSystemOperatingSystemsQuery>;
export type SystemOperatingSystemsLazyQueryHookResult = ReturnType<typeof useSystemOperatingSystemsLazyQuery>;
export type SystemOperatingSystemsQueryResult = Apollo.QueryResult<SystemOperatingSystemsQuery, SystemOperatingSystemsQueryVariables>;
export const SystemOrganizationDocument = gql`
    query SystemOrganization($id: ID!) {
  systemOrganization(id: $id) {
    addressLine1
    addressLine2
    city
    country
    createdAt
    id
    cif
    sentinelOneSiteId
    knowBe4Key
    imageUrl
    legalName
    name
    paidSubscription
    owned
    phone
    state
    updatedAt
    zip
    accountType
    archivedAt
    billingStartedAt
    modalsMutedAt
    userRoles {
      createdAt
      id
      owner
      user {
        id
      }
    }
    notificationSettings {
      deviceManagementReport {
        enabled
        frequency
        sendTo
        notificationType
      }
      documentUpload {
        enabled
        frequency
        sendTo
        notificationType
      }
      pendingActionItemsReport {
        enabled
        frequency
        sendTo
        notificationType
      }
      securityResponseReport {
        enabled
        frequency
        sendTo
        notificationType
      }
      trainingAndPhishingReport {
        enabled
        frequency
        sendTo
        notificationType
      }
    }
  }
}
    `;

/**
 * __useSystemOrganizationQuery__
 *
 * To run a query within a React component, call `useSystemOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemOrganizationQuery(baseOptions: Apollo.QueryHookOptions<SystemOrganizationQuery, SystemOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemOrganizationQuery, SystemOrganizationQueryVariables>(SystemOrganizationDocument, options);
      }
export function useSystemOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemOrganizationQuery, SystemOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemOrganizationQuery, SystemOrganizationQueryVariables>(SystemOrganizationDocument, options);
        }
export type SystemOrganizationQueryHookResult = ReturnType<typeof useSystemOrganizationQuery>;
export type SystemOrganizationLazyQueryHookResult = ReturnType<typeof useSystemOrganizationLazyQuery>;
export type SystemOrganizationQueryResult = Apollo.QueryResult<SystemOrganizationQuery, SystemOrganizationQueryVariables>;
export const SystemOrganizationCustomNotificationsDocument = gql`
    query SystemOrganizationCustomNotifications($organizationId: ID!) {
  systemOrganizationCustomNotifications(organizationId: $organizationId) {
    id
    emailSubject
    status
    sentAt
    createdAt
  }
}
    `;

/**
 * __useSystemOrganizationCustomNotificationsQuery__
 *
 * To run a query within a React component, call `useSystemOrganizationCustomNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemOrganizationCustomNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemOrganizationCustomNotificationsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSystemOrganizationCustomNotificationsQuery(baseOptions: Apollo.QueryHookOptions<SystemOrganizationCustomNotificationsQuery, SystemOrganizationCustomNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemOrganizationCustomNotificationsQuery, SystemOrganizationCustomNotificationsQueryVariables>(SystemOrganizationCustomNotificationsDocument, options);
      }
export function useSystemOrganizationCustomNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemOrganizationCustomNotificationsQuery, SystemOrganizationCustomNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemOrganizationCustomNotificationsQuery, SystemOrganizationCustomNotificationsQueryVariables>(SystemOrganizationCustomNotificationsDocument, options);
        }
export type SystemOrganizationCustomNotificationsQueryHookResult = ReturnType<typeof useSystemOrganizationCustomNotificationsQuery>;
export type SystemOrganizationCustomNotificationsLazyQueryHookResult = ReturnType<typeof useSystemOrganizationCustomNotificationsLazyQuery>;
export type SystemOrganizationCustomNotificationsQueryResult = Apollo.QueryResult<SystemOrganizationCustomNotificationsQuery, SystemOrganizationCustomNotificationsQueryVariables>;
export const SystemOrganizationMailingRecipientsDocument = gql`
    query SystemOrganizationMailingRecipients($pageNumber: Int, $pageItemsCount: Int, $mailingRecipientFilters: OrganizationMailingRecipientFilters, $sortField: MailingRecipientSortField, $sortOrder: SortOrder) {
  systemOrganizationMailingRecipients(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    mailingRecipientFilters: $mailingRecipientFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      firstName
      lastName
      email
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useSystemOrganizationMailingRecipientsQuery__
 *
 * To run a query within a React component, call `useSystemOrganizationMailingRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemOrganizationMailingRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemOrganizationMailingRecipientsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      mailingRecipientFilters: // value for 'mailingRecipientFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemOrganizationMailingRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<SystemOrganizationMailingRecipientsQuery, SystemOrganizationMailingRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemOrganizationMailingRecipientsQuery, SystemOrganizationMailingRecipientsQueryVariables>(SystemOrganizationMailingRecipientsDocument, options);
      }
export function useSystemOrganizationMailingRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemOrganizationMailingRecipientsQuery, SystemOrganizationMailingRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemOrganizationMailingRecipientsQuery, SystemOrganizationMailingRecipientsQueryVariables>(SystemOrganizationMailingRecipientsDocument, options);
        }
export type SystemOrganizationMailingRecipientsQueryHookResult = ReturnType<typeof useSystemOrganizationMailingRecipientsQuery>;
export type SystemOrganizationMailingRecipientsLazyQueryHookResult = ReturnType<typeof useSystemOrganizationMailingRecipientsLazyQuery>;
export type SystemOrganizationMailingRecipientsQueryResult = Apollo.QueryResult<SystemOrganizationMailingRecipientsQuery, SystemOrganizationMailingRecipientsQueryVariables>;
export const SystemOrganizationsDocument = gql`
    query SystemOrganizations($pageNumber: Int, $pageItemsCount: Int, $organizationFilters: OrganizationFilters, $sortField: OrganizationSortFieldEnum, $sortOrder: SortOrder) {
  systemOrganizations(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    organizationFilters: $organizationFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    totalCount
    nodes {
      addressLine1
      addressLine2
      city
      country
      createdAt
      id
      cif
      imageUrl
      legalName
      name
      paidSubscription
      owned
      phone
      state
      updatedAt
      modalsMutedAt
      zip
      userRoles {
        createdAt
        id
        owner
        updatedAt
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useSystemOrganizationsQuery__
 *
 * To run a query within a React component, call `useSystemOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemOrganizationsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      organizationFilters: // value for 'organizationFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<SystemOrganizationsQuery, SystemOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemOrganizationsQuery, SystemOrganizationsQueryVariables>(SystemOrganizationsDocument, options);
      }
export function useSystemOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemOrganizationsQuery, SystemOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemOrganizationsQuery, SystemOrganizationsQueryVariables>(SystemOrganizationsDocument, options);
        }
export type SystemOrganizationsQueryHookResult = ReturnType<typeof useSystemOrganizationsQuery>;
export type SystemOrganizationsLazyQueryHookResult = ReturnType<typeof useSystemOrganizationsLazyQuery>;
export type SystemOrganizationsQueryResult = Apollo.QueryResult<SystemOrganizationsQuery, SystemOrganizationsQueryVariables>;
export const SystemPolicyDocumentsDocument = gql`
    query SystemPolicyDocuments($pageNumber: Int, $pageItemsCount: Int, $systemPolicyDocumentFilters: SystemPolicyDocumentFilters, $sortFields: [PolicyDocumentFieldSortField], $sortOrder: SortOrder) {
  systemPolicyDocuments(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    systemPolicyDocumentFilters: $systemPolicyDocumentFilters
    sortFields: $sortFields
    sortOrder: $sortOrder
  ) {
    nodes {
      createdAt
      expiredAt
      id
      isDraft
      templateType
    }
    totalCount
  }
}
    `;

/**
 * __useSystemPolicyDocumentsQuery__
 *
 * To run a query within a React component, call `useSystemPolicyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemPolicyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemPolicyDocumentsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      systemPolicyDocumentFilters: // value for 'systemPolicyDocumentFilters'
 *      sortFields: // value for 'sortFields'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemPolicyDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<SystemPolicyDocumentsQuery, SystemPolicyDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemPolicyDocumentsQuery, SystemPolicyDocumentsQueryVariables>(SystemPolicyDocumentsDocument, options);
      }
export function useSystemPolicyDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemPolicyDocumentsQuery, SystemPolicyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemPolicyDocumentsQuery, SystemPolicyDocumentsQueryVariables>(SystemPolicyDocumentsDocument, options);
        }
export type SystemPolicyDocumentsQueryHookResult = ReturnType<typeof useSystemPolicyDocumentsQuery>;
export type SystemPolicyDocumentsLazyQueryHookResult = ReturnType<typeof useSystemPolicyDocumentsLazyQuery>;
export type SystemPolicyDocumentsQueryResult = Apollo.QueryResult<SystemPolicyDocumentsQuery, SystemPolicyDocumentsQueryVariables>;
export const SystemReactivateOrganizationDocument = gql`
    mutation SystemReactivateOrganization($systemReactivateOrganizationId: ID!) {
  systemReactivateOrganization(id: $systemReactivateOrganizationId) {
    id
  }
}
    `;
export type SystemReactivateOrganizationMutationFn = Apollo.MutationFunction<SystemReactivateOrganizationMutation, SystemReactivateOrganizationMutationVariables>;

/**
 * __useSystemReactivateOrganizationMutation__
 *
 * To run a mutation, you first call `useSystemReactivateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemReactivateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemReactivateOrganizationMutation, { data, loading, error }] = useSystemReactivateOrganizationMutation({
 *   variables: {
 *      systemReactivateOrganizationId: // value for 'systemReactivateOrganizationId'
 *   },
 * });
 */
export function useSystemReactivateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SystemReactivateOrganizationMutation, SystemReactivateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemReactivateOrganizationMutation, SystemReactivateOrganizationMutationVariables>(SystemReactivateOrganizationDocument, options);
      }
export type SystemReactivateOrganizationMutationHookResult = ReturnType<typeof useSystemReactivateOrganizationMutation>;
export type SystemReactivateOrganizationMutationResult = Apollo.MutationResult<SystemReactivateOrganizationMutation>;
export type SystemReactivateOrganizationMutationOptions = Apollo.BaseMutationOptions<SystemReactivateOrganizationMutation, SystemReactivateOrganizationMutationVariables>;
export const SystemRemoveAffiliateGroupDocument = gql`
    mutation SystemRemoveAffiliateGroup($systemRemoveAffiliateGroupId: ID!) {
  systemRemoveAffiliateGroup(id: $systemRemoveAffiliateGroupId) {
    id
  }
}
    `;
export type SystemRemoveAffiliateGroupMutationFn = Apollo.MutationFunction<SystemRemoveAffiliateGroupMutation, SystemRemoveAffiliateGroupMutationVariables>;

/**
 * __useSystemRemoveAffiliateGroupMutation__
 *
 * To run a mutation, you first call `useSystemRemoveAffiliateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemRemoveAffiliateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemRemoveAffiliateGroupMutation, { data, loading, error }] = useSystemRemoveAffiliateGroupMutation({
 *   variables: {
 *      systemRemoveAffiliateGroupId: // value for 'systemRemoveAffiliateGroupId'
 *   },
 * });
 */
export function useSystemRemoveAffiliateGroupMutation(baseOptions?: Apollo.MutationHookOptions<SystemRemoveAffiliateGroupMutation, SystemRemoveAffiliateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemRemoveAffiliateGroupMutation, SystemRemoveAffiliateGroupMutationVariables>(SystemRemoveAffiliateGroupDocument, options);
      }
export type SystemRemoveAffiliateGroupMutationHookResult = ReturnType<typeof useSystemRemoveAffiliateGroupMutation>;
export type SystemRemoveAffiliateGroupMutationResult = Apollo.MutationResult<SystemRemoveAffiliateGroupMutation>;
export type SystemRemoveAffiliateGroupMutationOptions = Apollo.BaseMutationOptions<SystemRemoveAffiliateGroupMutation, SystemRemoveAffiliateGroupMutationVariables>;
export const SystemRemoveAffiliateOrganizationDocument = gql`
    mutation SystemRemoveAffiliateOrganization($id: ID!) {
  systemRemoveAffiliateOrganization(affiliateOrganizationId: $id) {
    id
  }
}
    `;
export type SystemRemoveAffiliateOrganizationMutationFn = Apollo.MutationFunction<SystemRemoveAffiliateOrganizationMutation, SystemRemoveAffiliateOrganizationMutationVariables>;

/**
 * __useSystemRemoveAffiliateOrganizationMutation__
 *
 * To run a mutation, you first call `useSystemRemoveAffiliateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemRemoveAffiliateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemRemoveAffiliateOrganizationMutation, { data, loading, error }] = useSystemRemoveAffiliateOrganizationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemRemoveAffiliateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SystemRemoveAffiliateOrganizationMutation, SystemRemoveAffiliateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemRemoveAffiliateOrganizationMutation, SystemRemoveAffiliateOrganizationMutationVariables>(SystemRemoveAffiliateOrganizationDocument, options);
      }
export type SystemRemoveAffiliateOrganizationMutationHookResult = ReturnType<typeof useSystemRemoveAffiliateOrganizationMutation>;
export type SystemRemoveAffiliateOrganizationMutationResult = Apollo.MutationResult<SystemRemoveAffiliateOrganizationMutation>;
export type SystemRemoveAffiliateOrganizationMutationOptions = Apollo.BaseMutationOptions<SystemRemoveAffiliateOrganizationMutation, SystemRemoveAffiliateOrganizationMutationVariables>;
export const SystemRemoveMemberDocument = gql`
    mutation SystemRemoveMember($organizationId: ID!, $userId: UserID!) {
  systemRemoveMember(organizationId: $organizationId, userId: $userId) {
    id
  }
}
    `;
export type SystemRemoveMemberMutationFn = Apollo.MutationFunction<SystemRemoveMemberMutation, SystemRemoveMemberMutationVariables>;

/**
 * __useSystemRemoveMemberMutation__
 *
 * To run a mutation, you first call `useSystemRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemRemoveMemberMutation, { data, loading, error }] = useSystemRemoveMemberMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSystemRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<SystemRemoveMemberMutation, SystemRemoveMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemRemoveMemberMutation, SystemRemoveMemberMutationVariables>(SystemRemoveMemberDocument, options);
      }
export type SystemRemoveMemberMutationHookResult = ReturnType<typeof useSystemRemoveMemberMutation>;
export type SystemRemoveMemberMutationResult = Apollo.MutationResult<SystemRemoveMemberMutation>;
export type SystemRemoveMemberMutationOptions = Apollo.BaseMutationOptions<SystemRemoveMemberMutation, SystemRemoveMemberMutationVariables>;
export const SystemRemoveOrganizationMailingRecipientDocument = gql`
    mutation SystemRemoveOrganizationMailingRecipient($mailingRecipientId: ID!) {
  systemRemoveOrganizationMailingRecipient(
    mailingRecipientId: $mailingRecipientId
  ) {
    id
  }
}
    `;
export type SystemRemoveOrganizationMailingRecipientMutationFn = Apollo.MutationFunction<SystemRemoveOrganizationMailingRecipientMutation, SystemRemoveOrganizationMailingRecipientMutationVariables>;

/**
 * __useSystemRemoveOrganizationMailingRecipientMutation__
 *
 * To run a mutation, you first call `useSystemRemoveOrganizationMailingRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemRemoveOrganizationMailingRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemRemoveOrganizationMailingRecipientMutation, { data, loading, error }] = useSystemRemoveOrganizationMailingRecipientMutation({
 *   variables: {
 *      mailingRecipientId: // value for 'mailingRecipientId'
 *   },
 * });
 */
export function useSystemRemoveOrganizationMailingRecipientMutation(baseOptions?: Apollo.MutationHookOptions<SystemRemoveOrganizationMailingRecipientMutation, SystemRemoveOrganizationMailingRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemRemoveOrganizationMailingRecipientMutation, SystemRemoveOrganizationMailingRecipientMutationVariables>(SystemRemoveOrganizationMailingRecipientDocument, options);
      }
export type SystemRemoveOrganizationMailingRecipientMutationHookResult = ReturnType<typeof useSystemRemoveOrganizationMailingRecipientMutation>;
export type SystemRemoveOrganizationMailingRecipientMutationResult = Apollo.MutationResult<SystemRemoveOrganizationMailingRecipientMutation>;
export type SystemRemoveOrganizationMailingRecipientMutationOptions = Apollo.BaseMutationOptions<SystemRemoveOrganizationMailingRecipientMutation, SystemRemoveOrganizationMailingRecipientMutationVariables>;
export const SystemRemoveRiskDocument = gql`
    mutation SystemRemoveRisk($id: ID!) {
  systemRemoveRisk(id: $id) {
    id
  }
}
    `;
export type SystemRemoveRiskMutationFn = Apollo.MutationFunction<SystemRemoveRiskMutation, SystemRemoveRiskMutationVariables>;

/**
 * __useSystemRemoveRiskMutation__
 *
 * To run a mutation, you first call `useSystemRemoveRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemRemoveRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemRemoveRiskMutation, { data, loading, error }] = useSystemRemoveRiskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemRemoveRiskMutation(baseOptions?: Apollo.MutationHookOptions<SystemRemoveRiskMutation, SystemRemoveRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemRemoveRiskMutation, SystemRemoveRiskMutationVariables>(SystemRemoveRiskDocument, options);
      }
export type SystemRemoveRiskMutationHookResult = ReturnType<typeof useSystemRemoveRiskMutation>;
export type SystemRemoveRiskMutationResult = Apollo.MutationResult<SystemRemoveRiskMutation>;
export type SystemRemoveRiskMutationOptions = Apollo.BaseMutationOptions<SystemRemoveRiskMutation, SystemRemoveRiskMutationVariables>;
export const SystemRemoveRiskAssessmentDocumentDocument = gql`
    mutation systemRemoveRiskAssessmentDocument($id: ID!) {
  systemRemoveRiskAssessmentDocument(id: $id) {
    id
  }
}
    `;
export type SystemRemoveRiskAssessmentDocumentMutationFn = Apollo.MutationFunction<SystemRemoveRiskAssessmentDocumentMutation, SystemRemoveRiskAssessmentDocumentMutationVariables>;

/**
 * __useSystemRemoveRiskAssessmentDocumentMutation__
 *
 * To run a mutation, you first call `useSystemRemoveRiskAssessmentDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemRemoveRiskAssessmentDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemRemoveRiskAssessmentDocumentMutation, { data, loading, error }] = useSystemRemoveRiskAssessmentDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemRemoveRiskAssessmentDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SystemRemoveRiskAssessmentDocumentMutation, SystemRemoveRiskAssessmentDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemRemoveRiskAssessmentDocumentMutation, SystemRemoveRiskAssessmentDocumentMutationVariables>(SystemRemoveRiskAssessmentDocumentDocument, options);
      }
export type SystemRemoveRiskAssessmentDocumentMutationHookResult = ReturnType<typeof useSystemRemoveRiskAssessmentDocumentMutation>;
export type SystemRemoveRiskAssessmentDocumentMutationResult = Apollo.MutationResult<SystemRemoveRiskAssessmentDocumentMutation>;
export type SystemRemoveRiskAssessmentDocumentMutationOptions = Apollo.BaseMutationOptions<SystemRemoveRiskAssessmentDocumentMutation, SystemRemoveRiskAssessmentDocumentMutationVariables>;
export const SystemRemoveShadowEntityDocument = gql`
    mutation SystemRemoveShadowEntity($userId: UserID!) {
  systemRemoveShadowEntity(userId: $userId) {
    id
    deletedAt
  }
}
    `;
export type SystemRemoveShadowEntityMutationFn = Apollo.MutationFunction<SystemRemoveShadowEntityMutation, SystemRemoveShadowEntityMutationVariables>;

/**
 * __useSystemRemoveShadowEntityMutation__
 *
 * To run a mutation, you first call `useSystemRemoveShadowEntityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemRemoveShadowEntityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemRemoveShadowEntityMutation, { data, loading, error }] = useSystemRemoveShadowEntityMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSystemRemoveShadowEntityMutation(baseOptions?: Apollo.MutationHookOptions<SystemRemoveShadowEntityMutation, SystemRemoveShadowEntityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemRemoveShadowEntityMutation, SystemRemoveShadowEntityMutationVariables>(SystemRemoveShadowEntityDocument, options);
      }
export type SystemRemoveShadowEntityMutationHookResult = ReturnType<typeof useSystemRemoveShadowEntityMutation>;
export type SystemRemoveShadowEntityMutationResult = Apollo.MutationResult<SystemRemoveShadowEntityMutation>;
export type SystemRemoveShadowEntityMutationOptions = Apollo.BaseMutationOptions<SystemRemoveShadowEntityMutation, SystemRemoveShadowEntityMutationVariables>;
export const SystemRemoveTaskDocument = gql`
    mutation SystemRemoveTask($id: ID!, $riskId: ID!) {
  systemRemoveTask(id: $id, riskId: $riskId) {
    id
  }
}
    `;
export type SystemRemoveTaskMutationFn = Apollo.MutationFunction<SystemRemoveTaskMutation, SystemRemoveTaskMutationVariables>;

/**
 * __useSystemRemoveTaskMutation__
 *
 * To run a mutation, you first call `useSystemRemoveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemRemoveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemRemoveTaskMutation, { data, loading, error }] = useSystemRemoveTaskMutation({
 *   variables: {
 *      id: // value for 'id'
 *      riskId: // value for 'riskId'
 *   },
 * });
 */
export function useSystemRemoveTaskMutation(baseOptions?: Apollo.MutationHookOptions<SystemRemoveTaskMutation, SystemRemoveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemRemoveTaskMutation, SystemRemoveTaskMutationVariables>(SystemRemoveTaskDocument, options);
      }
export type SystemRemoveTaskMutationHookResult = ReturnType<typeof useSystemRemoveTaskMutation>;
export type SystemRemoveTaskMutationResult = Apollo.MutationResult<SystemRemoveTaskMutation>;
export type SystemRemoveTaskMutationOptions = Apollo.BaseMutationOptions<SystemRemoveTaskMutation, SystemRemoveTaskMutationVariables>;
export const SystemRemoveVendorRiskDocument = gql`
    mutation SystemRemoveVendorRisk($id: ID!) {
  systemRemoveVendorRisk(id: $id) {
    id
  }
}
    `;
export type SystemRemoveVendorRiskMutationFn = Apollo.MutationFunction<SystemRemoveVendorRiskMutation, SystemRemoveVendorRiskMutationVariables>;

/**
 * __useSystemRemoveVendorRiskMutation__
 *
 * To run a mutation, you first call `useSystemRemoveVendorRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemRemoveVendorRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemRemoveVendorRiskMutation, { data, loading, error }] = useSystemRemoveVendorRiskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemRemoveVendorRiskMutation(baseOptions?: Apollo.MutationHookOptions<SystemRemoveVendorRiskMutation, SystemRemoveVendorRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemRemoveVendorRiskMutation, SystemRemoveVendorRiskMutationVariables>(SystemRemoveVendorRiskDocument, options);
      }
export type SystemRemoveVendorRiskMutationHookResult = ReturnType<typeof useSystemRemoveVendorRiskMutation>;
export type SystemRemoveVendorRiskMutationResult = Apollo.MutationResult<SystemRemoveVendorRiskMutation>;
export type SystemRemoveVendorRiskMutationOptions = Apollo.BaseMutationOptions<SystemRemoveVendorRiskMutation, SystemRemoveVendorRiskMutationVariables>;
export const SystemRiskDocument = gql`
    query SystemRisk($id: ID!) {
  systemRisk(id: $id) {
    id
    rating
    title
    coreFunction
    functionCategory
    tasks {
      id
    }
    createdAt
    updatedAt
    riskAssessmentDocument {
      id
      organization {
        name
      }
    }
  }
}
    `;

/**
 * __useSystemRiskQuery__
 *
 * To run a query within a React component, call `useSystemRiskQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemRiskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemRiskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemRiskQuery(baseOptions: Apollo.QueryHookOptions<SystemRiskQuery, SystemRiskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemRiskQuery, SystemRiskQueryVariables>(SystemRiskDocument, options);
      }
export function useSystemRiskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemRiskQuery, SystemRiskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemRiskQuery, SystemRiskQueryVariables>(SystemRiskDocument, options);
        }
export type SystemRiskQueryHookResult = ReturnType<typeof useSystemRiskQuery>;
export type SystemRiskLazyQueryHookResult = ReturnType<typeof useSystemRiskLazyQuery>;
export type SystemRiskQueryResult = Apollo.QueryResult<SystemRiskQuery, SystemRiskQueryVariables>;
export const SystemRiskAssessmentDocumentDocument = gql`
    query SystemRiskAssessmentDocument($id: ID!) {
  systemRiskAssessmentDocument(id: $id) {
    id
    createdAt
    updatedAt
    completedAt
    expiredAt
    isDraft
    sections {
      OrganizationalOversight {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
          coreFunction
          functionCategory
          options {
            title
            code
          }
        }
        title
        code
      }
      AccessControl {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
          coreFunction
          functionCategory
          options {
            title
            code
          }
        }
        title
        code
      }
      SystemDeploymentAndMaintenance {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
          coreFunction
          functionCategory
          options {
            title
            code
          }
        }
        title
        code
      }
      DataProtection {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
          coreFunction
          functionCategory
          options {
            title
            code
          }
        }
        title
        code
      }
      NetworkSecurity {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
          coreFunction
          functionCategory
          options {
            title
            code
          }
        }
        title
        code
      }
      SecurityLoggingAndMonitoring {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
          coreFunction
          functionCategory
          options {
            title
            code
          }
        }
        title
        code
      }
      RiskManagementStrategy {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
          coreFunction
          functionCategory
          options {
            title
            code
          }
        }
        title
        code
      }
      IncidentResponse {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
          coreFunction
          functionCategory
          options {
            title
            code
          }
        }
        title
        code
      }
      BusinessContinuityAndDisasterRecovery {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
          coreFunction
          functionCategory
          options {
            title
            code
          }
        }
        title
        code
      }
    }
    document {
      documentUrl
      title
    }
    organization {
      id
      cif
      name
      imageUrl
      legalName
    }
    user {
      id
      email
      firstName
      lastName
    }
    risks {
      id
      tasks {
        id
      }
    }
    status
  }
}
    `;

/**
 * __useSystemRiskAssessmentDocumentQuery__
 *
 * To run a query within a React component, call `useSystemRiskAssessmentDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemRiskAssessmentDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemRiskAssessmentDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemRiskAssessmentDocumentQuery(baseOptions: Apollo.QueryHookOptions<SystemRiskAssessmentDocumentQuery, SystemRiskAssessmentDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemRiskAssessmentDocumentQuery, SystemRiskAssessmentDocumentQueryVariables>(SystemRiskAssessmentDocumentDocument, options);
      }
export function useSystemRiskAssessmentDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemRiskAssessmentDocumentQuery, SystemRiskAssessmentDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemRiskAssessmentDocumentQuery, SystemRiskAssessmentDocumentQueryVariables>(SystemRiskAssessmentDocumentDocument, options);
        }
export type SystemRiskAssessmentDocumentQueryHookResult = ReturnType<typeof useSystemRiskAssessmentDocumentQuery>;
export type SystemRiskAssessmentDocumentLazyQueryHookResult = ReturnType<typeof useSystemRiskAssessmentDocumentLazyQuery>;
export type SystemRiskAssessmentDocumentQueryResult = Apollo.QueryResult<SystemRiskAssessmentDocumentQuery, SystemRiskAssessmentDocumentQueryVariables>;
export const SystemRiskAssessmentDocumentsDocument = gql`
    query SystemRiskAssessmentDocuments($pageNumber: Int, $pageItemsCount: Int, $filter: RiskAssessmentDocumentFilter, $sortField: RiskAssessmentDocumentFieldSortFieldEnum, $sortOrder: SortOrder) {
  systemRiskAssessmentDocuments(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    filter: $filter
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    totalCount
    nodes {
      id
      status
      createdAt
      expiredAt
      completedAt
      document {
        id
      }
      isDraft
      organization {
        id
        name
        cif
        imageUrl
        legalName
      }
      user {
        id
        email
        firstName
        lastName
      }
      risks {
        id
      }
      status
    }
  }
}
    `;

/**
 * __useSystemRiskAssessmentDocumentsQuery__
 *
 * To run a query within a React component, call `useSystemRiskAssessmentDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemRiskAssessmentDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemRiskAssessmentDocumentsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      filter: // value for 'filter'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemRiskAssessmentDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<SystemRiskAssessmentDocumentsQuery, SystemRiskAssessmentDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemRiskAssessmentDocumentsQuery, SystemRiskAssessmentDocumentsQueryVariables>(SystemRiskAssessmentDocumentsDocument, options);
      }
export function useSystemRiskAssessmentDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemRiskAssessmentDocumentsQuery, SystemRiskAssessmentDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemRiskAssessmentDocumentsQuery, SystemRiskAssessmentDocumentsQueryVariables>(SystemRiskAssessmentDocumentsDocument, options);
        }
export type SystemRiskAssessmentDocumentsQueryHookResult = ReturnType<typeof useSystemRiskAssessmentDocumentsQuery>;
export type SystemRiskAssessmentDocumentsLazyQueryHookResult = ReturnType<typeof useSystemRiskAssessmentDocumentsLazyQuery>;
export type SystemRiskAssessmentDocumentsQueryResult = Apollo.QueryResult<SystemRiskAssessmentDocumentsQuery, SystemRiskAssessmentDocumentsQueryVariables>;
export const SystemRisksDocument = gql`
    query SystemRisks($pageNumber: Int, $pageItemsCount: Int, $riskFilters: SystemRiskFilters, $sortFields: [RiskSortField], $sortOrder: SortOrder) {
  systemRisks(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    riskFilters: $riskFilters
    sortFields: $sortFields
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      createdAt
      functionCategory
      rating
      title
      updatedAt
      riskAssessmentDocument {
        organization {
          id
        }
      }
      tasks {
        id
        title
        description
        completedAt
        dueDate
        assignee {
          id
          firstName
          lastName
          email
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemRisksQuery__
 *
 * To run a query within a React component, call `useSystemRisksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemRisksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemRisksQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      riskFilters: // value for 'riskFilters'
 *      sortFields: // value for 'sortFields'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemRisksQuery(baseOptions?: Apollo.QueryHookOptions<SystemRisksQuery, SystemRisksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemRisksQuery, SystemRisksQueryVariables>(SystemRisksDocument, options);
      }
export function useSystemRisksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemRisksQuery, SystemRisksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemRisksQuery, SystemRisksQueryVariables>(SystemRisksDocument, options);
        }
export type SystemRisksQueryHookResult = ReturnType<typeof useSystemRisksQuery>;
export type SystemRisksLazyQueryHookResult = ReturnType<typeof useSystemRisksLazyQuery>;
export type SystemRisksQueryResult = Apollo.QueryResult<SystemRisksQuery, SystemRisksQueryVariables>;
export const SystemSetOperatingSystemSupportStatusDocument = gql`
    mutation systemSetOperatingSystemSupportStatus($operatingSystemId: ID!, $status: OsSupportStatus!) {
  systemSetOperatingSystemSupportStatus(id: $operatingSystemId, status: $status) {
    id
  }
}
    `;
export type SystemSetOperatingSystemSupportStatusMutationFn = Apollo.MutationFunction<SystemSetOperatingSystemSupportStatusMutation, SystemSetOperatingSystemSupportStatusMutationVariables>;

/**
 * __useSystemSetOperatingSystemSupportStatusMutation__
 *
 * To run a mutation, you first call `useSystemSetOperatingSystemSupportStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemSetOperatingSystemSupportStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemSetOperatingSystemSupportStatusMutation, { data, loading, error }] = useSystemSetOperatingSystemSupportStatusMutation({
 *   variables: {
 *      operatingSystemId: // value for 'operatingSystemId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSystemSetOperatingSystemSupportStatusMutation(baseOptions?: Apollo.MutationHookOptions<SystemSetOperatingSystemSupportStatusMutation, SystemSetOperatingSystemSupportStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemSetOperatingSystemSupportStatusMutation, SystemSetOperatingSystemSupportStatusMutationVariables>(SystemSetOperatingSystemSupportStatusDocument, options);
      }
export type SystemSetOperatingSystemSupportStatusMutationHookResult = ReturnType<typeof useSystemSetOperatingSystemSupportStatusMutation>;
export type SystemSetOperatingSystemSupportStatusMutationResult = Apollo.MutationResult<SystemSetOperatingSystemSupportStatusMutation>;
export type SystemSetOperatingSystemSupportStatusMutationOptions = Apollo.BaseMutationOptions<SystemSetOperatingSystemSupportStatusMutation, SystemSetOperatingSystemSupportStatusMutationVariables>;
export const SystemSetRiskAssessmentAnswersDocument = gql`
    mutation SystemSetRiskAssessmentAnswers($id: ID!, $sections: RiskAssessmentSectionsInput!) {
  systemSetRiskAssessmentAnswers(
    riskAssessmentDocumentId: $id
    sections: $sections
  ) {
    id
    sections {
      OrganizationalOversight {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
        }
        title
        code
      }
      AccessControl {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
        }
        title
        code
      }
      SystemDeploymentAndMaintenance {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
        }
        title
        code
      }
      DataProtection {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
        }
        title
        code
      }
      NetworkSecurity {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
        }
        title
        code
      }
      SecurityLoggingAndMonitoring {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
        }
        title
        code
      }
      RiskManagementStrategy {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
        }
        title
        code
      }
      IncidentResponse {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
        }
        title
        code
      }
      BusinessContinuityAndDisasterRecovery {
        id
        questions {
          title
          code
          description
          answer {
            title
            code
          }
          note
        }
        title
        code
      }
    }
  }
}
    `;
export type SystemSetRiskAssessmentAnswersMutationFn = Apollo.MutationFunction<SystemSetRiskAssessmentAnswersMutation, SystemSetRiskAssessmentAnswersMutationVariables>;

/**
 * __useSystemSetRiskAssessmentAnswersMutation__
 *
 * To run a mutation, you first call `useSystemSetRiskAssessmentAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemSetRiskAssessmentAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemSetRiskAssessmentAnswersMutation, { data, loading, error }] = useSystemSetRiskAssessmentAnswersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      sections: // value for 'sections'
 *   },
 * });
 */
export function useSystemSetRiskAssessmentAnswersMutation(baseOptions?: Apollo.MutationHookOptions<SystemSetRiskAssessmentAnswersMutation, SystemSetRiskAssessmentAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemSetRiskAssessmentAnswersMutation, SystemSetRiskAssessmentAnswersMutationVariables>(SystemSetRiskAssessmentAnswersDocument, options);
      }
export type SystemSetRiskAssessmentAnswersMutationHookResult = ReturnType<typeof useSystemSetRiskAssessmentAnswersMutation>;
export type SystemSetRiskAssessmentAnswersMutationResult = Apollo.MutationResult<SystemSetRiskAssessmentAnswersMutation>;
export type SystemSetRiskAssessmentAnswersMutationOptions = Apollo.BaseMutationOptions<SystemSetRiskAssessmentAnswersMutation, SystemSetRiskAssessmentAnswersMutationVariables>;
export const SystemSetRiskAssessmentDocumentCompletionStatusDocument = gql`
    mutation SystemSetRiskAssessmentDocumentCompletionStatus($id: ID!, $status: RiskAssessmentStatus!) {
  systemSetRiskAssessmentDocumentCompletionStatus(
    riskAssessmentDocumentId: $id
    status: $status
  ) {
    id
    status
  }
}
    `;
export type SystemSetRiskAssessmentDocumentCompletionStatusMutationFn = Apollo.MutationFunction<SystemSetRiskAssessmentDocumentCompletionStatusMutation, SystemSetRiskAssessmentDocumentCompletionStatusMutationVariables>;

/**
 * __useSystemSetRiskAssessmentDocumentCompletionStatusMutation__
 *
 * To run a mutation, you first call `useSystemSetRiskAssessmentDocumentCompletionStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemSetRiskAssessmentDocumentCompletionStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemSetRiskAssessmentDocumentCompletionStatusMutation, { data, loading, error }] = useSystemSetRiskAssessmentDocumentCompletionStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSystemSetRiskAssessmentDocumentCompletionStatusMutation(baseOptions?: Apollo.MutationHookOptions<SystemSetRiskAssessmentDocumentCompletionStatusMutation, SystemSetRiskAssessmentDocumentCompletionStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemSetRiskAssessmentDocumentCompletionStatusMutation, SystemSetRiskAssessmentDocumentCompletionStatusMutationVariables>(SystemSetRiskAssessmentDocumentCompletionStatusDocument, options);
      }
export type SystemSetRiskAssessmentDocumentCompletionStatusMutationHookResult = ReturnType<typeof useSystemSetRiskAssessmentDocumentCompletionStatusMutation>;
export type SystemSetRiskAssessmentDocumentCompletionStatusMutationResult = Apollo.MutationResult<SystemSetRiskAssessmentDocumentCompletionStatusMutation>;
export type SystemSetRiskAssessmentDocumentCompletionStatusMutationOptions = Apollo.BaseMutationOptions<SystemSetRiskAssessmentDocumentCompletionStatusMutation, SystemSetRiskAssessmentDocumentCompletionStatusMutationVariables>;
export const SystemSetShadowOrganizationDocument = gql`
    mutation SystemSetShadowOrganization($organizationId: ID!) {
  systemSetShadowOrganization(organizationId: $organizationId) {
    id
  }
}
    `;
export type SystemSetShadowOrganizationMutationFn = Apollo.MutationFunction<SystemSetShadowOrganizationMutation, SystemSetShadowOrganizationMutationVariables>;

/**
 * __useSystemSetShadowOrganizationMutation__
 *
 * To run a mutation, you first call `useSystemSetShadowOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemSetShadowOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemSetShadowOrganizationMutation, { data, loading, error }] = useSystemSetShadowOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSystemSetShadowOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SystemSetShadowOrganizationMutation, SystemSetShadowOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemSetShadowOrganizationMutation, SystemSetShadowOrganizationMutationVariables>(SystemSetShadowOrganizationDocument, options);
      }
export type SystemSetShadowOrganizationMutationHookResult = ReturnType<typeof useSystemSetShadowOrganizationMutation>;
export type SystemSetShadowOrganizationMutationResult = Apollo.MutationResult<SystemSetShadowOrganizationMutation>;
export type SystemSetShadowOrganizationMutationOptions = Apollo.BaseMutationOptions<SystemSetShadowOrganizationMutation, SystemSetShadowOrganizationMutationVariables>;
export const SystemSetShadowUserDocument = gql`
    mutation SystemSetShadowUser($userId: UserID!) {
  systemSetShadowUser(userId: $userId) {
    id
  }
}
    `;
export type SystemSetShadowUserMutationFn = Apollo.MutationFunction<SystemSetShadowUserMutation, SystemSetShadowUserMutationVariables>;

/**
 * __useSystemSetShadowUserMutation__
 *
 * To run a mutation, you first call `useSystemSetShadowUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemSetShadowUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemSetShadowUserMutation, { data, loading, error }] = useSystemSetShadowUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSystemSetShadowUserMutation(baseOptions?: Apollo.MutationHookOptions<SystemSetShadowUserMutation, SystemSetShadowUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemSetShadowUserMutation, SystemSetShadowUserMutationVariables>(SystemSetShadowUserDocument, options);
      }
export type SystemSetShadowUserMutationHookResult = ReturnType<typeof useSystemSetShadowUserMutation>;
export type SystemSetShadowUserMutationResult = Apollo.MutationResult<SystemSetShadowUserMutation>;
export type SystemSetShadowUserMutationOptions = Apollo.BaseMutationOptions<SystemSetShadowUserMutation, SystemSetShadowUserMutationVariables>;
export const SystemTaskDocument = gql`
    query SystemTask($id: ID!) {
  systemTask(id: $id) {
    id
    risk {
      id
      riskAssessmentDocument {
        id
        organization {
          id
          name
        }
      }
    }
    assignee {
      id
      firstName
      email
      lastName
    }
    title
    description
    dueDate
    isComplete
    completedAt
    comments {
      id
      user {
        id
        firstName
        email
        lastName
      }
      text
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSystemTaskQuery__
 *
 * To run a query within a React component, call `useSystemTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemTaskQuery(baseOptions: Apollo.QueryHookOptions<SystemTaskQuery, SystemTaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemTaskQuery, SystemTaskQueryVariables>(SystemTaskDocument, options);
      }
export function useSystemTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemTaskQuery, SystemTaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemTaskQuery, SystemTaskQueryVariables>(SystemTaskDocument, options);
        }
export type SystemTaskQueryHookResult = ReturnType<typeof useSystemTaskQuery>;
export type SystemTaskLazyQueryHookResult = ReturnType<typeof useSystemTaskLazyQuery>;
export type SystemTaskQueryResult = Apollo.QueryResult<SystemTaskQuery, SystemTaskQueryVariables>;
export const SystemTaskCommentsDocument = gql`
    query SystemTaskComments($pageNumber: Int, $pageItemsCount: Int, $taskCommentFilters: TaskCommentFilters, $sortFields: [TaskCommentSortField], $sortOrder: SortOrder) {
  systemTaskComments(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    taskCommentFilters: $taskCommentFilters
    sortFields: $sortFields
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      text
      createdAt
      updatedAt
      user {
        firstName
        lastName
        email
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemTaskCommentsQuery__
 *
 * To run a query within a React component, call `useSystemTaskCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemTaskCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemTaskCommentsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      taskCommentFilters: // value for 'taskCommentFilters'
 *      sortFields: // value for 'sortFields'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemTaskCommentsQuery(baseOptions?: Apollo.QueryHookOptions<SystemTaskCommentsQuery, SystemTaskCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemTaskCommentsQuery, SystemTaskCommentsQueryVariables>(SystemTaskCommentsDocument, options);
      }
export function useSystemTaskCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemTaskCommentsQuery, SystemTaskCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemTaskCommentsQuery, SystemTaskCommentsQueryVariables>(SystemTaskCommentsDocument, options);
        }
export type SystemTaskCommentsQueryHookResult = ReturnType<typeof useSystemTaskCommentsQuery>;
export type SystemTaskCommentsLazyQueryHookResult = ReturnType<typeof useSystemTaskCommentsLazyQuery>;
export type SystemTaskCommentsQueryResult = Apollo.QueryResult<SystemTaskCommentsQuery, SystemTaskCommentsQueryVariables>;
export const SystemTasksDocument = gql`
    query SystemTasks($pageNumber: Int, $pageItemsCount: Int, $taskFilters: TaskFilters, $sortFields: [TaskSortField], $sortOrder: SortOrder) {
  systemTasks(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    taskFilters: $taskFilters
    sortFields: $sortFields
    sortOrder: $sortOrder
  ) {
    nodes {
      assignee {
        id
        firstName
        lastName
        email
      }
      comments {
        id
        text
        createdAt
        user {
          id
          firstName
          lastName
        }
      }
      id
      title
      dueDate
      completedAt
      status
    }
    totalCount
  }
}
    `;

/**
 * __useSystemTasksQuery__
 *
 * To run a query within a React component, call `useSystemTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemTasksQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      taskFilters: // value for 'taskFilters'
 *      sortFields: // value for 'sortFields'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemTasksQuery(baseOptions?: Apollo.QueryHookOptions<SystemTasksQuery, SystemTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemTasksQuery, SystemTasksQueryVariables>(SystemTasksDocument, options);
      }
export function useSystemTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemTasksQuery, SystemTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemTasksQuery, SystemTasksQueryVariables>(SystemTasksDocument, options);
        }
export type SystemTasksQueryHookResult = ReturnType<typeof useSystemTasksQuery>;
export type SystemTasksLazyQueryHookResult = ReturnType<typeof useSystemTasksLazyQuery>;
export type SystemTasksQueryResult = Apollo.QueryResult<SystemTasksQuery, SystemTasksQueryVariables>;
export const SystemUpdateAffiliateGroupDocument = gql`
    mutation SystemUpdateAffiliateGroup($systemUpdateAffiliateGroupId: ID!, $input: UpdateAffiliateGroupInput!) {
  systemUpdateAffiliateGroup(id: $systemUpdateAffiliateGroupId, input: $input) {
    id
    name
    organizations {
      id
    }
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export type SystemUpdateAffiliateGroupMutationFn = Apollo.MutationFunction<SystemUpdateAffiliateGroupMutation, SystemUpdateAffiliateGroupMutationVariables>;

/**
 * __useSystemUpdateAffiliateGroupMutation__
 *
 * To run a mutation, you first call `useSystemUpdateAffiliateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateAffiliateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateAffiliateGroupMutation, { data, loading, error }] = useSystemUpdateAffiliateGroupMutation({
 *   variables: {
 *      systemUpdateAffiliateGroupId: // value for 'systemUpdateAffiliateGroupId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemUpdateAffiliateGroupMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateAffiliateGroupMutation, SystemUpdateAffiliateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateAffiliateGroupMutation, SystemUpdateAffiliateGroupMutationVariables>(SystemUpdateAffiliateGroupDocument, options);
      }
export type SystemUpdateAffiliateGroupMutationHookResult = ReturnType<typeof useSystemUpdateAffiliateGroupMutation>;
export type SystemUpdateAffiliateGroupMutationResult = Apollo.MutationResult<SystemUpdateAffiliateGroupMutation>;
export type SystemUpdateAffiliateGroupMutationOptions = Apollo.BaseMutationOptions<SystemUpdateAffiliateGroupMutation, SystemUpdateAffiliateGroupMutationVariables>;
export const SystemUpdateDocumentDocument = gql`
    mutation SystemUpdateDocument($input: UpdateSystemDocumentInput!) {
  systemUpdateDocument(input: $input) {
    id
    description
  }
}
    `;
export type SystemUpdateDocumentMutationFn = Apollo.MutationFunction<SystemUpdateDocumentMutation, SystemUpdateDocumentMutationVariables>;

/**
 * __useSystemUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useSystemUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateDocumentMutation, { data, loading, error }] = useSystemUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateDocumentMutation, SystemUpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateDocumentMutation, SystemUpdateDocumentMutationVariables>(SystemUpdateDocumentDocument, options);
      }
export type SystemUpdateDocumentMutationHookResult = ReturnType<typeof useSystemUpdateDocumentMutation>;
export type SystemUpdateDocumentMutationResult = Apollo.MutationResult<SystemUpdateDocumentMutation>;
export type SystemUpdateDocumentMutationOptions = Apollo.BaseMutationOptions<SystemUpdateDocumentMutation, SystemUpdateDocumentMutationVariables>;
export const SystemUpdateOrganizationDocument = gql`
    mutation SystemUpdateOrganization($organization: UpdateSystemOrganizationInput, $organizationId: ID!, $sentinelOneSiteId: String, $knowBe4ApiKey: String, $billingStartedAt: Date) {
  systemUpdateOrganization(input: $organization) {
    addressLine1
    addressLine2
    city
    country
    createdAt
    id
    cif
    sentinelOneSiteId
    knowBe4Key
    imageUrl
    legalName
    name
    paidSubscription
    owned
    phone
    state
    updatedAt
    zip
  }
  systemUpdateSentinelOneSiteId(
    organizationId: $organizationId
    sentinelOneSiteId: $sentinelOneSiteId
  ) {
    id
    sentinelOneSiteId
  }
  systemUpdateKnowBe4ApiKey(
    organizationId: $organizationId
    knowBe4ApiKey: $knowBe4ApiKey
  ) {
    id
    knowBe4Key
  }
  systemUpdateOrganizationBillingStartedAt(
    organizationId: $organizationId
    billingStartedAt: $billingStartedAt
  ) {
    id
    billingStartedAt
  }
}
    `;
export type SystemUpdateOrganizationMutationFn = Apollo.MutationFunction<SystemUpdateOrganizationMutation, SystemUpdateOrganizationMutationVariables>;

/**
 * __useSystemUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useSystemUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateOrganizationMutation, { data, loading, error }] = useSystemUpdateOrganizationMutation({
 *   variables: {
 *      organization: // value for 'organization'
 *      organizationId: // value for 'organizationId'
 *      sentinelOneSiteId: // value for 'sentinelOneSiteId'
 *      knowBe4ApiKey: // value for 'knowBe4ApiKey'
 *      billingStartedAt: // value for 'billingStartedAt'
 *   },
 * });
 */
export function useSystemUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateOrganizationMutation, SystemUpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateOrganizationMutation, SystemUpdateOrganizationMutationVariables>(SystemUpdateOrganizationDocument, options);
      }
export type SystemUpdateOrganizationMutationHookResult = ReturnType<typeof useSystemUpdateOrganizationMutation>;
export type SystemUpdateOrganizationMutationResult = Apollo.MutationResult<SystemUpdateOrganizationMutation>;
export type SystemUpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<SystemUpdateOrganizationMutation, SystemUpdateOrganizationMutationVariables>;
export const SystemUpdateOrganizationAccountTypeDocument = gql`
    mutation SystemUpdateOrganizationAccountType($id: ID!, $accountType: OrganizationAccountType!) {
  systemUpdateOrganizationAccountType(id: $id, accountType: $accountType) {
    id
    accountType
  }
}
    `;
export type SystemUpdateOrganizationAccountTypeMutationFn = Apollo.MutationFunction<SystemUpdateOrganizationAccountTypeMutation, SystemUpdateOrganizationAccountTypeMutationVariables>;

/**
 * __useSystemUpdateOrganizationAccountTypeMutation__
 *
 * To run a mutation, you first call `useSystemUpdateOrganizationAccountTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateOrganizationAccountTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateOrganizationAccountTypeMutation, { data, loading, error }] = useSystemUpdateOrganizationAccountTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountType: // value for 'accountType'
 *   },
 * });
 */
export function useSystemUpdateOrganizationAccountTypeMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateOrganizationAccountTypeMutation, SystemUpdateOrganizationAccountTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateOrganizationAccountTypeMutation, SystemUpdateOrganizationAccountTypeMutationVariables>(SystemUpdateOrganizationAccountTypeDocument, options);
      }
export type SystemUpdateOrganizationAccountTypeMutationHookResult = ReturnType<typeof useSystemUpdateOrganizationAccountTypeMutation>;
export type SystemUpdateOrganizationAccountTypeMutationResult = Apollo.MutationResult<SystemUpdateOrganizationAccountTypeMutation>;
export type SystemUpdateOrganizationAccountTypeMutationOptions = Apollo.BaseMutationOptions<SystemUpdateOrganizationAccountTypeMutation, SystemUpdateOrganizationAccountTypeMutationVariables>;
export const SystemUpdateOrganizationMailingRecipientDocument = gql`
    mutation SystemUpdateOrganizationMailingRecipient($input: UpdateSystemOrganizationMailingRecipientInput!) {
  systemUpdateOrganizationMailingRecipient(input: $input) {
    id
    firstName
    lastName
    email
  }
}
    `;
export type SystemUpdateOrganizationMailingRecipientMutationFn = Apollo.MutationFunction<SystemUpdateOrganizationMailingRecipientMutation, SystemUpdateOrganizationMailingRecipientMutationVariables>;

/**
 * __useSystemUpdateOrganizationMailingRecipientMutation__
 *
 * To run a mutation, you first call `useSystemUpdateOrganizationMailingRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateOrganizationMailingRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateOrganizationMailingRecipientMutation, { data, loading, error }] = useSystemUpdateOrganizationMailingRecipientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemUpdateOrganizationMailingRecipientMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateOrganizationMailingRecipientMutation, SystemUpdateOrganizationMailingRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateOrganizationMailingRecipientMutation, SystemUpdateOrganizationMailingRecipientMutationVariables>(SystemUpdateOrganizationMailingRecipientDocument, options);
      }
export type SystemUpdateOrganizationMailingRecipientMutationHookResult = ReturnType<typeof useSystemUpdateOrganizationMailingRecipientMutation>;
export type SystemUpdateOrganizationMailingRecipientMutationResult = Apollo.MutationResult<SystemUpdateOrganizationMailingRecipientMutation>;
export type SystemUpdateOrganizationMailingRecipientMutationOptions = Apollo.BaseMutationOptions<SystemUpdateOrganizationMailingRecipientMutation, SystemUpdateOrganizationMailingRecipientMutationVariables>;
export const SystemUpdateOrganizationModalsMutedAtDocument = gql`
    mutation SystemUpdateOrganizationModalsMutedAt($organizationId: ID!) {
  systemUpdateOrganizationModalsMutedAt(organizationId: $organizationId) {
    id
  }
}
    `;
export type SystemUpdateOrganizationModalsMutedAtMutationFn = Apollo.MutationFunction<SystemUpdateOrganizationModalsMutedAtMutation, SystemUpdateOrganizationModalsMutedAtMutationVariables>;

/**
 * __useSystemUpdateOrganizationModalsMutedAtMutation__
 *
 * To run a mutation, you first call `useSystemUpdateOrganizationModalsMutedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateOrganizationModalsMutedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateOrganizationModalsMutedAtMutation, { data, loading, error }] = useSystemUpdateOrganizationModalsMutedAtMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSystemUpdateOrganizationModalsMutedAtMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateOrganizationModalsMutedAtMutation, SystemUpdateOrganizationModalsMutedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateOrganizationModalsMutedAtMutation, SystemUpdateOrganizationModalsMutedAtMutationVariables>(SystemUpdateOrganizationModalsMutedAtDocument, options);
      }
export type SystemUpdateOrganizationModalsMutedAtMutationHookResult = ReturnType<typeof useSystemUpdateOrganizationModalsMutedAtMutation>;
export type SystemUpdateOrganizationModalsMutedAtMutationResult = Apollo.MutationResult<SystemUpdateOrganizationModalsMutedAtMutation>;
export type SystemUpdateOrganizationModalsMutedAtMutationOptions = Apollo.BaseMutationOptions<SystemUpdateOrganizationModalsMutedAtMutation, SystemUpdateOrganizationModalsMutedAtMutationVariables>;
export const SystemUpdateOrganizationNotificationSettingsDocument = gql`
    mutation SystemUpdateOrganizationNotificationSettings($organizationId: ID!, $updatedNotificationSettings: NotificationSettingsInput!) {
  systemUpdateOrganizationNotificationSettings(
    organizationId: $organizationId
    updatedNotificationSettings: $updatedNotificationSettings
  ) {
    id
  }
}
    `;
export type SystemUpdateOrganizationNotificationSettingsMutationFn = Apollo.MutationFunction<SystemUpdateOrganizationNotificationSettingsMutation, SystemUpdateOrganizationNotificationSettingsMutationVariables>;

/**
 * __useSystemUpdateOrganizationNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useSystemUpdateOrganizationNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateOrganizationNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateOrganizationNotificationSettingsMutation, { data, loading, error }] = useSystemUpdateOrganizationNotificationSettingsMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      updatedNotificationSettings: // value for 'updatedNotificationSettings'
 *   },
 * });
 */
export function useSystemUpdateOrganizationNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateOrganizationNotificationSettingsMutation, SystemUpdateOrganizationNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateOrganizationNotificationSettingsMutation, SystemUpdateOrganizationNotificationSettingsMutationVariables>(SystemUpdateOrganizationNotificationSettingsDocument, options);
      }
export type SystemUpdateOrganizationNotificationSettingsMutationHookResult = ReturnType<typeof useSystemUpdateOrganizationNotificationSettingsMutation>;
export type SystemUpdateOrganizationNotificationSettingsMutationResult = Apollo.MutationResult<SystemUpdateOrganizationNotificationSettingsMutation>;
export type SystemUpdateOrganizationNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<SystemUpdateOrganizationNotificationSettingsMutation, SystemUpdateOrganizationNotificationSettingsMutationVariables>;
export const SystemUpdateRiskDocument = gql`
    mutation SystemUpdateRisk($input: UpdateSystemRiskInput) {
  systemUpdateRisk(input: $input) {
    id
    rating
    functionCategory
    title
  }
}
    `;
export type SystemUpdateRiskMutationFn = Apollo.MutationFunction<SystemUpdateRiskMutation, SystemUpdateRiskMutationVariables>;

/**
 * __useSystemUpdateRiskMutation__
 *
 * To run a mutation, you first call `useSystemUpdateRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateRiskMutation, { data, loading, error }] = useSystemUpdateRiskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemUpdateRiskMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateRiskMutation, SystemUpdateRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateRiskMutation, SystemUpdateRiskMutationVariables>(SystemUpdateRiskDocument, options);
      }
export type SystemUpdateRiskMutationHookResult = ReturnType<typeof useSystemUpdateRiskMutation>;
export type SystemUpdateRiskMutationResult = Apollo.MutationResult<SystemUpdateRiskMutation>;
export type SystemUpdateRiskMutationOptions = Apollo.BaseMutationOptions<SystemUpdateRiskMutation, SystemUpdateRiskMutationVariables>;
export const SystemUpdateTaskDocument = gql`
    mutation SystemUpdateTask($task: UpdateSystemTaskInput!) {
  systemUpdateTask(task: $task) {
    id
  }
}
    `;
export type SystemUpdateTaskMutationFn = Apollo.MutationFunction<SystemUpdateTaskMutation, SystemUpdateTaskMutationVariables>;

/**
 * __useSystemUpdateTaskMutation__
 *
 * To run a mutation, you first call `useSystemUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateTaskMutation, { data, loading, error }] = useSystemUpdateTaskMutation({
 *   variables: {
 *      task: // value for 'task'
 *   },
 * });
 */
export function useSystemUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateTaskMutation, SystemUpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateTaskMutation, SystemUpdateTaskMutationVariables>(SystemUpdateTaskDocument, options);
      }
export type SystemUpdateTaskMutationHookResult = ReturnType<typeof useSystemUpdateTaskMutation>;
export type SystemUpdateTaskMutationResult = Apollo.MutationResult<SystemUpdateTaskMutation>;
export type SystemUpdateTaskMutationOptions = Apollo.BaseMutationOptions<SystemUpdateTaskMutation, SystemUpdateTaskMutationVariables>;
export const SystemUpdateUserDocument = gql`
    mutation SystemUpdateUser($input: UpdateSystemUserInput) {
  systemUpdateUser(input: $input) {
    id
    firstName
    lastName
  }
}
    `;
export type SystemUpdateUserMutationFn = Apollo.MutationFunction<SystemUpdateUserMutation, SystemUpdateUserMutationVariables>;

/**
 * __useSystemUpdateUserMutation__
 *
 * To run a mutation, you first call `useSystemUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateUserMutation, { data, loading, error }] = useSystemUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSystemUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateUserMutation, SystemUpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateUserMutation, SystemUpdateUserMutationVariables>(SystemUpdateUserDocument, options);
      }
export type SystemUpdateUserMutationHookResult = ReturnType<typeof useSystemUpdateUserMutation>;
export type SystemUpdateUserMutationResult = Apollo.MutationResult<SystemUpdateUserMutation>;
export type SystemUpdateUserMutationOptions = Apollo.BaseMutationOptions<SystemUpdateUserMutation, SystemUpdateUserMutationVariables>;
export const SystemUpdateUserOrganizationRoleDocument = gql`
    mutation SystemUpdateUserOrganizationRole($userOrganizationId: ID!, $role: UserOrganizationRole!) {
  systemUpdateUserOrganizationRole(
    userOrganizationId: $userOrganizationId
    role: $role
  ) {
    id
  }
}
    `;
export type SystemUpdateUserOrganizationRoleMutationFn = Apollo.MutationFunction<SystemUpdateUserOrganizationRoleMutation, SystemUpdateUserOrganizationRoleMutationVariables>;

/**
 * __useSystemUpdateUserOrganizationRoleMutation__
 *
 * To run a mutation, you first call `useSystemUpdateUserOrganizationRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateUserOrganizationRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateUserOrganizationRoleMutation, { data, loading, error }] = useSystemUpdateUserOrganizationRoleMutation({
 *   variables: {
 *      userOrganizationId: // value for 'userOrganizationId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSystemUpdateUserOrganizationRoleMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateUserOrganizationRoleMutation, SystemUpdateUserOrganizationRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateUserOrganizationRoleMutation, SystemUpdateUserOrganizationRoleMutationVariables>(SystemUpdateUserOrganizationRoleDocument, options);
      }
export type SystemUpdateUserOrganizationRoleMutationHookResult = ReturnType<typeof useSystemUpdateUserOrganizationRoleMutation>;
export type SystemUpdateUserOrganizationRoleMutationResult = Apollo.MutationResult<SystemUpdateUserOrganizationRoleMutation>;
export type SystemUpdateUserOrganizationRoleMutationOptions = Apollo.BaseMutationOptions<SystemUpdateUserOrganizationRoleMutation, SystemUpdateUserOrganizationRoleMutationVariables>;
export const SystemUpdateUserPortalAccessRoleDocument = gql`
    mutation SystemUpdateUserPortalAccessRole($systemUpdateUserPortalAccessRoleId: UserID!, $accessRoles: [CognitoScope]) {
  systemUpdateUserPortalAccessRole(
    id: $systemUpdateUserPortalAccessRoleId
    accessRoles: $accessRoles
  ) {
    id
  }
}
    `;
export type SystemUpdateUserPortalAccessRoleMutationFn = Apollo.MutationFunction<SystemUpdateUserPortalAccessRoleMutation, SystemUpdateUserPortalAccessRoleMutationVariables>;

/**
 * __useSystemUpdateUserPortalAccessRoleMutation__
 *
 * To run a mutation, you first call `useSystemUpdateUserPortalAccessRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateUserPortalAccessRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateUserPortalAccessRoleMutation, { data, loading, error }] = useSystemUpdateUserPortalAccessRoleMutation({
 *   variables: {
 *      systemUpdateUserPortalAccessRoleId: // value for 'systemUpdateUserPortalAccessRoleId'
 *      accessRoles: // value for 'accessRoles'
 *   },
 * });
 */
export function useSystemUpdateUserPortalAccessRoleMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateUserPortalAccessRoleMutation, SystemUpdateUserPortalAccessRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateUserPortalAccessRoleMutation, SystemUpdateUserPortalAccessRoleMutationVariables>(SystemUpdateUserPortalAccessRoleDocument, options);
      }
export type SystemUpdateUserPortalAccessRoleMutationHookResult = ReturnType<typeof useSystemUpdateUserPortalAccessRoleMutation>;
export type SystemUpdateUserPortalAccessRoleMutationResult = Apollo.MutationResult<SystemUpdateUserPortalAccessRoleMutation>;
export type SystemUpdateUserPortalAccessRoleMutationOptions = Apollo.BaseMutationOptions<SystemUpdateUserPortalAccessRoleMutation, SystemUpdateUserPortalAccessRoleMutationVariables>;
export const SystemUserDocument = gql`
    query SystemUser($id: UserID!, $userActionFilters: UserActionSubqueryFilters) {
  systemUser(id: $id) {
    id
    firstName
    lastName
    email
    phone
    createdAt
    updatedAt
    organizations {
      id
    }
    portalAccessRole
    userActions(userActionFilters: $userActionFilters) {
      createdAt
    }
  }
}
    `;

/**
 * __useSystemUserQuery__
 *
 * To run a query within a React component, call `useSystemUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      userActionFilters: // value for 'userActionFilters'
 *   },
 * });
 */
export function useSystemUserQuery(baseOptions: Apollo.QueryHookOptions<SystemUserQuery, SystemUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemUserQuery, SystemUserQueryVariables>(SystemUserDocument, options);
      }
export function useSystemUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemUserQuery, SystemUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemUserQuery, SystemUserQueryVariables>(SystemUserDocument, options);
        }
export type SystemUserQueryHookResult = ReturnType<typeof useSystemUserQuery>;
export type SystemUserLazyQueryHookResult = ReturnType<typeof useSystemUserLazyQuery>;
export type SystemUserQueryResult = Apollo.QueryResult<SystemUserQuery, SystemUserQueryVariables>;
export const SystemUserActionsDocument = gql`
    query SystemUserActions($pageNumber: Int, $pageItemsCount: Int, $filters: UserActionsFilters, $sortField: UserActionSortField, $sortOrder: SortOrder, $includeDeleted: Boolean) {
  systemUserActions(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    filters: $filters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      user {
        id
        email
      }
      actionTag
      contextType
      actionEntity(includeDeleted: $includeDeleted) {
        __typename
        ... on VendorRequest {
          id
          organization(includeDeleted: $includeDeleted) {
            id
            cif
            name
          }
        }
        ... on PolicyDocument {
          id
          organization(includeDeleted: $includeDeleted) {
            id
            cif
            name
          }
        }
        ... on RiskAssessmentDocument {
          id
          organization(includeDeleted: $includeDeleted) {
            id
            cif
            name
          }
        }
        ... on ExecutiveReport {
          id
          organization(includeDeleted: $includeDeleted) {
            id
            cif
            name
          }
        }
        ... on Organization {
          id
          cif
          name
        }
        ... on Task {
          id
          risk(includeDeleted: $includeDeleted) {
            riskAssessmentDocument(includeDeleted: $includeDeleted) {
              organization(includeDeleted: $includeDeleted) {
                id
                cif
                name
              }
            }
          }
        }
        ... on TaskComment {
          id
          task(includeDeleted: $includeDeleted) {
            risk(includeDeleted: $includeDeleted) {
              riskAssessmentDocument(includeDeleted: $includeDeleted) {
                organization(includeDeleted: $includeDeleted) {
                  id
                  cif
                  name
                }
              }
            }
          }
        }
        ... on Risk {
          id
          riskAssessmentDocument(includeDeleted: $includeDeleted) {
            organization(includeDeleted: $includeDeleted) {
              id
              cif
              name
            }
          }
        }
        ... on VendorOrganization {
          id
          organization(includeDeleted: $includeDeleted) {
            id
            cif
            name
          }
        }
        ... on Document {
          id
          organizations(includeDeleted: $includeDeleted) {
            id
            cif
            name
          }
        }
        ... on UserOrganization {
          id
          user(includeDeleted: $includeDeleted) {
            id
          }
          organization(includeDeleted: $includeDeleted) {
            id
            cif
            name
          }
        }
        ... on AcknowledgementItem {
          id
          roadmapStep(includeDeleted: $includeDeleted) {
            organization(includeDeleted: $includeDeleted) {
              id
              cif
              name
            }
          }
        }
      }
      createdAt
    }
    totalCount
  }
}
    `;

/**
 * __useSystemUserActionsQuery__
 *
 * To run a query within a React component, call `useSystemUserActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemUserActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemUserActionsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      filters: // value for 'filters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      includeDeleted: // value for 'includeDeleted'
 *   },
 * });
 */
export function useSystemUserActionsQuery(baseOptions?: Apollo.QueryHookOptions<SystemUserActionsQuery, SystemUserActionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemUserActionsQuery, SystemUserActionsQueryVariables>(SystemUserActionsDocument, options);
      }
export function useSystemUserActionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemUserActionsQuery, SystemUserActionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemUserActionsQuery, SystemUserActionsQueryVariables>(SystemUserActionsDocument, options);
        }
export type SystemUserActionsQueryHookResult = ReturnType<typeof useSystemUserActionsQuery>;
export type SystemUserActionsLazyQueryHookResult = ReturnType<typeof useSystemUserActionsLazyQuery>;
export type SystemUserActionsQueryResult = Apollo.QueryResult<SystemUserActionsQuery, SystemUserActionsQueryVariables>;
export const SystemDealershipUsersDocument = gql`
    query SystemDealershipUsers($pageNumber: Int, $pageItemsCount: Int, $userOrganizationFilters: UserOrganizationFilters, $userFilters: UserFilters, $organizationFilters: OrganizationFilters, $sortField: UserOrganizationSortField, $sortOrder: SortOrder) {
  systemUserOrganizations(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    userOrganizationFilters: $userOrganizationFilters
    userFilters: $userFilters
    organizationFilters: $organizationFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      owner
      user {
        id
        email
        firstName
        lastName
        phone
      }
      organization {
        id
        cif
        name
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemDealershipUsersQuery__
 *
 * To run a query within a React component, call `useSystemDealershipUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemDealershipUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemDealershipUsersQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      userOrganizationFilters: // value for 'userOrganizationFilters'
 *      userFilters: // value for 'userFilters'
 *      organizationFilters: // value for 'organizationFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemDealershipUsersQuery(baseOptions?: Apollo.QueryHookOptions<SystemDealershipUsersQuery, SystemDealershipUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemDealershipUsersQuery, SystemDealershipUsersQueryVariables>(SystemDealershipUsersDocument, options);
      }
export function useSystemDealershipUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemDealershipUsersQuery, SystemDealershipUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemDealershipUsersQuery, SystemDealershipUsersQueryVariables>(SystemDealershipUsersDocument, options);
        }
export type SystemDealershipUsersQueryHookResult = ReturnType<typeof useSystemDealershipUsersQuery>;
export type SystemDealershipUsersLazyQueryHookResult = ReturnType<typeof useSystemDealershipUsersLazyQuery>;
export type SystemDealershipUsersQueryResult = Apollo.QueryResult<SystemDealershipUsersQuery, SystemDealershipUsersQueryVariables>;
export const SystemUsersDocument = gql`
    query SystemUsers($pageNumber: Int, $pageItemsCount: Int, $userFilters: UserFilters, $userOrganizationFilters: UserOrganizationFilters, $sortField: UserSortFieldEnum, $sortOrder: SortOrder, $userActionFilters: UserActionSubqueryFilters) {
  systemUsers(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    userFilters: $userFilters
    userOrganizationFilters: $userOrganizationFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      firstName
      lastName
      email
      phone
      imageUrl
      organizations {
        id
      }
      userActions(userActionFilters: $userActionFilters) {
        createdAt
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemUsersQuery__
 *
 * To run a query within a React component, call `useSystemUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemUsersQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      userFilters: // value for 'userFilters'
 *      userOrganizationFilters: // value for 'userOrganizationFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      userActionFilters: // value for 'userActionFilters'
 *   },
 * });
 */
export function useSystemUsersQuery(baseOptions?: Apollo.QueryHookOptions<SystemUsersQuery, SystemUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemUsersQuery, SystemUsersQueryVariables>(SystemUsersDocument, options);
      }
export function useSystemUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemUsersQuery, SystemUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemUsersQuery, SystemUsersQueryVariables>(SystemUsersDocument, options);
        }
export type SystemUsersQueryHookResult = ReturnType<typeof useSystemUsersQuery>;
export type SystemUsersLazyQueryHookResult = ReturnType<typeof useSystemUsersLazyQuery>;
export type SystemUsersQueryResult = Apollo.QueryResult<SystemUsersQuery, SystemUsersQueryVariables>;
export const SystemVendorOrganizationsDocument = gql`
    query SystemVendorOrganizations($pageNumber: Int, $pageItemsCount: Int, $systemVendorOrganizationFilters: SystemVendorOrganizationFilters, $sortField: VendorOrganizationSortFieldEnum, $sortOrder: SortOrder) {
  systemVendorOrganizations(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    systemVendorOrganizationFilters: $systemVendorOrganizationFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      vendor {
        id
        businessName
      }
      organization {
        id
        cif
        name
      }
      createdAt
      contactEmail
    }
    totalCount
  }
}
    `;

/**
 * __useSystemVendorOrganizationsQuery__
 *
 * To run a query within a React component, call `useSystemVendorOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemVendorOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemVendorOrganizationsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      systemVendorOrganizationFilters: // value for 'systemVendorOrganizationFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemVendorOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<SystemVendorOrganizationsQuery, SystemVendorOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemVendorOrganizationsQuery, SystemVendorOrganizationsQueryVariables>(SystemVendorOrganizationsDocument, options);
      }
export function useSystemVendorOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemVendorOrganizationsQuery, SystemVendorOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemVendorOrganizationsQuery, SystemVendorOrganizationsQueryVariables>(SystemVendorOrganizationsDocument, options);
        }
export type SystemVendorOrganizationsQueryHookResult = ReturnType<typeof useSystemVendorOrganizationsQuery>;
export type SystemVendorOrganizationsLazyQueryHookResult = ReturnType<typeof useSystemVendorOrganizationsLazyQuery>;
export type SystemVendorOrganizationsQueryResult = Apollo.QueryResult<SystemVendorOrganizationsQuery, SystemVendorOrganizationsQueryVariables>;
export const SystemVendorRequestDocument = gql`
    query SystemVendorRequest($systemVendorRequestId: ID!) {
  systemVendorRequest(id: $systemVendorRequestId) {
    id
    vendor {
      businessName
      contactEmail
    }
    organization {
      cif
      name
    }
    vendorOrganization {
      contactEmail
    }
    vendorRisk {
      completedAt
      data {
        sections {
          title
          questions {
            description
            code
            options {
              code
              title
            }
            answer {
              code
              otherText
            }
          }
        }
        stepState {
          vendorAgreementAnswers {
            maintainsSafeguardsForCustInfo
            hasNecessaryPrivacyDisclosure
            responsesCompleteAndTruthful
            isPersonAuthorizedToAnswer
          }
        }
      }
      document {
        id
        documentUrl
        fileExtension
        uploadedByUser {
          id
        }
      }
    }
    status
    sentAt
    startedAt
    openedAt
    reviewedAt
    linkExpiredAt
    deniedAt
    completedAt
  }
}
    `;

/**
 * __useSystemVendorRequestQuery__
 *
 * To run a query within a React component, call `useSystemVendorRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemVendorRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemVendorRequestQuery({
 *   variables: {
 *      systemVendorRequestId: // value for 'systemVendorRequestId'
 *   },
 * });
 */
export function useSystemVendorRequestQuery(baseOptions: Apollo.QueryHookOptions<SystemVendorRequestQuery, SystemVendorRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemVendorRequestQuery, SystemVendorRequestQueryVariables>(SystemVendorRequestDocument, options);
      }
export function useSystemVendorRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemVendorRequestQuery, SystemVendorRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemVendorRequestQuery, SystemVendorRequestQueryVariables>(SystemVendorRequestDocument, options);
        }
export type SystemVendorRequestQueryHookResult = ReturnType<typeof useSystemVendorRequestQuery>;
export type SystemVendorRequestLazyQueryHookResult = ReturnType<typeof useSystemVendorRequestLazyQuery>;
export type SystemVendorRequestQueryResult = Apollo.QueryResult<SystemVendorRequestQuery, SystemVendorRequestQueryVariables>;
export const SystemVendorRequestsDocument = gql`
    query SystemVendorRequests($pageNumber: Int, $pageItemsCount: Int, $vendorRequestFilters: VendorRequestFilters, $sortField: VendorRequestSortFieldEnum, $sortOrder: SortOrder) {
  systemVendorRequests(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    vendorRequestFilters: $vendorRequestFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      vendor {
        businessName
      }
      organization {
        id
        cif
        name
      }
      status
      sentAt
      completedAt
      deniedAt
      linkExpiredAt
    }
    totalCount
  }
}
    `;

/**
 * __useSystemVendorRequestsQuery__
 *
 * To run a query within a React component, call `useSystemVendorRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemVendorRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemVendorRequestsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      vendorRequestFilters: // value for 'vendorRequestFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemVendorRequestsQuery(baseOptions?: Apollo.QueryHookOptions<SystemVendorRequestsQuery, SystemVendorRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemVendorRequestsQuery, SystemVendorRequestsQueryVariables>(SystemVendorRequestsDocument, options);
      }
export function useSystemVendorRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemVendorRequestsQuery, SystemVendorRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemVendorRequestsQuery, SystemVendorRequestsQueryVariables>(SystemVendorRequestsDocument, options);
        }
export type SystemVendorRequestsQueryHookResult = ReturnType<typeof useSystemVendorRequestsQuery>;
export type SystemVendorRequestsLazyQueryHookResult = ReturnType<typeof useSystemVendorRequestsLazyQuery>;
export type SystemVendorRequestsQueryResult = Apollo.QueryResult<SystemVendorRequestsQuery, SystemVendorRequestsQueryVariables>;
export const SystemVendorRiskDocument = gql`
    query SystemVendorRisk($id: ID!) {
  systemVendorRisk(id: $id) {
    id
    assessmentUrl
    createdAt
    updatedAt
    completedAt
    expiredAt
    archivedAt
    status
    organizations {
      id
    }
    vendor {
      id
      businessName
      businessAddress
      contactEmail
    }
    data {
      sections {
        title
        questions {
          description
          code
          options {
            code
            title
          }
          answer {
            code
            otherText
          }
        }
      }
      stepState {
        vendorAgreementAnswers {
          maintainsSafeguardsForCustInfo
          hasNecessaryPrivacyDisclosure
          responsesCompleteAndTruthful
          isPersonAuthorizedToAnswer
        }
      }
    }
    document {
      id
      documentUrl
      fileExtension
      uploadedByUser {
        id
      }
    }
    isGlobal
  }
}
    `;

/**
 * __useSystemVendorRiskQuery__
 *
 * To run a query within a React component, call `useSystemVendorRiskQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemVendorRiskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemVendorRiskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemVendorRiskQuery(baseOptions: Apollo.QueryHookOptions<SystemVendorRiskQuery, SystemVendorRiskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemVendorRiskQuery, SystemVendorRiskQueryVariables>(SystemVendorRiskDocument, options);
      }
export function useSystemVendorRiskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemVendorRiskQuery, SystemVendorRiskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemVendorRiskQuery, SystemVendorRiskQueryVariables>(SystemVendorRiskDocument, options);
        }
export type SystemVendorRiskQueryHookResult = ReturnType<typeof useSystemVendorRiskQuery>;
export type SystemVendorRiskLazyQueryHookResult = ReturnType<typeof useSystemVendorRiskLazyQuery>;
export type SystemVendorRiskQueryResult = Apollo.QueryResult<SystemVendorRiskQuery, SystemVendorRiskQueryVariables>;
export const SystemVendorRisksDocument = gql`
    query SystemVendorRisks($pageNumber: Int, $pageItemsCount: Int, $vendorRiskFilters: VendorRiskFilters, $sortField: VendorRiskFieldSortEnum, $sortOrder: SortOrder, $vendorFilters: VendorFilters) {
  systemVendorRisks(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    vendorRiskFilters: $vendorRiskFilters
    sortField: $sortField
    sortOrder: $sortOrder
    vendorFilters: $vendorFilters
  ) {
    nodes {
      id
      assessmentUrl
      createdAt
      updatedAt
      completedAt
      expiredAt
      archivedAt
      status
      isGlobal
      organizations {
        id
        cif
        name
      }
      vendor {
        id
        businessName
        businessAddress
        contactEmail
      }
      document {
        id
        documentUrl
        expiresAt
        uploadedByUser {
          id
          firstName
          lastName
          email
        }
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSystemVendorRisksQuery__
 *
 * To run a query within a React component, call `useSystemVendorRisksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemVendorRisksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemVendorRisksQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      vendorRiskFilters: // value for 'vendorRiskFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *      vendorFilters: // value for 'vendorFilters'
 *   },
 * });
 */
export function useSystemVendorRisksQuery(baseOptions?: Apollo.QueryHookOptions<SystemVendorRisksQuery, SystemVendorRisksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemVendorRisksQuery, SystemVendorRisksQueryVariables>(SystemVendorRisksDocument, options);
      }
export function useSystemVendorRisksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemVendorRisksQuery, SystemVendorRisksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemVendorRisksQuery, SystemVendorRisksQueryVariables>(SystemVendorRisksDocument, options);
        }
export type SystemVendorRisksQueryHookResult = ReturnType<typeof useSystemVendorRisksQuery>;
export type SystemVendorRisksLazyQueryHookResult = ReturnType<typeof useSystemVendorRisksLazyQuery>;
export type SystemVendorRisksQueryResult = Apollo.QueryResult<SystemVendorRisksQuery, SystemVendorRisksQueryVariables>;
export const SystemVendorsDocument = gql`
    query SystemVendors($pageNumber: Int, $pageItemsCount: Int, $vendorFilters: VendorFilters, $sortField: VendorSortFieldEnum, $sortOrder: SortOrder) {
  systemVendors(
    pageNumber: $pageNumber
    pageItemsCount: $pageItemsCount
    vendorFilters: $vendorFilters
    sortField: $sortField
    sortOrder: $sortOrder
  ) {
    nodes {
      id
      businessName
      businessAddress
      contactEmail
      createdAt
      deletedAt
    }
    totalCount
  }
}
    `;

/**
 * __useSystemVendorsQuery__
 *
 * To run a query within a React component, call `useSystemVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemVendorsQuery({
 *   variables: {
 *      pageNumber: // value for 'pageNumber'
 *      pageItemsCount: // value for 'pageItemsCount'
 *      vendorFilters: // value for 'vendorFilters'
 *      sortField: // value for 'sortField'
 *      sortOrder: // value for 'sortOrder'
 *   },
 * });
 */
export function useSystemVendorsQuery(baseOptions?: Apollo.QueryHookOptions<SystemVendorsQuery, SystemVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemVendorsQuery, SystemVendorsQueryVariables>(SystemVendorsDocument, options);
      }
export function useSystemVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemVendorsQuery, SystemVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemVendorsQuery, SystemVendorsQueryVariables>(SystemVendorsDocument, options);
        }
export type SystemVendorsQueryHookResult = ReturnType<typeof useSystemVendorsQuery>;
export type SystemVendorsLazyQueryHookResult = ReturnType<typeof useSystemVendorsLazyQuery>;
export type SystemVendorsQueryResult = Apollo.QueryResult<SystemVendorsQuery, SystemVendorsQueryVariables>;
export const SystemVendorDocument = gql`
    query SystemVendor($id: ID!) {
  systemVendor(id: $id) {
    id
    businessName
    businessAddress
    contactEmail
    createdAt
    updatedAt
    deletedAt
  }
}
    `;

/**
 * __useSystemVendorQuery__
 *
 * To run a query within a React component, call `useSystemVendorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSystemVendorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSystemVendorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSystemVendorQuery(baseOptions: Apollo.QueryHookOptions<SystemVendorQuery, SystemVendorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SystemVendorQuery, SystemVendorQueryVariables>(SystemVendorDocument, options);
      }
export function useSystemVendorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SystemVendorQuery, SystemVendorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SystemVendorQuery, SystemVendorQueryVariables>(SystemVendorDocument, options);
        }
export type SystemVendorQueryHookResult = ReturnType<typeof useSystemVendorQuery>;
export type SystemVendorLazyQueryHookResult = ReturnType<typeof useSystemVendorLazyQuery>;
export type SystemVendorQueryResult = Apollo.QueryResult<SystemVendorQuery, SystemVendorQueryVariables>;
export const SystemCreateVendorDocument = gql`
    mutation SystemCreateVendor($vendorParams: SystemCreateVendorInput) {
  systemCreateVendor(vendorParams: $vendorParams) {
    id
  }
}
    `;
export type SystemCreateVendorMutationFn = Apollo.MutationFunction<SystemCreateVendorMutation, SystemCreateVendorMutationVariables>;

/**
 * __useSystemCreateVendorMutation__
 *
 * To run a mutation, you first call `useSystemCreateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemCreateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemCreateVendorMutation, { data, loading, error }] = useSystemCreateVendorMutation({
 *   variables: {
 *      vendorParams: // value for 'vendorParams'
 *   },
 * });
 */
export function useSystemCreateVendorMutation(baseOptions?: Apollo.MutationHookOptions<SystemCreateVendorMutation, SystemCreateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemCreateVendorMutation, SystemCreateVendorMutationVariables>(SystemCreateVendorDocument, options);
      }
export type SystemCreateVendorMutationHookResult = ReturnType<typeof useSystemCreateVendorMutation>;
export type SystemCreateVendorMutationResult = Apollo.MutationResult<SystemCreateVendorMutation>;
export type SystemCreateVendorMutationOptions = Apollo.BaseMutationOptions<SystemCreateVendorMutation, SystemCreateVendorMutationVariables>;
export const SystemUpdateVendorDocument = gql`
    mutation SystemUpdateVendor($id: ID!, $businessName: String!, $businessAddress: String, $contactEmail: String) {
  systemUpdateVendorName(vendorId: $id, businessName: $businessName) {
    id
    businessName
  }
  systemUpdateVendorAddress(vendorId: $id, businessAddress: $businessAddress) {
    id
    businessAddress
  }
  systemUpdateVendorDefaultContact(vendorId: $id, contactEmail: $contactEmail) {
    id
    contactEmail
  }
}
    `;
export type SystemUpdateVendorMutationFn = Apollo.MutationFunction<SystemUpdateVendorMutation, SystemUpdateVendorMutationVariables>;

/**
 * __useSystemUpdateVendorMutation__
 *
 * To run a mutation, you first call `useSystemUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSystemUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [systemUpdateVendorMutation, { data, loading, error }] = useSystemUpdateVendorMutation({
 *   variables: {
 *      id: // value for 'id'
 *      businessName: // value for 'businessName'
 *      businessAddress: // value for 'businessAddress'
 *      contactEmail: // value for 'contactEmail'
 *   },
 * });
 */
export function useSystemUpdateVendorMutation(baseOptions?: Apollo.MutationHookOptions<SystemUpdateVendorMutation, SystemUpdateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SystemUpdateVendorMutation, SystemUpdateVendorMutationVariables>(SystemUpdateVendorDocument, options);
      }
export type SystemUpdateVendorMutationHookResult = ReturnType<typeof useSystemUpdateVendorMutation>;
export type SystemUpdateVendorMutationResult = Apollo.MutationResult<SystemUpdateVendorMutation>;
export type SystemUpdateVendorMutationOptions = Apollo.BaseMutationOptions<SystemUpdateVendorMutation, SystemUpdateVendorMutationVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    email
    phone
    imageUrl
    disableOrgs
    organizations {
      id
      name
      legalName
      addressLine1
      addressLine2
      state
      zip
      country
      paidSubscription
      city
      imageUrl
      phone
      createdAt
      updatedAt
      userRoles {
        id
        owner
        createdAt
        updatedAt
      }
      owned
    }
    shadowEntity {
      id
      shadowType
      shadowEntity {
        __typename
        ... on User {
          firstName
          lastName
        }
        ... on Organization {
          name
        }
      }
      createdAt
      updatedAt
      user {
        id
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;